import * as e from "zod";
//#region src/generated/core/bodySerializer.gen.ts
var t = { bodySerializer: (e) => JSON.stringify(e, (e, t) => typeof t == "bigint" ? t.toString() : t) };
Object.entries({
	$body_: "body",
	$headers_: "headers",
	$path_: "path",
	$query_: "query"
});
//#endregion
//#region src/generated/core/serverSentEvents.gen.ts
var n = ({ onRequest: e, onSseError: t, onSseEvent: n, responseTransformer: r, responseValidator: i, sseDefaultRetryDelay: a, sseMaxRetryAttempts: o, sseMaxRetryDelay: s, sseSleepFn: c, url: l, ...u }) => {
	let ee, te = c ?? ((e) => new Promise((t) => setTimeout(t, e)));
	return { stream: async function* () {
		let c = a ?? 3e3, d = 0, f = u.signal ?? new AbortController().signal;
		for (; !f.aborted;) {
			d++;
			let a = u.headers instanceof Headers ? u.headers : new Headers(u.headers);
			ee !== void 0 && a.set("Last-Event-ID", ee);
			try {
				let t = {
					redirect: "follow",
					...u,
					body: u.serializedBody,
					headers: a,
					signal: f
				}, o = new Request(l, t);
				e && (o = await e(l, t));
				let s = await (u.fetch ?? globalThis.fetch)(o);
				if (!s.ok) throw Error(`SSE failed: ${s.status} ${s.statusText}`);
				if (!s.body) throw Error("No body in SSE response");
				let te = s.body.pipeThrough(new TextDecoderStream()).getReader(), d = "", ne = () => {
					try {
						te.cancel();
					} catch {}
				};
				f.addEventListener("abort", ne);
				try {
					for (;;) {
						let { done: e, value: t } = await te.read();
						if (e) break;
						d += t, d = d.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
						let a = d.split("\n\n");
						d = a.pop() ?? "";
						for (let e of a) {
							let t = e.split("\n"), a = [], o;
							for (let e of t) if (e.startsWith("data:")) a.push(e.replace(/^data:\s*/, ""));
							else if (e.startsWith("event:")) o = e.replace(/^event:\s*/, "");
							else if (e.startsWith("id:")) ee = e.replace(/^id:\s*/, "");
							else if (e.startsWith("retry:")) {
								let t = Number.parseInt(e.replace(/^retry:\s*/, ""), 10);
								Number.isNaN(t) || (c = t);
							}
							let s, l = !1;
							if (a.length) {
								let e = a.join("\n");
								try {
									s = JSON.parse(e), l = !0;
								} catch {
									s = e;
								}
							}
							l && (i && await i(s), r && (s = await r(s))), n?.({
								data: s,
								event: o,
								id: ee,
								retry: c
							}), a.length && (yield s);
						}
					}
				} finally {
					f.removeEventListener("abort", ne), te.releaseLock();
				}
				break;
			} catch (e) {
				if (t?.(e), o !== void 0 && d >= o) break;
				let n = Math.min(c * 2 ** (d - 1), s ?? 3e4);
				await te(n);
			}
		}
	}() };
}, r = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, i = (e) => {
	switch (e) {
		case "form": return ",";
		case "pipeDelimited": return "|";
		case "spaceDelimited": return "%20";
		default: return ",";
	}
}, a = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, o = ({ allowReserved: e, explode: t, name: n, style: a, value: o }) => {
	if (!t) {
		let t = (e ? o : o.map((e) => encodeURIComponent(e))).join(i(a));
		switch (a) {
			case "label": return `.${t}`;
			case "matrix": return `;${n}=${t}`;
			case "simple": return t;
			default: return `${n}=${t}`;
		}
	}
	let c = r(a), l = o.map((t) => a === "label" || a === "simple" ? e ? t : encodeURIComponent(t) : s({
		allowReserved: e,
		name: n,
		value: t
	})).join(c);
	return a === "label" || a === "matrix" ? c + l : l;
}, s = ({ allowReserved: e, name: t, value: n }) => {
	if (n == null) return "";
	if (typeof n == "object") throw Error("Deeply-nested arrays/objects aren’t supported. Provide your own `querySerializer()` to handle these.");
	return `${t}=${e ? n : encodeURIComponent(n)}`;
}, c = ({ allowReserved: e, explode: t, name: n, style: r, value: i, valueOnly: o }) => {
	if (i instanceof Date) return o ? i.toISOString() : `${n}=${i.toISOString()}`;
	if (r !== "deepObject" && !t) {
		let t = [];
		Object.entries(i).forEach(([n, r]) => {
			t = [
				...t,
				n,
				e ? r : encodeURIComponent(r)
			];
		});
		let a = t.join(",");
		switch (r) {
			case "form": return `${n}=${a}`;
			case "label": return `.${a}`;
			case "matrix": return `;${n}=${a}`;
			default: return a;
		}
	}
	let c = a(r), l = Object.entries(i).map(([t, i]) => s({
		allowReserved: e,
		name: r === "deepObject" ? `${n}[${t}]` : t,
		value: i
	})).join(c);
	return r === "label" || r === "matrix" ? c + l : l;
}, l = /\{[^{}]+\}/g, u = ({ path: e, url: t }) => {
	let n = t, r = t.match(l);
	if (r) for (let t of r) {
		let r = !1, i = t.substring(1, t.length - 1), a = "simple";
		i.endsWith("*") && (r = !0, i = i.substring(0, i.length - 1)), i.startsWith(".") ? (i = i.substring(1), a = "label") : i.startsWith(";") && (i = i.substring(1), a = "matrix");
		let l = e[i];
		if (l == null) continue;
		if (Array.isArray(l)) {
			n = n.replace(t, o({
				explode: r,
				name: i,
				style: a,
				value: l
			}));
			continue;
		}
		if (typeof l == "object") {
			n = n.replace(t, c({
				explode: r,
				name: i,
				style: a,
				value: l,
				valueOnly: !0
			}));
			continue;
		}
		if (a === "matrix") {
			n = n.replace(t, `;${s({
				name: i,
				value: l
			})}`);
			continue;
		}
		let u = encodeURIComponent(a === "label" ? `.${l}` : l);
		n = n.replace(t, u);
	}
	return n;
}, ee = ({ baseUrl: e, path: t, query: n, querySerializer: r, url: i }) => {
	let a = i.startsWith("/") ? i : `/${i}`, o = (e ?? "") + a;
	t && (o = u({
		path: t,
		url: o
	}));
	let s = n ? r(n) : "";
	return s.startsWith("?") && (s = s.substring(1)), s && (o += `?${s}`), o;
};
function te(e) {
	let t = e.body !== void 0;
	if (t && e.bodySerializer) return "serializedBody" in e ? e.serializedBody !== void 0 && e.serializedBody !== "" ? e.serializedBody : null : e.body === "" ? null : e.body;
	if (t) return e.body;
}
//#endregion
//#region src/generated/core/auth.gen.ts
var d = async (e, t) => {
	let n = typeof t == "function" ? await t(e) : t;
	if (n) return e.scheme === "bearer" ? `Bearer ${n}` : e.scheme === "basic" ? `Basic ${btoa(n)}` : n;
}, f = ({ parameters: e = {}, ...t } = {}) => (n) => {
	let r = [];
	if (n && typeof n == "object") for (let i in n) {
		let a = n[i];
		if (a == null) continue;
		let l = e[i] || t;
		if (Array.isArray(a)) {
			let e = o({
				allowReserved: l.allowReserved,
				explode: !0,
				name: i,
				style: "form",
				value: a,
				...l.array
			});
			e && r.push(e);
		} else if (typeof a == "object") {
			let e = c({
				allowReserved: l.allowReserved,
				explode: !0,
				name: i,
				style: "deepObject",
				value: a,
				...l.object
			});
			e && r.push(e);
		} else {
			let e = s({
				allowReserved: l.allowReserved,
				name: i,
				value: a
			});
			e && r.push(e);
		}
	}
	return r.join("&");
}, ne = (e) => {
	if (!e) return "stream";
	let t = e.split(";")[0]?.trim();
	if (t) {
		if (t.startsWith("application/json") || t.endsWith("+json")) return "json";
		if (t === "multipart/form-data") return "formData";
		if ([
			"application/",
			"audio/",
			"image/",
			"video/"
		].some((e) => t.startsWith(e))) return "blob";
		if (t.startsWith("text/")) return "text";
	}
}, re = (e, t) => t ? !!(e.headers.has(t) || e.query?.[t] || e.headers.get("Cookie")?.includes(`${t}=`)) : !1, ie = async ({ security: e, ...t }) => {
	for (let n of e) {
		if (re(t, n.name)) continue;
		let e = await d(n, t.auth);
		if (!e) continue;
		let r = n.name ?? "Authorization";
		switch (n.in) {
			case "query":
				t.query ||= {}, t.query[r] = e;
				break;
			case "cookie":
				t.headers.append("Cookie", `${r}=${e}`);
				break;
			default: t.headers.set(r, e);
		}
	}
}, ae = (e) => ee({
	baseUrl: e.baseUrl,
	path: e.path,
	query: e.query,
	querySerializer: typeof e.querySerializer == "function" ? e.querySerializer : f(e.querySerializer),
	url: e.url
}), oe = (e, t) => {
	let n = {
		...e,
		...t
	};
	return n.baseUrl?.endsWith("/") && (n.baseUrl = n.baseUrl.substring(0, n.baseUrl.length - 1)), n.headers = ce(e.headers, t.headers), n;
}, se = (e) => {
	let t = [];
	return e.forEach((e, n) => {
		t.push([n, e]);
	}), t;
}, ce = (...e) => {
	let t = new Headers();
	for (let n of e) {
		if (!n) continue;
		let e = n instanceof Headers ? se(n) : Object.entries(n);
		for (let [n, r] of e) if (r === null) t.delete(n);
		else if (Array.isArray(r)) for (let e of r) t.append(n, e);
		else r !== void 0 && t.set(n, typeof r == "object" ? JSON.stringify(r) : r);
	}
	return t;
}, le = class {
	fns = [];
	clear() {
		this.fns = [];
	}
	eject(e) {
		let t = this.getInterceptorIndex(e);
		this.fns[t] && (this.fns[t] = null);
	}
	exists(e) {
		let t = this.getInterceptorIndex(e);
		return !!this.fns[t];
	}
	getInterceptorIndex(e) {
		return typeof e == "number" ? this.fns[e] ? e : -1 : this.fns.indexOf(e);
	}
	update(e, t) {
		let n = this.getInterceptorIndex(e);
		return this.fns[n] ? (this.fns[n] = t, e) : !1;
	}
	use(e) {
		return this.fns.push(e), this.fns.length - 1;
	}
}, ue = () => ({
	error: new le(),
	request: new le(),
	response: new le()
}), de = f({
	allowReserved: !1,
	array: {
		explode: !0,
		style: "form"
	},
	object: {
		explode: !0,
		style: "deepObject"
	}
}), fe = { "Content-Type": "application/json" }, pe = (e = {}) => ({
	...t,
	headers: fe,
	parseAs: "auto",
	querySerializer: de,
	...e
}), p = ((e = {}) => {
	let t = oe(pe(), e), r = () => ({ ...t }), i = (e) => (t = oe(t, e), r()), a = ue(), o = async (e) => {
		let n = {
			...t,
			...e,
			fetch: e.fetch ?? t.fetch ?? globalThis.fetch,
			headers: ce(t.headers, e.headers),
			serializedBody: void 0
		};
		return n.security && await ie({
			...n,
			security: n.security
		}), n.requestValidator && await n.requestValidator(n), n.body !== void 0 && n.bodySerializer && (n.serializedBody = n.bodySerializer(n.body)), (n.body === void 0 || n.serializedBody === "") && n.headers.delete("Content-Type"), {
			opts: n,
			url: ae(n)
		};
	}, s = async (e) => {
		let { opts: t, url: n } = await o(e), r = {
			redirect: "follow",
			...t,
			body: te(t)
		}, i = new Request(n, r);
		for (let e of a.request.fns) e && (i = await e(i, t));
		let s = t.fetch, c;
		try {
			c = await s(i);
		} catch (e) {
			let n = e;
			for (let r of a.error.fns) r && (n = await r(e, void 0, i, t));
			if (n ||= {}, t.throwOnError) throw n;
			return t.responseStyle === "data" ? void 0 : {
				error: n,
				request: i,
				response: void 0
			};
		}
		for (let e of a.response.fns) e && (c = await e(c, i, t));
		let l = {
			request: i,
			response: c
		};
		if (c.ok) {
			let e = (t.parseAs === "auto" ? ne(c.headers.get("Content-Type")) : t.parseAs) ?? "json";
			if (c.status === 204 || c.headers.get("Content-Length") === "0") {
				let n;
				switch (e) {
					case "arrayBuffer":
					case "blob":
					case "text":
						n = await c[e]();
						break;
					case "formData":
						n = new FormData();
						break;
					case "stream":
						n = c.body;
						break;
					default: n = {};
				}
				return t.responseStyle === "data" ? n : {
					data: n,
					...l
				};
			}
			let n;
			switch (e) {
				case "arrayBuffer":
				case "blob":
				case "formData":
				case "text":
					n = await c[e]();
					break;
				case "json": {
					let e = await c.text();
					n = e ? JSON.parse(e) : {};
					break;
				}
				case "stream": return t.responseStyle === "data" ? c.body : {
					data: c.body,
					...l
				};
			}
			return e === "json" && (t.responseValidator && await t.responseValidator(n), t.responseTransformer && (n = await t.responseTransformer(n))), t.responseStyle === "data" ? n : {
				data: n,
				...l
			};
		}
		let u = await c.text(), ee;
		try {
			ee = JSON.parse(u);
		} catch {}
		let d = ee ?? u, f = d;
		for (let e of a.error.fns) e && (f = await e(d, c, i, t));
		if (f ||= {}, t.throwOnError) throw f;
		return t.responseStyle === "data" ? void 0 : {
			error: f,
			...l
		};
	}, c = (e) => (t) => s({
		...t,
		method: e
	}), l = (e) => async (t) => {
		let { opts: r, url: i } = await o(t);
		return n({
			...r,
			body: r.body,
			headers: r.headers,
			method: e,
			onRequest: async (e, t) => {
				let n = new Request(e, t);
				for (let e of a.request.fns) e && (n = await e(n, r));
				return n;
			},
			serializedBody: te(r),
			url: i
		});
	};
	return {
		buildUrl: (e) => ae({
			...t,
			...e
		}),
		connect: c("CONNECT"),
		delete: c("DELETE"),
		get: c("GET"),
		getConfig: r,
		head: c("HEAD"),
		interceptors: a,
		options: c("OPTIONS"),
		patch: c("PATCH"),
		post: c("POST"),
		put: c("PUT"),
		request: s,
		setConfig: i,
		sse: {
			connect: l("CONNECT"),
			delete: l("DELETE"),
			get: l("GET"),
			head: l("HEAD"),
			options: l("OPTIONS"),
			patch: l("PATCH"),
			post: l("POST"),
			put: l("PUT"),
			trace: l("TRACE")
		},
		trace: c("TRACE")
	};
})(pe({
	baseUrl: "https://api.myparcel.nl/",
	throwOnError: !0
})), me = e.int().gte(400).lte(499).register(e.globalRegistry, { description: "The request contains bad syntax or cannot be fulfilled" }), he = e.union([
	e.literal(3e3),
	e.literal(3001),
	e.literal(3002),
	e.literal(3003),
	e.literal(3004),
	e.literal(3005),
	e.literal(3006),
	e.literal(3007)
]).register(e.globalRegistry, { description: "Authentication and Authorization related error codes" }), ge = e.union([he, e.int()]), _e = e.object({
	status: me.optional(),
	code: ge.optional(),
	title: e.string().optional(),
	message: e.string().optional()
}), ve = e.object({
	message: e.string(),
	request_id: e.string().register(e.globalRegistry, { description: "Internal request ID, useful for debugging purposes." }),
	status_code: me,
	errors: e.union([e.array(_e), e.record(e.string(), _e)])
}), ye = e.literal(404).register(e.globalRegistry, { description: "Did not find the requested target resource." }), be = ve.and(e.object({
	status_code: ye.optional(),
	errors: e.array(e.object({
		status: ye.optional(),
		code: e.int().optional()
	})).optional()
})), m = e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).register(e.globalRegistry, { description: "Unique ID of a Shipment." }), xe = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), Se = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), Ce = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7),
	e.literal(8)
]), we = e.string().length(2).regex(/^[A-Za-z]{2}$/), Te = e.union([e.enum([""]), e.unknown()]).nullable(), Ee = e.union([e.unknown(), e.enum([""])]).nullable(), De = e.object({
	account_id: xe.optional(),
	person: e.string().optional(),
	first_name: e.string().optional(),
	last_name: e.string().optional(),
	company: e.string().nullish(),
	street: e.string().optional(),
	street_additional_info: e.string().nullish(),
	number: e.string().nullish(),
	number_suffix: e.string().nullish(),
	postal_code: e.string().optional(),
	city: e.string().optional(),
	state: e.string().optional(),
	cc: we,
	region: e.string().max(35).nullish(),
	area: e.string().optional(),
	phone: e.string().nullish(),
	email: e.union([e.unknown(), e.enum([""])]).nullish(),
	billing_email: Te.optional(),
	secondary_emails: e.array(Ee).nullish(),
	box_number: e.string().max(8).nullish(),
	eori_number: e.string().optional(),
	vat_number: e.string().optional(),
	invalid: e.boolean().optional()
}), Oe = De.and(e.object({
	person: e.unknown().optional(),
	first_name: e.string().max(50).optional(),
	last_name: e.string().max(50).optional(),
	company: e.unknown().optional(),
	street: e.unknown().optional(),
	street_additional_info: e.unknown().optional(),
	number: e.unknown().optional(),
	number_suffix: e.unknown().optional(),
	postal_code: e.unknown().optional(),
	city: e.unknown().optional(),
	state: e.unknown().optional(),
	area: e.unknown().optional(),
	phone: e.unknown().optional()
})), h = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7),
	e.literal(8),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(12),
	e.literal(13),
	e.literal(14),
	e.literal(15),
	e.literal(16),
	e.literal(17),
	e.literal(18),
	e.literal(19),
	e.literal(98),
	e.literal(99),
	e.literal(100),
	e.literal(101),
	e.literal(30),
	e.literal(31),
	e.literal(32),
	e.literal(33),
	e.literal(34),
	e.literal(35),
	e.literal(36),
	e.literal(37),
	e.literal(38)
]), ke = e.object({
	currency: e.enum(["EUR"]),
	amount: e.int().gte(0)
}), Ae = e.object({ insurance: ke.optional() }), je = Ae.and(e.object({ insurance: e.object({ amount: e.unknown().optional() }).optional() })), g = e.union([e.literal(0), e.literal(1)]), _ = e.object({
	currency: e.enum(["", "EUR"]).register(e.globalRegistry, { description: "The currency as uppercase 3-letter ISO 4217 code." }),
	amount: e.union([e.int().gte(0), e.string().regex(/\d*/)])
}).register(e.globalRegistry, { description: "Money amount with currency" }), Me = e.object({
	age_check: g.optional(),
	cash_on_delivery: _.optional(),
	collect: g.optional(),
	cooled_delivery: g.optional(),
	drop_off_at_postal_point: g.optional(),
	extra_assurance: g.optional(),
	fresh_food: g.optional(),
	frozen: g.optional(),
	hide_sender: g.optional(),
	large_format: g.optional(),
	no_tracking: g.optional(),
	only_recipient: g.optional(),
	priority_delivery: g.optional(),
	receipt_code: g.optional(),
	return: g.optional(),
	same_day_delivery: g.optional(),
	saturday_delivery: g.optional(),
	signature: g.optional(),
	tracked: g.optional()
}), v = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7)
]).register(e.globalRegistry, { description: "Package Type." }), Ne = e.object({ package_type: v.optional() }), Pe = e.object({ delivery_type: e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7),
	e.literal(8)
]).nullish() }), Fe = e.object({ delivery_date: e.string().regex(/([0-9]{4})-([0-9]{2})-([0-9]{2}) ([0-9]{2}):([0-9]{2}):([0-9]{2})/).nullish() }), Ie = e.object({ label_description: e.string().max(45).nullish() }), y = je.and(Me).and(Ne).and(Pe).and(Fe).and(Ie), Le = e.object({
	save_recipient_address: g.optional(),
	delivery_notification: g.optional(),
	delivery_notification_email: e.array(e.email()).optional(),
	disable_auto_detect_pickup: g.optional(),
	printer_identifier: e.string().optional(),
	tracktrace: e.object({
		bcc: g.optional(),
		bcc_email: Te.optional(),
		carrier_email_basic_notification: g.optional(),
		delivery_notification: g.optional(),
		delivery_notification_email: e.array(e.string()).optional(),
		disable_auto_detect_pickup: g.optional(),
		email_on_handed_to_courier: g.optional(),
		from_address_company: e.string().optional(),
		from_address_email: e.union([e.unknown(), e.enum([""])]).optional(),
		printer_identifier: e.string().optional(),
		save_recipient_address: g.optional(),
		send_track_trace_emails: g.optional()
	}).optional()
}).nullable(), Re = e.enum([
	"retail",
	"locker",
	"post_office"
]).register(e.globalRegistry, { description: "Pickup / drop-off location type." }), ze = e.union([
	e.literal(0),
	e.literal(1),
	e.literal(2),
	e.literal(4),
	e.literal(8),
	e.literal(16)
]), Be = e.object({
	location_code: e.string().optional(),
	location_name: e.string().optional(),
	street: e.string().optional(),
	number: e.string().optional(),
	number_suffix: e.string().nullish(),
	postal_code: e.string().optional(),
	city: e.string().optional(),
	cc: e.string().length(2).regex(/^[A-Z]{2}/).optional(),
	location_type: e.union([Re, ze]).optional(),
	retail_network_id: e.string().optional()
}).nullable(), Ve = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5)
]), He = e.object({
	description: e.string().max(50),
	amount: e.int().gte(1).lte(99999),
	weight: e.int().gte(0).lte(999999999),
	item_value: _,
	classification: e.string(),
	country: e.union([e.unknown(), e.enum([""])]).optional()
}), b = e.object({
	contents: Ve,
	invoice: e.string().max(150).nullish(),
	eori_number: e.string().nullish(),
	vat_number: e.string().nullish(),
	vat_number_uk: e.string().nullish(),
	voec_number: e.string().nullish(),
	weight: e.int().gte(0).lte(999999999),
	items: e.array(He).min(1).max(100)
}), Ue = e.int().gte(0).lte(999999999), We = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), Ge = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), Ke = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), qe = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), Je = Ue, Ye = We.nullable(), Xe = Ge.nullable(), Ze = Ke.nullable(), Qe = qe.nullable(), $e = e.object({
	weight: Ue.optional(),
	height: We.nullish(),
	width: Ge.nullish(),
	length: Ke.nullish(),
	volume: qe.nullish(),
	carrier_weight: e.union([Je, e.string().regex(/^\d+$/)]).nullish(),
	carrier_height: Ye.nullish(),
	carrier_width: Xe.nullish(),
	carrier_length: Ze.nullish(),
	carrier_volume: Qe.nullish()
}).nullable(), et = e.union([e.int(), e.string().max(255).regex(/^[^=\?]*$/)]).nullable(), tt = e.enum([
	"pending",
	"unpaid",
	"paid"
]).nullable(), nt = Be, rt = e.enum(["", "EUR"]).register(e.globalRegistry, { description: "The currency as uppercase 3-letter ISO 4217 code." }), it = e.union([e.int().gte(0), e.string().regex(/\d*/)]), x = e.object({
	currency: rt,
	amount: it.nullable()
}).register(e.globalRegistry, { description: "Money amount with currency, where the amount may be null. The amount is null when the requester lacks permission to read price amounts (Permissions::BILLING_READ_PRICE_AMOUNTS)." }), at = e.enum([
	"Facebook",
	"Flespakket.nl",
	"Amazon",
	"Bol.com",
	"MyParcel.nl",
	"Wix",
	"Ecwid",
	"Exact Online DE",
	"Exact Online NL",
	"Etsy"
]), ot = e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }), st = e.enum([
	"pending",
	"unpaid",
	"paid"
]).nullable(), S = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7),
	e.literal(8),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(12),
	e.literal(13),
	e.literal(14),
	e.literal(15),
	e.literal(16),
	e.literal(17),
	e.literal(18),
	e.literal(19),
	e.literal(20),
	e.literal(21)
]).register(e.globalRegistry, { description: "This enumeration represents the Carriers. The value is the Carrier id." }), ct = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6)
]), lt = ct, ut = e.string().max(255), dt = e.string().max(255).nullable(), ft = m.nullable(), pt = xe, mt = Se, ht = Ce, gt = Oe, _t = De, vt = h, yt = y.and(e.unknown()), bt = Le, xt = Be, St = b.nullable(), Ct = $e, wt = et, Tt = tt, Et = nt, Dt = g, Ot = x, kt = e.string().max(255), At = e.union([e.unknown(), e.enum(["Wereld"])]), jt = at.nullable(), Mt = ot.nullable(), Nt = st, Pt = S, Ft = lt, It = ut.nullable(), Lt = dt, Rt = e.string().max(255), zt = e.string().max(255), Bt = e.union([e.string().regex(/\d+/), e.int()]), Vt = e.string().max(255), Ht = e.string().max(255), Ut = e.string().max(255), Wt = e.string().regex(/^[A-Z][A-Z]$/), Gt = e.string().max(255), Kt = e.string().max(8).nullable(), qt = e.object({
	id: e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).optional(),
	gender: e.string().max(3).nullish(),
	first_name: e.string().max(255).nullish(),
	last_name: e.string().max(255).nullable(),
	email: e.union([e.enum([""]), e.unknown()]).nullable(),
	phone: e.string().max(100).nullable(),
	company: e.string().max(255).nullable(),
	street: Rt,
	street_additional_info: zt.optional(),
	number: Bt,
	number_suffix: Vt.optional(),
	postal_code: Ht,
	city: Ut,
	cc: Wt,
	region: Gt.optional(),
	box_number: Kt.optional()
}), Jt = qt.nullable(), Yt = m.nullable(), Xt = e.string().max(255).nullable(), Zt = Xt, Qt = e.boolean().default(!1), $t = e.boolean().default(!1), en = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).nullable(), tn = e.enum(["", "EUR"]), nn = tn.nullable(), rn = e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).nullable(), an = e.union([e.unknown(), e.enum([""])]).nullable(), on = e.array(e.object({
	uri: e.union([e.enum([""]), e.unknown()]),
	barcode: e.string()
})), sn = on, cn = e.string().nullable(), ln = e.uuid().max(36).nullable(), un = e.int().nullable(), dn = e.string().nullable(), fn = e.record(e.string(), e.unknown()).nullable(), pn = e.string().nullable(), mn = e.object({
	quantity: un.optional(),
	order_line_identifier: dn.optional(),
	order_line: fn.optional(),
	picklist_identifier: pn.optional(),
	order_identifier: e.string().nullish()
}).nullable(), hn = e.array(mn).nullable(), gn = e.string().regex(/\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\d|3[0-1]) ([0-1]\d|2[0-4]):[0-5]\d(:([0-5]\d|60)(.\d+)?)?/).register(e.globalRegistry, { description: "Represents a date in ISO 8601 format and a time in ISO 8601 format, separated\nby a space, so:\n\n```\nYYYY-MM-DD hh:mm:ss.u\n```\n\nWhere:\n  - `YYYY` represents a four-digit year, `0000` through `9999`\n  - `MM` represents a zero-padded month of the year, `01` through `12`\n  - `DD` represents a zero-padded day of that month, `01` through `31`\nand:\n  - `hh` represents a zero-padded hour, `00` through `24`\n  - `mm` represents a zero-padded minute, `00` through `59`\n  - `ss` (optional) represents a zero-padded second, `00` through `60`\n    (where `60` is only used to denote an added leap second)\n  - `.u` (optional) represents a fraction of a second, `.0` through `.999999+`\n" }), _n = gn, vn = _n, yn = gn, bn = yn, xn = e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }), Sn = xn.nullable(), Cn = Sn, wn = xn.nullable(), Tn = wn, En = e.object({
	id: e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).register(e.globalRegistry, { description: "Unique ID of a Shipment." }),
	parent_id: m.nullable(),
	account_id: xe,
	shop_id: Se,
	shipment_type: Ce,
	recipient: Oe,
	sender: De,
	status: h,
	options: y.and(e.unknown()),
	general_settings: Le,
	pickup: Be,
	customs_declaration: b.nullable(),
	physical_properties: $e,
	reference_identifier: et,
	transaction_status: tt,
	drop_off_point: nt,
	hidden: g,
	price: x,
	barcode: e.string().max(255),
	region: e.union([e.unknown(), e.enum(["Wereld"])]),
	external_provider: at.nullable(),
	external_provider_id: ot.nullable(),
	payment_status: st,
	carrier_id: S,
	platform_id: lt,
	origin: ut.nullable(),
	user_agent: dt,
	secondary_shipments: e.array(e.object({
		id: m,
		parent_id: ft,
		account_id: pt,
		shop_id: mt,
		shipment_type: ht,
		recipient: gt,
		sender: _t,
		status: vt,
		options: yt,
		general_settings: bt,
		pickup: xt,
		customs_declaration: St,
		physical_properties: Ct,
		reference_identifier: wt,
		transaction_status: Tt,
		drop_off_point: Et,
		hidden: Dt,
		price: Ot,
		barcode: kt,
		region: At,
		external_provider: jt,
		external_provider_id: Mt,
		payment_status: Nt,
		carrier_id: Pt,
		platform_id: Ft,
		origin: It,
		user_agent: Lt,
		secondary_shipments: e.array(e.unknown()).max(0).nullish(),
		collection_contact: Jt,
		multi_collo_main_shipment_id: Yt,
		external_identifier: Zt,
		delayed: Qt,
		delivered: $t,
		amount: en.optional(),
		currency: nn.optional(),
		contract_id: rn,
		link_consumer_portal: an.optional(),
		partner_tracktraces: sn.optional(),
		pickup_request_number: cn.optional(),
		order_shipment_identifier: ln.optional(),
		shipped_items: hn.optional(),
		created: vn,
		modified: bn,
		created_by: Cn,
		modified_by: Tn
	})),
	collection_contact: qt.nullable(),
	multi_collo_main_shipment_id: m.nullable(),
	external_identifier: Xt,
	delayed: e.boolean().default(!1),
	delivered: e.boolean().default(!1),
	amount: e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).nullish(),
	currency: tn.nullish(),
	contract_id: e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).nullable(),
	link_consumer_portal: e.union([e.unknown(), e.enum([""])]).nullish(),
	partner_tracktraces: on.optional(),
	pickup_request_number: e.string().nullish(),
	order_shipment_identifier: e.uuid().max(36).nullish(),
	shipped_items: e.array(mn).nullish(),
	created: _n,
	modified: yn,
	created_by: Sn,
	modified_by: wn
}), Dn = e.object({ data: e.object({ shipments: e.array(En).register(e.globalRegistry, { description: "A list of Shipment Resources." }) }) }), On = e.union([e.string(), e.unknown()]), kn = e.object({ url: e.url() }), An = e.object({ data: e.union([
	e.object({ pdf: kn }),
	e.object({ pdfs: kn }),
	e.object({ csvs: kn }),
	e.object({ zpl: kn }),
	e.object({ zpls: kn })
]) }), jn = e.array(e.object({
	shipment_id: m,
	price: _,
	price_after_vat: _
})), Mn = e.object({ data: e.object({ shipments: e.object({
	unpaid_shipments: jn,
	blocked_shipments: jn
}) }) }), Nn = e.object({
	amount: e.int().nullable(),
	currency: e.enum(["", "EUR"]).register(e.globalRegistry, { description: "The currency as uppercase 3-letter ISO 4217 code." })
}).register(e.globalRegistry, { description: "Price amount in a specific currency" }), Pn = e.object({
	id: e.string(),
	hash: e.string(),
	type: e.int(),
	notification_hash: e.string(),
	original_notification_hash: e.string(),
	paid: e.union([e.literal(0), e.literal(1)]),
	price: Nn,
	payment_url: e.url().nullable(),
	invoices: e.object({
		id: e.int(),
		number: e.string(),
		status: e.int()
	})
}), Fn = e.object({ data: e.object({ payment_instructions: e.array(Pn) }) }), In = e.literal(400).register(e.globalRegistry, { description: "The server will not process the request due to a client error." }), Ln = ve.and(e.object({
	status_code: In.optional(),
	errors: e.array(e.object({
		status: In.optional(),
		code: e.int().optional()
	})).optional()
})), Rn = e.object({
	type: e.string().register(e.globalRegistry, { description: "URI reference identifying the problem type. Derived from the wrapping UserException constant name (e.g. `urn:problem:invalid-shipments`) or, when no matching constant exists, a status-based fallback URN.\n" }),
	title: e.string().register(e.globalRegistry, { description: "A short, human-readable summary of the problem type." }),
	status: e.int().register(e.globalRegistry, { description: "The HTTP status code for this occurrence." }),
	detail: e.string().register(e.globalRegistry, { description: "A human-readable explanation specific to this occurrence." }),
	instance: e.string().register(e.globalRegistry, { description: "URI reference identifying the specific occurrence. The request path for the top-level object; the RFC 6901 JSON Pointer of the failing field for each `errors[]` entry.\n" }).optional(),
	request_id: e.string().register(e.globalRegistry, { description: "Per-request correlation identifier. Mirrors the value of the `X-Request-Id` response header and the legacy envelope's `request_id` field. Allowed as an RFC 9457 §3.2 extension member so consumers don't have to read both header and body for tracing.\n" }).optional(),
	errors: e.array(e.object({
		type: e.string(),
		title: e.string(),
		detail: e.string(),
		instance: e.string().optional()
	})).register(e.globalRegistry, { description: "Sub-problem list. Each entry is itself an RFC 9457 problem-detail object describing one failing field. The sub-error `type`/`title` narrow past the wrapping problem when the underlying validator code maps to its own UserException constant (e.g. `urn:problem:invalid-address`, `urn:problem:invalid-physical-properties`).\n" }).optional()
}).register(e.globalRegistry, { description: "RFC 9457 problem-detail object returned when the caller lists `application/problem+json` in the Accept header. Top-level fields are strictly the five defined in RFC 9457 §3.1; the `errors` array is an extension populated when the underlying exception carried per-field validator errors.\n" }), zn = e.union([
	e.literal(0),
	e.literal(1),
	e.literal(2),
	e.literal(3)
]), C = e.object({
	date: gn,
	timezone: e.string(),
	timezone_type: zn
}), Bn = e.enum([
	"morning",
	"standard",
	"evening",
	"same_day",
	"express",
	"early_morning"
]), Vn = e.enum([
	"package",
	"mailbox",
	"unfranked",
	"digital_stamp",
	"pallet",
	"small_package",
	"envelope"
]).register(e.globalRegistry, { description: "Package Type." }), Hn = e.object({
	type: e.enum(["start", "end"]),
	date_time: C
}), Un = e.object({
	type: Bn.nullable(),
	package_type: Vn,
	delivery_time_frames: e.array(Hn),
	shipment_options: e.array(e.object({
		name: e.string(),
		schema: e.object({
			type: e.enum(["boolean"]),
			enum: e.array(e.boolean())
		})
	})),
	price: Nn.optional(),
	identifier: e.string().optional(),
	transporter: e.string().optional(),
	label_type: e.string().optional()
}), Wn = e.object({
	date: C,
	possibilities: e.array(Un)
}), Gn = e.object({ data: e.object({ deliveries: e.array(Wn) }) }), Kn = e.iso.date().regex(/\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\d|3[0-1])/).register(e.globalRegistry, { description: "Represents a date in ISO 8601 format:\n\n```\nYYYY-MM-DD\n```\n\nWhere:\n  - `YYYY` represents a four-digit year, `0000` through `9999`\n  - `MM` represents a zero-padded month of the year, `01` through `12`\n  - `DD` represents a zero-padded day of that month, `01` through `31`\n" }), qn = e.iso.time().regex(/([0-1]\d|2[0-4]):[0-5]\d(:([0-5]\d|60)(.\d+)?)?/).register(e.globalRegistry, { description: "Represents a time in ISO 8601 format:\n\n```\nhh:mm:ss.u\n```\n\nWhere:\n  - `hh` represents a zero-padded hour, `00` through `24`\n  - `mm` represents a zero-padded minute, `00` through `59`\n  - `ss` (optional) represents a zero-padded second, `00` through `60`\n    (where `60` is only used to denote an added leap second)\n  - `.u` (optional) represents a fraction of a second, `.0` through `.999999+`\n" }), Jn = e.object({
	start: qn,
	end: qn,
	price: Nn,
	price_comment: e.string(),
	comment: e.string(),
	type: e.int(),
	collect_date: C.optional(),
	identifier: e.string().optional(),
	transporter: e.string().optional(),
	label_type: e.string().optional()
}), Yn = e.object({
	date: Kn,
	time: e.array(Jn)
}), Xn = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(6),
	e.literal(7),
	e.literal(8)
]), Zn = e.object({
	start: qn.nullish(),
	type: Xn.optional(),
	price: Nn.optional()
}), w = e.array(e.string()).register(e.globalRegistry, { description: "Opening hours.\nEach opening consist out of open- and close time formatted as a single string separated by ' - '. e.g. \"13:00 - 20:00\"\n" }), Qn = e.object({
	monday: w,
	tuesday: w,
	wednesday: w,
	thursday: w,
	friday: w,
	saturday: w,
	sunday: w
}), $n = e.union([e.number().gte(-90).lte(90), e.string().regex(/^[-+]?(90|[0-8]?\d)(\.\d+)?$/)]), er = e.union([e.number().gte(-180).lte(180), e.string().regex(/^[-+]?(180|(0?\d{0,2}|1[0-7]\d)(\.\d+)?)$/)]), tr = e.object({
	date: Kn.nullish(),
	time: e.array(Zn).optional(),
	location: e.string().optional(),
	street: e.string().optional(),
	number: e.string().optional(),
	number_suffix: e.string().nullish(),
	postal_code: e.string().optional(),
	city: e.string().optional(),
	cc: e.string().optional(),
	start_time: qn.nullish(),
	price: e.int().optional(),
	price_comment: e.enum(["retail", "retailexpress"]).optional(),
	comment: e.string().optional(),
	phone_number: e.string().optional(),
	opening_hours: Qn.optional(),
	distance: e.string().optional(),
	latitude: $n.optional(),
	longitude: er.optional(),
	location_code: e.string().optional(),
	retail_network_id: e.string().nullish(),
	holiday: e.object({
		from: e.string().nullish(),
		to: e.string().nullish()
	}).optional()
}), nr = e.int().gte(500).lte(599).register(e.globalRegistry, { description: "The server failed to fulfill an apparently valid request" }), rr = e.union([me, nr]), ir = e.object({
	status: rr.optional(),
	code: ge,
	title: e.string().optional(),
	message: e.string()
}), ar = e.object({
	data: e.object({
		delivery: e.array(Yn),
		pickup: e.array(tr),
		message: e.string().optional()
	}),
	errors: e.array(e.union([ir, e.object({
		code: e.int(),
		message: e.string(),
		human: e.string().optional()
	})])).optional()
}), or = e.literal(406).register(e.globalRegistry, { description: "The target resource doesn't have an acceptable representation for the user agent." }), sr = ve.and(e.object({
	status_code: or.optional(),
	errors: e.array(e.object({
		status: or.optional(),
		code: e.int().optional()
	})).optional()
})), cr = e.object({ link: e.url() }).register(e.globalRegistry, { description: "DownloadUrl Object Definition" }), lr = e.object({ data: e.object({ download_url: cr }) }), ur = e.union([
	e.literal(0),
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6)
]), dr = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7)
]), fr = e.array(e.union([ur, dr])).nullable(), pr = e.object({
	monday: e.number().nullish(),
	tuesday: e.number().nullish(),
	wednesday: e.number().nullish(),
	thursday: e.number().nullish(),
	friday: e.number().nullish(),
	saturday: e.number().nullish(),
	sunday: e.number().nullish()
}), mr = e.object({
	start: C.nullable(),
	end: C.nullable()
}), T = e.array(mr), hr = e.object({
	monday: T.optional(),
	tuesday: T.optional(),
	wednesday: T.optional(),
	thursday: T.optional(),
	friday: T.optional(),
	saturday: T.optional(),
	sunday: T.optional()
}).nullable(), gr = e.object({
	location_code: e.string().optional(),
	location_name: e.string().nullish(),
	cc: e.string().optional(),
	state: e.string().nullish(),
	city: e.string().optional(),
	postal_code: e.string().optional(),
	street: e.string().optional(),
	number: e.union([e.string(), e.int()]).nullish(),
	number_suffix: e.string().nullish(),
	phone: e.string().nullish(),
	reference: e.string().nullish(),
	longitude: er.nullish(),
	latitude: $n.nullish(),
	available_days: fr.optional(),
	cut_off_time: e.string().nullish(),
	carrier_id: S.optional(),
	distance: e.number().nullish(),
	occupancy: pr.nullish(),
	occupancy_today: e.number().nullish(),
	default_drop_off_point: e.boolean().nullish(),
	type: Re.nullish(),
	opening_hours: hr.optional()
}), _r = e.object({ data: e.object({ drop_off_points: e.array(gr) }) }), vr = e.literal(415).register(e.globalRegistry, { description: "Content is in a format not supported by this method on the target resource." }), yr = ve.and(e.object({
	status_code: vr.optional(),
	errors: e.array(e.object({
		status: vr.optional(),
		code: e.literal(3100).optional()
	})).optional()
})), br = e.literal(401).register(e.globalRegistry, { description: "The request lacks valid authentication credentials for the target resource." }), xr = ve.and(e.object({
	status_code: br.optional(),
	errors: e.array(e.object({
		status: br.optional(),
		code: e.int().optional()
	})).optional()
})), Sr = e.object({
	cc: e.string(),
	city: e.string(),
	street: e.string(),
	postal_code: e.string(),
	number: e.string(),
	number_suffix: e.string().nullish()
}), Cr = e.array(e.object({
	delivery_type_id: e.int(),
	delivery_type_name: e.string(),
	price: e.int(),
	moment: e.object({ start: C.nullish() })
})), E = e.object({
	start: C.nullable(),
	end: C.nullable()
}), wr = e.object({
	monday: e.array(E),
	tuesday: e.array(E),
	wednesday: e.array(E),
	thursday: e.array(E),
	friday: e.array(E),
	saturday: e.array(E),
	sunday: e.array(E)
}), Tr = e.object({
	location_name: e.string(),
	retail_network_id: e.string().nullable(),
	distance: e.string(),
	latitude: e.string(),
	longitude: e.string(),
	location_code: e.string(),
	phone_number: e.string().nullable(),
	type: Re.nullable(),
	opening_hours: wr
}), Er = e.object({
	address: Sr,
	possibilities: Cr,
	location: Tr
}), Dr = e.object({ data: e.object({ pickup_locations: e.array(Er) }) }), Or = e.object({ data: e.object({
	shipments: e.array(En).register(e.globalRegistry, { description: "A list of Shipment Resources." }),
	pdf: e.object({ url: e.string().regex(/^\/pdfs\/.*/) }).optional(),
	zpl: e.object({ url: e.string().regex(/^\/zpls\/.*/) }).optional()
}) }), kr = e.object({ data: e.object({ ids: e.array(e.object({
	id: m,
	reference_identifier: et
})).register(e.globalRegistry, { description: "A list of Shipment IDs." }) }) }), Ar = e.array(e.object({
	id: m,
	reference_identifier: et
})).register(e.globalRegistry, { description: "A list of Shipment IDs." }), jr = e.object({ data: e.union([e.object({
	ids: Ar,
	pdf: e.object({ url: e.string().regex(/^\/pdfs\/.*/) })
}), e.object({
	ids: Ar,
	zpl: e.object({ url: e.string().regex(/^\/zpls\/.*/) })
})]) }), Mr = e.object({
	status: nr.optional(),
	code: e.int().optional(),
	title: e.string().optional(),
	message: e.string().optional()
}), Nr = e.object({
	message: e.string().register(e.globalRegistry, { description: "A human-readable description of the error." }).optional(),
	request_id: e.string().register(e.globalRegistry, { description: "Internal request ID, useful for debugging purposes." }).optional(),
	status_code: nr.optional(),
	errors: e.array(Mr).optional()
}), Pr = e.object({ data: e.object({
	shipments: e.array(En).register(e.globalRegistry, { description: "A list of Shipment Resources." }),
	results: e.int().register(e.globalRegistry, { description: "The number of results." })
}) }), Fr = e.object({
	uri: e.url(),
	barcode: e.string()
}), Ir = e.object({
	name: e.string(),
	cc: e.string().nullable(),
	city: e.string().nullable(),
	postal_code: e.string().nullable(),
	street: e.string().nullable(),
	number: e.string().nullable(),
	number_suffix: e.string().nullable(),
	longitude: e.number().nullable(),
	latitude: e.number().nullable()
}), Lr = e.enum([
	"registered",
	"handed_to_carrier",
	"sorting",
	"distribution",
	"delivered"
]).nullable(), Rr = e.object({
	code: e.string(),
	status: h.nullable(),
	main: Lr,
	description: e.string(),
	time: gn,
	delayed: e.boolean(),
	location: Ir
}), zr = e.array(Rr), Br = e.enum(["estimated", "expected"]).nullable(), Vr = e.object({
	start: C.nullable(),
	end: C.nullable()
}).nullable(), Hr = e.union([e.string(), e.object({
	content: e.string(),
	content_type: e.string()
})]).nullable(), Ur = e.object({
	shipment_id: m,
	carrier: S,
	code: e.string(),
	description: e.string(),
	time: gn,
	link_consumer_portal: e.url().nullable(),
	link_tracktrace: e.url().nullable(),
	partner_tracktraces: e.array(Fr),
	recipient: Oe,
	sender: De,
	options: y,
	pickup: Be,
	delayed: e.boolean(),
	location: Ir,
	status: e.object({
		current: h,
		main: Lr,
		final: e.boolean()
	}),
	history: zr,
	delivery_moment_type: Br.optional(),
	delivery_moment: Vr.optional(),
	signature: Hr.optional(),
	returnable: e.boolean().optional()
}).register(e.globalRegistry, { description: "A Track & Trace resource." }), Wr = e.object({ data: e.object({ tracktraces: e.array(Ur).register(e.globalRegistry, { description: "A list of Track & Trace Resources." }) }) }), Gr = e.enum([
	"BPOST",
	"BRT",
	"CHEAP_CARGO",
	"DHL_EUROPLUS",
	"DHL_FOR_YOU",
	"DHL_FREIGHT",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"GLS",
	"INPOST",
	"POSTE_ITALIANE",
	"POSTNL",
	"SPRING",
	"TRUNKRS",
	"UPS_EXPRESS_SAVER",
	"UPS_STANDARD",
	"VIA_TIM"
]).register(e.globalRegistry, { description: "Carrier string definition for capabilities endpoints (v2)" }), Kr = e.object({
	id: e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).register(e.globalRegistry, { description: "The contract ID." }),
	type: e.enum(["MAIN", "CUSTOM"]).register(e.globalRegistry, { description: "The type of contract." })
}).register(e.globalRegistry, { description: "Contract definition for capabilities endpoints (v2)" }), qr = e.enum([
	"PACKAGE",
	"MAILBOX",
	"UNFRANKED",
	"DIGITAL_STAMP",
	"PALLET",
	"SMALL_PACKAGE",
	"ENVELOPE"
]).register(e.globalRegistry, { description: "Package Type." }), D = e.object({
	isSelectedByDefault: e.boolean(),
	isRequired: e.boolean()
}), Jr = e.object({
	additionalInsurance: D.optional(),
	deliverAtPostalPoint: D.optional(),
	freshFood: D.optional(),
	frozen: D.optional(),
	hideSender: D.optional(),
	noTracking: D.optional(),
	oversizedPackage: D.optional(),
	priorityDelivery: D.optional(),
	printReturnLabelAtDropOff: D.optional(),
	recipientOnlyDelivery: D.optional(),
	requiresAgeVerification: D.optional(),
	requiresCashOnDelivery: D.optional(),
	requiresReceiptCode: D.optional(),
	requiresSignature: D.optional(),
	returnOnFirstFailedDelivery: D.optional(),
	sameDayDelivery: D.optional(),
	saturdayDelivery: D.optional(),
	scheduledCollection: D.optional(),
	tracked: D.optional()
}), O = D.and(e.object({
	requires: e.array(e.string()).register(e.globalRegistry, { description: "camelCase shipment option keys that are required" }),
	excludes: e.array(e.string()).register(e.globalRegistry, { description: "camelCase shipment option keys that are excluded" })
})), Yr = e.object({
	insuredAmount: e.object({
		default: _,
		min: _,
		max: _
	}).register(e.globalRegistry, { description: "Deprecated. Use the flat default/min/max properties on the insurance option directly. Will be removed in a future release.\n" }).optional(),
	default: _.optional(),
	min: _.optional(),
	max: _.optional()
}), Xr = O.and(Yr), Zr = Jr.and(e.object({
	additionalInsurance: O.optional(),
	deliverAtPostalPoint: O.optional(),
	freshFood: O.optional(),
	frozen: O.optional(),
	hideSender: O.optional(),
	insurance: Xr.optional(),
	noTracking: O.optional(),
	oversizedPackage: O.optional(),
	priorityDelivery: O.optional(),
	printReturnLabelAtDropOff: O.optional(),
	recipientOnlyDelivery: O.optional(),
	requiresAgeVerification: O.optional(),
	requiresCashOnDelivery: O.optional(),
	requiresReceiptCode: O.optional(),
	requiresSignature: O.optional(),
	returnOnFirstFailedDelivery: O.optional(),
	sameDayDelivery: O.optional(),
	saturdayDelivery: O.optional(),
	scheduledCollection: O.optional(),
	tracked: O.optional()
})), Qr = e.object({
	value: e.number().register(e.globalRegistry, { description: "The numeric value" }),
	unit: e.enum([
		"g",
		"kg",
		"cm",
		"mm",
		"mm3",
		"cm3",
		"dm3",
		"m3"
	]).register(e.globalRegistry, { description: "The unit of measurement in SI units" })
}), k = e.object({
	min: Qr,
	max: Qr,
	calculation: e.string()
}), $r = e.object({
	weight: k.optional(),
	width: k.optional(),
	length: k.optional(),
	height: k.optional(),
	girth: k.optional(),
	volumetricWeight: k.optional(),
	volume: k.optional(),
	lengthWidthHeightSum: k.optional()
}), ei = e.enum([
	"MORNING_DELIVERY",
	"STANDARD_DELIVERY",
	"EVENING_DELIVERY",
	"PICKUP_DELIVERY",
	"SAME_DAY_DELIVERY",
	"EXPRESS_DELIVERY",
	"EARLY_MORNING_DELIVERY"
]), ti = e.enum(["B2B", "B2C"]), ni = e.object({ max: e.int() }), ri = e.object({
	carrier: Gr,
	contract: Kr.optional(),
	packageTypes: e.array(qr),
	options: Zr,
	physicalProperties: $r,
	deliveryTypes: e.array(ei),
	transactionTypes: e.array(ti),
	collo: ni
}).register(e.globalRegistry, { description: "A V2 Capability response item for a given Shipment configuration." }), ii = e.object({ results: e.array(ri).register(e.globalRegistry, { description: "A list of V2 Capabilities for a given Shipment configuration." }) }), ai = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(12),
	e.literal(13),
	e.literal(14),
	e.literal(15),
	e.literal(16),
	e.literal(17),
	e.literal(18),
	e.literal(19),
	e.literal(20),
	e.literal(21)
]).register(e.globalRegistry, { description: "Carrier ID definition for capabilities endpoints (v1)" }), oi = e.object({
	id: e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).register(e.globalRegistry, { description: "The contract ID." }),
	type: e.enum(["main", "custom"]).register(e.globalRegistry, { description: "The type of contract." })
}).register(e.globalRegistry, { description: "Contract definition for capabilities endpoints (v1)" }), A = e.object({
	is_selected_by_default: e.boolean(),
	is_required: e.boolean()
}), si = e.object({
	age_check: A.optional(),
	cash_on_delivery: A.optional(),
	collect: A.optional(),
	drop_off_at_postal_point: A.optional(),
	extra_assurance: A.optional(),
	fresh_food: A.optional(),
	frozen: A.optional(),
	hide_sender: A.optional(),
	large_format: A.optional(),
	no_tracking: A.optional(),
	only_recipient: A.optional(),
	printerless_return: A.optional(),
	priority_delivery: A.optional(),
	receipt_code: A.optional(),
	return: A.optional(),
	same_day_delivery: A.optional(),
	saturday_delivery: A.optional(),
	signature: A.optional(),
	tracked: A.optional()
}), j = A.and(e.object({
	requires: e.array(e.string()).register(e.globalRegistry, { description: "snake_case shipment option keys that are required" }),
	excludes: e.array(e.string()).register(e.globalRegistry, { description: "snake_case shipment option keys that are excluded" })
})), ci = e.object({
	insured_amount: e.object({
		default: _,
		min: _,
		max: _
	}).register(e.globalRegistry, { description: "Deprecated. Use the flat default/min/max properties on the insurance option directly. Will be removed in a future release.\n" }).optional(),
	default: _.optional(),
	min: _.optional(),
	max: _.optional()
}), li = j.and(ci), ui = si.and(e.object({
	age_check: j.optional(),
	cash_on_delivery: j.optional(),
	collect: j.optional(),
	drop_off_at_postal_point: j.optional(),
	extra_assurance: j.optional(),
	fresh_food: j.optional(),
	frozen: j.optional(),
	hide_sender: j.optional(),
	insurance: li.optional(),
	large_format: j.optional(),
	no_tracking: j.optional(),
	only_recipient: j.optional(),
	printerless_return: j.optional(),
	priority_delivery: j.optional(),
	receipt_code: j.optional(),
	return: j.optional(),
	same_day_delivery: j.optional(),
	saturday_delivery: j.optional(),
	signature: j.optional(),
	tracked: j.optional()
})), di = e.object({
	weight: k.optional(),
	width: k.optional(),
	length: k.optional(),
	height: k.optional(),
	girth: k.optional(),
	volumetric_weight: k.optional(),
	volume: k.optional(),
	length_width_height_sum: k.optional()
}), fi = e.object({
	carrier_id: ai,
	contract: oi.optional(),
	package_types: e.array(v),
	options: ui,
	physical_properties: di,
	delivery_types: e.array(Xn),
	transaction_types: e.array(ti),
	collo: ni
}).register(e.globalRegistry, { description: "A V1 Capability response item for a given Shipment configuration." }), pi = e.object({ data: e.object({ capabilities: e.array(fi).register(e.globalRegistry, { description: "A list of V1 Capabilities for a given Shipment configuration." }) }) }), M = D.and(e.object({})), mi = M.and(Yr), hi = Jr.and(e.object({
	additionalInsurance: M.optional(),
	deliverAtPostalPoint: M.optional(),
	hideSender: M.optional(),
	insurance: mi.optional(),
	noTracking: M.optional(),
	oversizedPackage: M.optional(),
	priorityDelivery: M.optional(),
	printReturnLabelAtDropOff: M.optional(),
	recipientOnlyDelivery: M.optional(),
	requiresAgeVerification: M.optional(),
	requiresCashOnDelivery: M.optional(),
	requiresReceiptCode: M.optional(),
	requiresSignature: M.optional(),
	returnOnFirstFailedDelivery: M.optional(),
	sameDayDelivery: M.optional(),
	saturdayDelivery: M.optional(),
	scheduledCollection: M.optional(),
	tracked: M.optional()
})), gi = e.object({
	carrier: Gr,
	packageTypes: e.array(qr),
	options: hi,
	deliveryTypes: e.array(ei),
	transactionTypes: e.array(ti),
	collo: ni
}).register(e.globalRegistry, { description: "A V2 Capability response item for a given Shipment configuration." }), _i = e.object({ items: e.array(gi).register(e.globalRegistry, { description: "A superset of V2 Capabilities for the contracts within a user's account." }) }), N = A.and(e.object({})), vi = N.and(ci), yi = si.and(e.object({
	age_check: N.optional(),
	cash_on_delivery: N.optional(),
	collect: N.optional(),
	drop_off_at_postal_point: N.optional(),
	extra_assurance: N.optional(),
	hide_sender: N.optional(),
	insurance: vi.optional(),
	large_format: N.optional(),
	no_tracking: N.optional(),
	only_recipient: N.optional(),
	printerless_return: N.optional(),
	priority_delivery: N.optional(),
	receipt_code: N.optional(),
	return: N.optional(),
	same_day_delivery: N.optional(),
	saturday_delivery: N.optional(),
	signature: N.optional(),
	tracked: N.optional()
})), bi = e.object({
	carrier_id: ai,
	package_types: e.array(v),
	options: yi,
	delivery_types: e.array(Xn),
	transaction_types: e.array(ti),
	collo: ni
}).register(e.globalRegistry, { description: "A V1 Capability contract definitions response item for a given Shipment configuration." }), xi = e.object({ data: e.object({ contract_definitions: e.array(bi).register(e.globalRegistry, { description: "A superset of V1 Capabilities for the contracts within a user's account." }) }) }), Si = e.object({
	id: e.int().register(e.globalRegistry, { description: "The id of the contract." }),
	type: e.enum(["MAIN", "CUSTOM"]).register(e.globalRegistry, { description: "The type of contract." })
}).register(e.globalRegistry, { description: "The contract object." }), Ci = e.enum([
	"EXPRESS",
	"FULFILMENT",
	"LABEL_PACKAGE",
	"MULTI_COLLO",
	"RETURN",
	"RETURN_ERS",
	"RETURN_SPECIAL",
	"STANDARD"
]), wi = e.object({
	name: e.string(),
	key: e.string(),
	price: x,
	vat: x,
	priceWithVat: x
}).register(e.globalRegistry, { description: "A V2 Price object." }), Ti = e.object({
	base: wi,
	charges: e.array(wi),
	discounts: e.array(wi),
	options: e.array(wi),
	other: e.array(wi),
	total: wi
}).register(e.globalRegistry, { description: "The V2 price composition object, containing the base, options, charges, discounts and total prices." }), Ei = e.object({
	carrier: Gr,
	contract: Si.optional(),
	packageType: qr,
	deliveryType: ei.optional(),
	shipmentType: Ci,
	priceComposition: Ti
}).register(e.globalRegistry, { description: "A V2 Rate response item for a given Shipment configuration." }), Di = e.object({
	id: e.int().register(e.globalRegistry, { description: "The id of the contract." }),
	type: e.enum(["main", "custom"]).register(e.globalRegistry, { description: "The type of contract." })
}).register(e.globalRegistry, { description: "The contract object." }), Oi = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7)
]), ki = e.object({
	name: e.string(),
	key: e.string(),
	price: x,
	vat: x,
	price_with_vat: x
}).register(e.globalRegistry, { description: "A V1 Price object." }), Ai = e.object({
	base: ki,
	charges: e.array(ki),
	discounts: e.array(ki),
	options: e.array(ki),
	other: e.array(ki),
	total: ki
}).register(e.globalRegistry, { description: "The price composition object, containing the base, options, charges, discounts and total prices." }), ji = e.object({
	carrier_id: ai,
	contract: Di.optional(),
	package_type: v,
	delivery_type: Xn.optional(),
	shipment_type: Oi,
	price_composition: Ai
}).register(e.globalRegistry, { description: "A V1 Rate response item for a given Shipment configuration." }), Mi = e.object({ data: e.object({ rates: e.array(ji).register(e.globalRegistry, { description: "A list of V1 Rates for a given Shipment configuration." }) }) }), Ni = e.object({
	id: e.int(),
	shopId: e.int(),
	packageType: e.enum([
		"DIGITAL_STAMP",
		"ENVELOPE",
		"UNFRANKED",
		"MAILBOX",
		"PACKAGE",
		"PALLET",
		"SMALL_PACKAGE"
	]).nullable(),
	countryCode: e.string().length(2).regex(/^[A-Z]{2}$/).nullable(),
	shipmentDirection: e.enum(["OUTBOUND", "INBOUND"]),
	fallback: e.boolean()
}).register(e.globalRegistry, { description: "A Notification Group response item" }), Pi = e.object({ results: e.array(Ni) }), Fi = e.enum([
	"LABEL_DOWNLOAD",
	"FIRST_SCAN",
	"RETURN"
]).register(e.globalRegistry, { description: "The notification template type." }), Ii = e.object({
	id: e.int(),
	notificationGroupId: e.int(),
	type: Fi,
	subject: e.string(),
	body: e.string(),
	active: e.boolean()
}).register(e.globalRegistry, { description: "A Notification Template response item" }), Li = e.object({ results: e.array(Ii) }), Ri = e.object({
	id: e.int(),
	account_id: e.int(),
	shop_id: e.int(),
	hook: e.string(),
	url: e.string(),
	payload: e.string().nullish()
}).register(e.globalRegistry, { description: "A Webhook Subscription response item" }), zi = e.object({ data: e.object({ webhook_subscriptions: e.array(Ri) }) }), Bi = e.object({
	id: e.int(),
	account_id: e.int(),
	shop_id: e.int(),
	hook: e.string(),
	url: e.string()
}).register(e.globalRegistry, { description: "A Webhook Subscription response item" }), Vi = e.object({ data: e.object({ webhook_subscriptions: e.array(Bi) }) }), Hi = e.object({ data: e.object({ ids: e.array(e.object({ id: e.int() })).register(e.globalRegistry, { description: "A list of created webhook subscription IDs." }) }) }), Ui = e.string().min(6).max(32).regex(/^[a-zA-Z0-9\-\s]+$/), Wi = e.enum([
	"1",
	"2",
	"3",
	"4",
	"5",
	"6",
	"7",
	"8",
	"9",
	"10",
	"11",
	"12",
	"13",
	"14",
	"15",
	"16",
	"17",
	"18",
	"19",
	"20",
	"21"
]).register(e.globalRegistry, { description: "This enumeration represents the Carriers. The value is the Carrier id." }), Gi = e.enum([
	"postnl",
	"bpost",
	"cheapcargo",
	"dpd",
	"instabox",
	"dhl",
	"bol.com",
	"ups",
	"dhlforyou",
	"dhlparcelconnect",
	"dhleuroplus",
	"upsstandard",
	"upsexpresssaver",
	"gls",
	"brt",
	"trunkrs",
	"inpost",
	"posteitaliane",
	"spring",
	"viatim",
	"dhlfreight"
]).register(e.globalRegistry, { description: "This enumeration represents the Carriers. The value is the Carrier id." }), Ki = e.union([Wi, Gi]).nullable(), qi = e.iso.date().regex(/\d{4}-\d{2}-\d{2}/).nullable(), Ji = e.string().length(2).regex(/^[A-Za-z]{2}$/).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 country code" }), P = qn.nullable(), F = e.union([
	e.boolean(),
	e.int().gte(0).lte(1),
	e.union([e.unknown(), e.unknown()]),
	e.enum([
		"0",
		"1",
		"false",
		"true"
	])
]), Yi = e.union([
	e.literal(!1),
	e.literal(!0),
	e.literal(0),
	e.literal(1),
	e.literal("0"),
	e.literal("1"),
	e.literal("false"),
	e.literal("true"),
	e.literal("off"),
	e.literal("on"),
	e.literal("no"),
	e.literal("yes"),
	e.literal("")
]).nullable(), Xi = Kn.nullable(), Zi = qn.nullable(), Qi = e.string().nullable(), $i = e.string().regex(/^([0-6](;[0-6])*)?$/).nullable(), ea = e.enum([
	"1",
	"2",
	"3",
	"4",
	"6",
	"7",
	"8"
]), ta = e.union([ea, e.unknown()]), na = e.enum(["A4", "A6"]).register(e.globalRegistry, { description: "The size of a paper as specified in ISO216." }), ra = $n.nullable(), ia = er.nullable(), aa = e.enum(["ASC", "DESC"]).register(e.globalRegistry, { description: "Specify whether the results should be sorted in ascending or descending order." }), oa = e.union([
	v,
	e.array(v),
	e.string().regex(/^[1-7](;[1-7]){0,5}$/)
]), sa = e.int().gte(1).lte(1e3).register(e.globalRegistry, { description: "Request a specific page of the results, used for paginated results." }), ca = e.enum([
	"myparcel",
	"flespakket",
	"belgie",
	"delivery_dutch",
	"postnl_customer",
	"italy"
]), la = e.enum([
	"1",
	"2",
	"3",
	"4",
	"5",
	"6"
]), ua = e.union([ca, la]).nullable(), da = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4)
]).register(e.globalRegistry, { description: "The position of the label on the paper." }), fa = e.union([da, e.string().regex(/^[0-4](;[1-4]){0,3}$/)]), pa = e.string().min(2).max(12).regex(/^[a-zA-Z0-9\-\s]{2,12}$/).nullable(), ma = e.coerce.bigint().gte(BigInt(1)).lte(BigInt(0x8000000000000000)), I = e.union([ma, e.string().regex(/^;*[1-9][0-9]{0,18}(;([1-9][0-9]{0,18}|[a-zA-Z]+)?)*$/)]), ha = e.union([
	Ce,
	e.array(Ce),
	e.string().regex(/^[1-8](;[1-8]){0,7}$/)
]), ga = e.int().gte(1).lte(2147483647), L = e.union([
	ga,
	e.array(ga),
	e.string().regex(/^[1-9][0-9]{0,9}(;[1-9][0-9]{0,9})*$/)
]), _a = e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "Specify the number of resources returned per page, used for paginated results." }), va = e.enum([
	"amount",
	"created",
	"created_by",
	"currency",
	"drop_off_point",
	"hidden",
	"id",
	"mark_delivered",
	"modified",
	"modified_by",
	"order_shipment_identifier",
	"parent_id",
	"recipient",
	"reference_identifier",
	"sender",
	"shipment_type",
	"shop_id",
	"status",
	"transaction_status"
]), ya = e.union([
	h,
	e.array(h),
	e.string().regex(/^(1|2|3|4|5|6|7|8|9|10|11|12|13|14|15|16|17|18|19|30|31|32|33|34|35|36|37|38|39|40|41|42|98|99|100|101)(;(1|2|3|4|5|6|7|8|9|10|11|12|13|14|15|16|17|18|19|30|31|32|33|34|35|36|37|38|39|40|41|42|98|99|100|101))*$/)
]), ba = e.string().regex(/^(?:;*(delivery_moment|returnable|signature)(?=;|$)(?!.*;\1(?:;|$)))+;*$/), xa = e.array(e.union([e.email(), e.string().max(0)])).max(4), Sa = e.object({
	cc: e.string().length(2),
	postal_code: e.string(),
	city: e.string(),
	street: e.string(),
	street_additional_info: e.string().nullish(),
	number: e.string().optional(),
	number_suffix: e.string().optional(),
	box_number: e.string().max(8).optional(),
	region: e.string().max(35).optional(),
	person: e.string(),
	company: e.string().optional(),
	phone: e.string().optional(),
	email: e.union([e.email(), e.string().max(0)]).nullish()
}), Ca = e.object({
	postal_code: e.string().optional(),
	location_name: e.string().optional(),
	city: e.string().optional(),
	street: e.string().optional(),
	number: e.string().optional(),
	number_suffix: e.string().nullish(),
	box_number: e.string().max(8).optional(),
	region: e.string().max(35).optional(),
	state: e.string().max(2).optional(),
	cc: e.string().length(2).regex(/^[A-Z]{2}/).optional(),
	location_code: e.string().optional(),
	location_type: e.union([ze, Re]).optional(),
	retail_network_id: e.string().optional()
}).nullable(), wa = e.object({ data: e.object({
	user_agent: e.string().max(255).optional(),
	shipments: e.array(e.object({
		account_id: e.int().optional(),
		shop_id: e.int().optional(),
		contract_id: e.int().optional(),
		reference_identifier: e.union([e.int(), e.string().max(255).regex(/^[^=\?]*$/)]).optional(),
		recipient: e.object({
			cc: e.string().length(2),
			region: e.string().max(35).optional(),
			state: e.string().max(2).optional(),
			postal_code: e.string().max(10),
			city: e.string().min(1).max(35),
			street: e.string().min(1).max(40).regex(/\D+/),
			street_additional_info: e.string().max(50).optional(),
			number: e.string().max(8).optional(),
			number_suffix: e.string().max(6).optional(),
			box_number: e.string().max(8).optional(),
			area: e.string().max(35).optional(),
			person: e.string().min(1).max(50),
			company: e.string().max(50).optional(),
			email: e.union([e.email(), e.string().max(0)]).optional(),
			secondary_emails: xa.optional(),
			phone: e.string().max(25).optional(),
			eori_number: e.string().nullish(),
			vat_number: e.string().nullish()
		}),
		sender: Sa.optional(),
		recipients: e.array(e.number()).min(1).optional(),
		physical_properties: e.object({
			weight: e.int().gte(0).lte(999999999),
			height: e.int().optional(),
			width: e.int().optional(),
			length: e.int().optional(),
			volume: e.int().optional()
		}).optional(),
		options: y.and(e.unknown()),
		customs_declaration: b.optional(),
		carrier: S,
		pickup: Ca.optional(),
		drop_off_point: e.object({
			postal_code: e.string(),
			location_name: e.string(),
			city: e.string(),
			street: e.string(),
			number: e.string(),
			number_suffix: e.string().optional(),
			box_number: e.string().optional(),
			region: e.string().optional(),
			state: e.string().optional(),
			cc: e.string().optional(),
			location_code: e.string(),
			retail_network_id: e.string().optional()
		}).nullish(),
		note: e.string().optional(),
		status: e.union([
			e.literal(1),
			e.literal(2),
			e.literal(3),
			e.literal(4),
			e.literal(5),
			e.literal(6),
			e.literal(7),
			e.literal(8)
		]).optional(),
		delivered: e.literal(0).optional(),
		general_settings: e.object({
			save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional(),
			delivery_notification: e.union([e.literal(0), e.literal(1)]).optional(),
			delivery_notification_email: e.array(e.string()).optional(),
			disable_auto_detect_pickup: e.union([e.literal(0), e.literal(1)]).optional(),
			printer_identifier: e.string().optional()
		}).optional(),
		secondary_shipments: e.array(e.object({
			account_id: e.int().optional(),
			shop_id: e.int().optional(),
			reference_identifier: e.union([e.int(), e.string().max(255).regex(/^[^=\?]*$/)]).optional(),
			recipient: e.object({
				cc: e.string().length(2).optional(),
				region: e.string().max(35).optional(),
				state: e.string().max(2).optional(),
				postal_code: e.string().max(10).optional(),
				city: e.string().min(1).max(35).optional(),
				street: e.string().min(1).max(40).optional(),
				street_additional_info: e.string().max(50).optional(),
				number: e.string().max(8).optional(),
				number_suffix: e.string().max(6).optional(),
				box_number: e.string().max(8).optional(),
				area: e.string().max(35).optional(),
				person: e.string().min(1).max(50).optional(),
				company: e.string().max(50).optional(),
				email: e.union([e.email(), e.string().max(0)]).optional(),
				secondary_emails: xa.optional(),
				phone: e.string().max(25).optional(),
				eori_number: e.string().nullish(),
				vat_number: e.string().nullish()
			}).optional(),
			recipients: e.array(e.number()).min(1).optional(),
			physical_properties: e.object({
				weight: e.int().gte(0).lte(999999999),
				height: e.int().optional(),
				width: e.int().optional(),
				length: e.int().optional(),
				volume: e.int().optional()
			}).optional(),
			options: y.optional(),
			customs_declaration: b.optional(),
			carrier: S.optional(),
			pickup: Ca.optional(),
			drop_off_point: e.object({
				postal_code: e.string(),
				location_name: e.string(),
				city: e.string(),
				street: e.string(),
				number: e.string(),
				number_suffix: e.string().optional(),
				box_number: e.string().optional(),
				region: e.string().optional(),
				state: e.string().optional(),
				cc: e.string().optional(),
				location_code: e.string(),
				retail_network_id: e.string().optional()
			}).nullish(),
			note: e.string().optional(),
			status: e.union([
				e.literal(1),
				e.literal(2),
				e.literal(3),
				e.literal(4),
				e.literal(5),
				e.literal(6),
				e.literal(7),
				e.literal(8)
			]).optional(),
			delivered: e.literal(0).optional(),
			general_settings: e.object({ save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional() }).optional(),
			hidden: e.union([e.literal(0), e.literal(1)]).optional(),
			shipped_items: e.array(e.object({
				order_line_identifier: e.string(),
				quantity: e.int().gte(1)
			})).min(0).optional()
		})).min(1).optional(),
		collection_contact: e.object({
			cc: e.string().length(2),
			city: e.string().min(1).max(255),
			company: e.string(),
			email: e.email(),
			first_name: e.string().optional(),
			gender: e.enum(["mr", "mrs"]).optional(),
			last_name: e.string(),
			number: e.union([e.string().min(1), e.int()]),
			number_suffix: e.string().nullish(),
			phone: e.string().min(8),
			postal_code: e.string().min(1),
			street: e.string().min(1),
			street_additional_info: e.string().nullish()
		}).optional(),
		hidden: e.union([e.literal(0), e.literal(1)]).optional(),
		shipped_items: e.array(e.object({
			order_line_identifier: e.string(),
			quantity: e.int().gte(1)
		})).min(0).optional()
	})).min(1).max(100)
}) }), Ta = e.object({ data: e.object({
	user_agent: e.string().max(255).optional(),
	shipments: e.array(e.object({
		account_id: e.int().optional(),
		shop_id: e.int().optional(),
		reference_identifier: e.union([e.int(), e.string().max(255).regex(/^[^=\?]*$/)]).optional(),
		recipient: e.object({
			cc: e.string().length(2),
			region: e.string().max(35).optional(),
			state: e.string().max(2).optional(),
			postal_code: e.string().max(10).optional(),
			city: e.string().min(1).max(35),
			street: e.string().min(1).max(40).regex(/\D+/),
			street_additional_info: e.string().max(50).optional(),
			number: e.string().max(8).optional(),
			number_suffix: e.string().max(6).optional(),
			box_number: e.string().max(8).optional(),
			area: e.string().max(35).optional(),
			person: e.string().min(1).max(50),
			company: e.string().max(50).optional(),
			email: e.union([e.email(), e.string().max(0)]).optional(),
			secondary_emails: xa.optional(),
			phone: e.string().max(25).optional()
		}),
		sender: Sa.optional(),
		recipients: e.array(e.number()).min(1).optional(),
		physical_properties: e.object({
			weight: e.int().gte(0).lte(999999999),
			height: e.int().optional(),
			width: e.int().optional(),
			length: e.int().optional(),
			volume: e.int().optional()
		}).optional(),
		options: y.and(e.unknown()),
		customs_declaration: b.optional(),
		carrier: S,
		pickup: Ca.optional(),
		"multi-colli": e.object({ amount: e.int() }).nullish(),
		note: e.string().optional(),
		status: e.union([
			e.literal(1),
			e.literal(2),
			e.literal(3),
			e.literal(4),
			e.literal(5),
			e.literal(6),
			e.literal(7),
			e.literal(8)
		]).optional(),
		delivered: e.literal(0).optional(),
		general_settings: e.object({
			save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional(),
			delivery_notification: e.union([e.literal(0), e.literal(1)]).optional(),
			delivery_notification_email: e.array(e.string()).optional(),
			disable_auto_detect_pickup: e.union([e.literal(0), e.literal(1)]).optional(),
			printer_identifier: e.string().optional()
		}).optional(),
		hidden: e.union([e.literal(0), e.literal(1)]).optional()
	})).min(1).max(100)
}) }), Ea = e.object({ package_type: e.union([
	e.literal(1),
	e.literal(2),
	e.literal(6)
]).optional() }), Da = e.literal(1).register(e.globalRegistry, { description: "Regular package." }), Oa = e.literal(2).register(e.globalRegistry, { description: "Shipment that fits through a mailbox slot." }), ka = e.literal(6), Aa = e.object({
	age_check: g.optional(),
	cooled_delivery: g.optional(),
	drop_off_at_postal_point: g.optional(),
	extra_assurance: g.optional(),
	hide_sender: g.optional(),
	large_format: g.optional(),
	only_recipient: g.optional(),
	receipt_code: g.optional(),
	return: g.optional(),
	same_day_delivery: g.optional(),
	saturday_delivery: g.optional(),
	signature: g.optional()
}), ja = e.object({ options: Ea.and(je).and(Aa).and(Ie).and(e.object({
	contribution: _.and(e.object({ amount: e.unknown().optional() })).optional(),
	printerless_return: g.optional()
})).optional() }), Ma = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(4),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(14),
	e.literal(15),
	e.literal(17),
	e.literal(18)
]), Na = e.object({ data: e.object({ return_shipments: e.array(ja.and(e.object({
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	contract_id: e.int().optional(),
	parent: e.int(),
	reference_identifier: e.union([e.int(), e.string().max(255).regex(/^[^=\?]*$/)]).optional(),
	carrier: Ma,
	email: e.string(),
	name: e.string(),
	sender: e.object({
		cc: e.string().length(2),
		postal_code: e.string().optional(),
		city: e.string(),
		street: e.string(),
		street_additional_info: e.string().optional(),
		number: e.string().optional(),
		number_suffix: e.string().optional(),
		box_number: e.string().max(8).optional(),
		region: e.string().max(35).optional(),
		person: e.string(),
		company: e.string().optional(),
		email: e.union([e.email(), e.string().max(0)]).nullish(),
		phone: e.string().optional()
	}).optional(),
	physical_properties: e.object({
		weight: e.int().gte(0).lte(999999999).optional(),
		height: e.int().optional(),
		width: e.int().optional(),
		length: e.int().optional(),
		volume: e.int().optional()
	}).optional(),
	customs_declaration: b.optional(),
	general_settings: e.object({ save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional() }).optional()
}))).min(1).optional() }) }), Pa = e.object({ data: e.object({ return_shipments: e.array(ja.and(e.object({
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	carrier: Ma,
	email: e.string().optional(),
	name: e.string().optional(),
	cc: e.string().optional(),
	sender: e.object({
		cc: e.string().length(2),
		postal_code: e.string().optional(),
		city: e.string(),
		street: e.string(),
		street_additional_info: e.string().optional(),
		number: e.string().optional(),
		number_suffix: e.string().optional(),
		box_number: e.string().max(8).optional(),
		region: e.string().max(35).optional(),
		person: e.string(),
		company: e.string().optional(),
		email: e.union([e.email(), e.string().max(0)]).nullish(),
		phone: e.string().optional()
	}).optional(),
	physical_properties: e.object({
		weight: e.int().gte(0).lte(999999999).optional(),
		height: e.int().optional(),
		width: e.int().optional(),
		length: e.int().optional(),
		volume: e.int().optional()
	}).optional(),
	customs_declaration: b.optional(),
	general_settings: e.object({ save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional() }).optional()
}))).min(1).optional() }) }), Fa = e.object({ data: e.object({ shipments: e.array(e.object({
	id: e.int(),
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	contract_id: e.int().optional(),
	reference_identifier: e.union([e.int(), e.string().max(255).regex(/^[^=\?]*$/)]).optional(),
	carrier: S,
	status: e.int().optional(),
	delivered: e.union([e.literal(0), e.literal(1)]).optional(),
	recipient: e.object({
		cc: e.string().length(2),
		region: e.string().max(32).optional(),
		state: e.string().max(2).optional(),
		postal_code: e.string().max(10).optional(),
		city: e.string().max(35),
		street: e.string().max(40),
		street_additional_info: e.string().max(50).optional(),
		number: e.string().max(8).nullish(),
		number_suffix: e.string().max(6).nullish(),
		box_number: e.string().max(8).optional(),
		person: e.string().max(50),
		company: e.string().max(50).optional(),
		email: e.union([e.email(), e.string().max(0)]).optional(),
		secondary_emails: xa.optional(),
		phone: e.string().max(25).optional(),
		eori_number: e.string().nullish(),
		vat_number: e.string().nullish()
	}),
	sender: Sa.optional(),
	options: y.and(e.unknown()),
	customs_declaration: b.optional(),
	physical_properties: e.object({
		weight: e.int().gte(0).lte(999999999),
		height: e.int().optional(),
		width: e.int().optional(),
		length: e.int().optional(),
		volume: e.int().optional()
	}).optional(),
	pickup: Ca.optional(),
	drop_off_point: e.object({
		postal_code: e.string(),
		location_name: e.string(),
		city: e.string(),
		street: e.string(),
		number: e.string(),
		number_suffix: e.string().optional(),
		box_number: e.string().optional(),
		region: e.string().optional(),
		state: e.string().optional(),
		cc: e.string().optional(),
		location_code: e.string(),
		retail_network_id: e.string().optional()
	}).nullish(),
	note: e.string().optional(),
	general_settings: e.object({
		save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional(),
		delivery_notification: e.union([e.literal(0), e.literal(1)]).optional(),
		delivery_notification_email: e.array(e.string()).optional(),
		disable_auto_detect_pickup: e.union([e.literal(0), e.literal(1)]).optional(),
		printer_identifier: e.string().optional()
	}).optional(),
	multi_collo_main_shipment_id: e.int().nullish(),
	secondary_shipments: e.array(e.object({
		id: e.int().optional(),
		account_id: e.int().optional(),
		shop_id: e.int().optional(),
		reference_identifier: e.union([e.int(), e.string().max(255).regex(/^[^=\?]*$/)]).optional(),
		recipient: e.object({
			cc: e.string().length(2).optional(),
			region: e.string().max(35).optional(),
			state: e.string().max(2).optional(),
			postal_code: e.string().max(10).optional(),
			city: e.string().min(1).max(35).optional(),
			street: e.string().min(1).max(40).optional(),
			street_additional_info: e.string().max(50).optional(),
			number: e.string().max(8).nullish(),
			number_suffix: e.string().max(6).nullish(),
			box_number: e.string().max(8).optional(),
			area: e.string().max(35).optional(),
			person: e.string().min(1).max(50).optional(),
			company: e.string().max(50).optional(),
			email: e.union([e.email(), e.string().max(0)]).optional(),
			secondary_emails: xa.optional(),
			phone: e.string().max(25).optional(),
			eori_number: e.string().nullish(),
			vat_number: e.string().nullish()
		}).optional(),
		recipients: e.array(e.number()).min(1).optional(),
		physical_properties: e.object({
			weight: e.int().gte(0).lte(999999999),
			height: e.int().optional(),
			width: e.int().optional(),
			length: e.int().optional(),
			volume: e.int().optional()
		}).optional(),
		options: y.optional(),
		customs_declaration: b.optional(),
		carrier: S.optional(),
		pickup: Ca.optional(),
		drop_off_point: e.object({
			postal_code: e.string(),
			location_name: e.string(),
			city: e.string(),
			street: e.string(),
			number: e.string(),
			number_suffix: e.string().optional(),
			box_number: e.string().optional(),
			region: e.string().optional(),
			state: e.string().optional(),
			cc: e.string().optional(),
			location_code: e.string(),
			retail_network_id: e.string().optional()
		}).nullish(),
		note: e.string().optional(),
		status: e.union([
			e.literal(1),
			e.literal(2),
			e.literal(3),
			e.literal(4),
			e.literal(5),
			e.literal(6),
			e.literal(7),
			e.literal(8)
		]).optional(),
		delivered: e.union([e.literal(0), e.literal(1)]).optional(),
		general_settings: e.object({ save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional() }).optional(),
		multi_collo_main_shipment_id: e.int().nullish(),
		hidden: e.union([e.literal(0), e.literal(1)]).optional(),
		shipped_items: e.array(e.object({
			order_line_identifier: e.string(),
			quantity: e.int().gte(1)
		})).min(0).optional()
	})).min(1).optional(),
	collection_contact: e.object({
		cc: e.string().length(2),
		city: e.string().min(1).max(255),
		company: e.string().nullish(),
		email: e.email().optional(),
		first_name: e.string().optional(),
		gender: e.enum(["mr", "mrs"]).optional(),
		last_name: e.string().optional(),
		number: e.union([e.string().min(1), e.int()]),
		number_suffix: e.string().nullish(),
		phone: e.string().min(8),
		postal_code: e.string().min(1),
		street: e.string().min(1),
		street_additional_info: e.string().nullish()
	}).optional(),
	hidden: e.union([e.literal(0), e.literal(1)]).optional(),
	shipped_items: e.array(e.object({
		order_line_identifier: e.string(),
		quantity: e.int().gte(1)
	})).min(0).optional()
})).min(1).max(100).optional() }) }), Ia = e.object({ data: e.object({ shipments: e.array(e.object({
	id: e.int(),
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	reference_identifier: e.union([e.int(), e.string().max(255).regex(/^[^=\?]*$/)]).optional(),
	carrier: S,
	status: e.int().optional(),
	delivered: e.union([e.literal(0), e.literal(1)]).optional(),
	recipient: e.object({
		cc: e.string().length(2),
		region: e.string().max(32).optional(),
		state: e.string().max(2).optional(),
		postal_code: e.string().max(10).optional(),
		city: e.string().max(35),
		street: e.string().max(40),
		street_additional_info: e.string().max(50).optional(),
		number: e.string().max(8).nullish(),
		number_suffix: e.string().max(6).nullish(),
		box_number: e.string().max(8).optional(),
		person: e.string().max(50),
		company: e.string().max(50).optional(),
		email: e.union([e.email(), e.string().max(0)]).optional(),
		secondary_emails: xa.optional(),
		phone: e.string().max(25).optional()
	}),
	sender: Sa.optional(),
	options: y.and(e.unknown()),
	customs_declaration: b.optional(),
	physical_properties: e.object({
		weight: e.int().gte(0).lte(999999999),
		height: e.int().optional(),
		width: e.int().optional(),
		length: e.int().optional(),
		volume: e.int().optional()
	}).optional(),
	pickup: Ca.optional(),
	note: e.string().optional(),
	general_settings: e.object({
		save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional(),
		delivery_notification: e.union([e.literal(0), e.literal(1)]).optional(),
		delivery_notification_email: e.array(e.string()).optional(),
		disable_auto_detect_pickup: e.union([e.literal(0), e.literal(1)]).optional(),
		printer_identifier: e.string().optional()
	}).optional(),
	hidden: e.union([e.literal(0), e.literal(1)]).optional()
})).min(1).max(100).optional() }) }), La = e.object({ data: e.object({ shipments: e.array(e.object({
	id: e.int(),
	hidden: e.union([e.literal(0), e.literal(1)]).optional(),
	status: h.optional(),
	delivered: e.union([e.literal(0), e.literal(1)]).optional()
})).min(1).max(100) }) }), Ra = e.enum([
	"RETAIL",
	"LOCKER",
	"POST_OFFICE"
]).register(e.globalRegistry, { description: "Pickup / drop-off location type used for capability and rates filtering." }), za = e.object({
	shopId: e.int().register(e.globalRegistry, { description: "The ID of the shop for which the capabilities are requested." }).optional(),
	contractId: e.int().register(e.globalRegistry, { description: "The ID of the contract for which the capabilities are requested." }).optional(),
	recipient: e.object({
		countryCode: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "Alpha-2 Country code of the recipient." }),
		postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code of the recipient." }).optional(),
		isBusiness: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Recipient data." }),
	sender: e.object({
		countryCode: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "Alpha-2 Country code of the sender." }).optional(),
		postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code of the sender." }).optional(),
		isBusiness: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Sender data." }).optional(),
	carrier: Gr.optional(),
	packageType: qr.optional(),
	physicalProperties: e.object({
		height: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The height value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The height of the package" }).optional(),
		width: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The width value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The width of the package" }).optional(),
		length: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The length value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The length of the package" }).optional(),
		weight: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The weight value" }),
			unit: e.enum(["g", "kg"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(e.globalRegistry, { description: "The weight of the package" }).optional()
	}).register(e.globalRegistry, { description: "Physical properties of the package." }).optional(),
	options: e.object({
		additionalInsurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Additional insurance option" }).optional(),
		deliverAtPostalPoint: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Deliver at postal point option" }).optional(),
		freshFood: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Fresh food delivery option" }).optional(),
		frozen: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Frozen delivery option" }).optional(),
		hideSender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Hide sender option" }).optional(),
		insurance: e.union([e.record(e.string(), e.never()), _]).optional(),
		noTracking: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Ship without track and trace option" }).optional(),
		oversizedPackage: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Oversized package option" }).optional(),
		printReturnLabelAtDropOff: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Print return label at drop off package option" }).optional(),
		priorityDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Priority delivery package option" }).optional(),
		recipientOnlyDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Recipient only delivery option" }).optional(),
		returnOnFirstFailedDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Return on first failed delivery option" }).optional(),
		requiresAgeVerification: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires age verification option" }).optional(),
		requiresCashOnDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Cash on delivery option" }).optional(),
		requiresReceiptCode: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires receipt code option" }).optional(),
		requiresSignature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires signature option" }).optional(),
		sameDayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Same day delivery option" }).optional(),
		saturdayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Saturday delivery option" }).optional(),
		scheduledCollection: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Scheduled collection option" }).optional()
	}).register(e.globalRegistry, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	deliveryType: e.enum([
		"EVENING_DELIVERY",
		"EXPRESS_DELIVERY",
		"EARLY_MORNING_DELIVERY",
		"MORNING_DELIVERY",
		"PICKUP_DELIVERY",
		"SAME_DAY_DELIVERY",
		"STANDARD_DELIVERY"
	]).optional(),
	direction: e.enum(["INBOUND", "OUTBOUND"]).register(e.globalRegistry, { description: "The shipment direction for which the capabilities are requested." }).optional(),
	pickup: e.object({ location: e.object({ type: Ra.optional() }).register(e.globalRegistry, { description: "Pickup location details." }).optional() }).register(e.globalRegistry, { description: "Pickup location criteria for filtering capabilities." }).optional()
}), Ba = e.object({ data: e.object({ capabilities: e.array(e.object({
	shop_id: e.int().register(e.globalRegistry, { description: "The ID of the shop for which the capabilities are requested." }).optional(),
	contract_id: e.int().register(e.globalRegistry, { description: "The ID of the contract for which the capabilities are requested." }).optional(),
	recipient: e.object({
		cc: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "Alpha-2 Country code of the recipient." }),
		postal_code: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code of the recipient." }).optional(),
		is_business: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Recipient data." }),
	sender: e.object({
		cc: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "Alpha-2 Country code of the sender." }).optional(),
		postal_code: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code of the sender." }).optional(),
		is_business: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Sender data." }).optional(),
	carrier_id: ai.optional(),
	package_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7)
	]).optional(),
	physical_properties: e.object({
		height: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The height value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The height of the package" }).optional(),
		width: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The width value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The width of the package" }).optional(),
		length: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The length value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The length of the package" }).optional(),
		weight: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The weight value" }),
			unit: e.enum(["g", "kg"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(e.globalRegistry, { description: "The weight of the package" }).optional()
	}).register(e.globalRegistry, { description: "Physical properties of the package." }).optional(),
	options: e.object({
		age_check: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires age verification option" }).optional(),
		cash_on_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Cash on delivery option" }).optional(),
		collect: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Scheduled collection option" }).optional(),
		drop_off_at_postal_point: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Deliver at postal point option" }).optional(),
		extra_assurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Additional insurance option" }).optional(),
		fresh_food: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Fresh food delivery option" }).optional(),
		frozen: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Frozen delivery option" }).optional(),
		hide_sender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Hide sender option" }).optional(),
		large_format: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Oversized package option" }).optional(),
		no_tracking: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Ship without track and trace option" }).optional(),
		only_recipient: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Recipient only delivery option" }).optional(),
		priority_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Priority delivery option" }).optional(),
		printerless_return: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Printerless return delivery option" }).optional(),
		receipt_code: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires receipt code option" }).optional(),
		return: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Return on first failed delivery option" }).optional(),
		same_day_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Same day delivery option" }).optional(),
		saturday_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Saturday delivery option" }).optional(),
		signature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires signature option" }).optional(),
		tracked: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "DEPRECATED: replaced by no_tracking (its inverse)." }).optional(),
		insurance: e.union([e.record(e.string(), e.never()), _]).optional()
	}).register(e.globalRegistry, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	delivery_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7),
		e.literal(8)
	]).optional(),
	shipment_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7),
		e.literal(8)
	]).optional(),
	direction: e.enum(["INBOUND", "OUTBOUND"]).register(e.globalRegistry, { description: "The shipment direction for which the capabilities are requested." }).optional(),
	pickup: e.object({ location_type: Re.optional() }).register(e.globalRegistry, { description: "Pickup location criteria for filtering capabilities." }).optional()
})) }) }), Va = e.object({ carrier: e.enum([
	"BRT",
	"DHL_EUROPLUS",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"DHL_FOR_YOU",
	"INPOST",
	"POSTNL"
]).optional() }), Ha = e.object({ data: e.object({ carrier_id: e.union([
	e.literal(1),
	e.literal(4),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(15),
	e.literal(17)
]).optional() }).optional() }), Ua = e.object({
	city: e.string().min(1).max(100).register(e.globalRegistry, { description: "The city of the address." }).optional(),
	countryCode: e.string().length(2).regex(/[A-Z]{2}/).register(e.globalRegistry, { description: "The country code (ISO 3166-1 alpha-2) of the address." }),
	street: e.string().min(1).max(100).register(e.globalRegistry, { description: "The street of the address." }).optional(),
	additionalInformation: e.string().min(1).max(100).register(e.globalRegistry, { description: "Additional information about the address." }).optional(),
	boxNumber: e.string().min(1).max(20).register(e.globalRegistry, { description: "The box number of the address. Only applicable for `countryCode`=`BE`." }).optional(),
	houseNumber: e.string().min(1).max(25).register(e.globalRegistry, { description: "The house number of the address." }).optional(),
	houseNumberSuffix: e.string().min(1).max(25).register(e.globalRegistry, { description: "The house number suffix of the address." }).optional(),
	postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "The postal code of the address." }).optional(),
	region: e.string().min(1).max(100).register(e.globalRegistry, { description: "The region of the address." }).optional(),
	state: e.string().min(1).max(100).register(e.globalRegistry, { description: "The state of the address." }).optional()
}), Wa = e.object({
	name: e.string().min(1).max(200).register(e.globalRegistry, { description: "The name of the pickup location." }),
	code: e.string().min(1).max(64).register(e.globalRegistry, { description: "The location code of the pickup location." }).optional(),
	type: Ra.optional()
}), Ga = e.object({
	address: Ua,
	location: Wa,
	retailNetworkId: e.enum(["PNPNL-01", "PNPBE-01"]).register(e.globalRegistry, { description: "PostNL Retail network ID." }).optional()
}).register(e.globalRegistry, { description: "Pickup location data." }), Ka = e.object({
	shopId: e.int().register(e.globalRegistry, { description: "The ID of the shop for which the rates are requested." }).optional(),
	contractId: e.int().register(e.globalRegistry, { description: "The ID of the contract for which the rates are requested." }).optional(),
	recipient: e.object({
		countryCode: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "Alpha-2 Country code of the recipient." }),
		postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code of the recipient." }).optional(),
		isBusiness: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Recipient data." }),
	sender: e.object({
		countryCode: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "Alpha-2 Country code of the sender." }).optional(),
		postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code of the sender." }).optional(),
		isBusiness: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Sender data." }).optional(),
	pickup: Ga.optional(),
	carrier: Gr,
	packageType: qr,
	physicalProperties: e.object({
		height: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The height value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The height of the package" }).optional(),
		width: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The width value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The width of the package" }).optional(),
		length: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The length value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The length of the package" }).optional(),
		weight: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The weight value" }),
			unit: e.enum(["g", "kg"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(e.globalRegistry, { description: "The weight of the package" }).optional()
	}).register(e.globalRegistry, { description: "Physical properties of the package." }).optional(),
	options: e.object({
		additionalInsurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Additional insurance option" }).optional(),
		deliverAtPostalPoint: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Deliver at postal point option" }).optional(),
		freshFood: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Fresh food option" }).optional(),
		frozen: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Frozen option" }).optional(),
		hideSender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Hide sender option" }).optional(),
		insurance: e.union([e.object({ insuredAmount: _ }).register(e.globalRegistry, { description: "Deprecated. Use options.insurance.{amount, currency} directly. Will be removed in a future release." }), _]).optional(),
		noTracking: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Ship without track and trace option" }).optional(),
		oversizedPackage: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Oversized package option" }).optional(),
		priorityDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Priority delivery package option" }).optional(),
		recipientOnlyDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Recipient only delivery option" }).optional(),
		returnOnFirstFailedDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Return on first failed delivery option" }).optional(),
		requiresAgeVerification: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires age verification option" }).optional(),
		requiresCashOnDelivery: e.object({ dueAmount: _ }).register(e.globalRegistry, { description: "Cash on delivery option" }).optional(),
		requiresReceiptCode: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires receipt code option" }).optional(),
		requiresSignature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires signature option" }).optional(),
		sameDayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Same day delivery option" }).optional(),
		saturdayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Saturday delivery option" }).optional(),
		scheduledCollection: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Scheduled collection option" }).optional()
	}).register(e.globalRegistry, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	deliveryType: e.enum([
		"EARLY_MORNING_DELIVERY",
		"EVENING_DELIVERY",
		"EXPRESS_DELIVERY",
		"MORNING_DELIVERY",
		"PICKUP_DELIVERY",
		"SAME_DAY_DELIVERY",
		"STANDARD_DELIVERY"
	]).optional(),
	direction: e.enum(["INBOUND", "OUTBOUND"]).register(e.globalRegistry, { description: "The shipment direction for which the rates are requested." }).optional(),
	collo: e.int().gte(1).register(e.globalRegistry, { description: "The number of collo for which the rates are requested." }).optional()
}), qa = e.object({ data: e.object({ rates: e.array(e.object({
	shop_id: e.int().register(e.globalRegistry, { description: "The ID of the shop for which the rates are requested." }).optional(),
	contract_id: e.int().register(e.globalRegistry, { description: "The ID of the contract for which the rates are requested." }).optional(),
	recipient: e.object({
		cc: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "Alpha-2 Country code of the recipient." }),
		postal_code: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code of the recipient." }).optional(),
		is_business: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Recipient data." }),
	sender: e.object({
		cc: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "Alpha-2 Country code of the sender." }).optional(),
		postal_code: e.string().min(1).max(15).register(e.globalRegistry, { description: "Postal code of the sender." }).optional(),
		is_business: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Sender data." }).optional(),
	pickup: Be.optional(),
	carrier_id: ai,
	package_type: v,
	physical_properties: e.object({
		height: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The height value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The height of the package" }).optional(),
		width: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The width value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The width of the package" }).optional(),
		length: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The length value" }),
			unit: e.enum(["cm", "mm"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The length of the package" }).optional(),
		weight: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The weight value" }),
			unit: e.enum(["g", "kg"]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(e.globalRegistry, { description: "The weight of the package" }).optional()
	}).register(e.globalRegistry, { description: "Physical properties of the package." }).optional(),
	options: e.object({
		age_check: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires age verification option" }).optional(),
		cash_on_delivery: e.object({ due_amount: _ }).register(e.globalRegistry, { description: "Cash on delivery option" }).optional(),
		collect: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Scheduled collection option" }).optional(),
		cooled_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Cooled delivery option" }).optional(),
		drop_off_at_postal_point: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Deliver at postal point option" }).optional(),
		extra_assurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Additional insurance option" }).optional(),
		hide_sender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Hide sender option" }).optional(),
		large_format: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Oversized package option" }).optional(),
		no_tracking: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Ship without track and trace option" }).optional(),
		only_recipient: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Recipient only delivery option" }).optional(),
		priority_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Priority delivery option" }).optional(),
		receipt_code: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires receipt code option" }).optional(),
		return: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Return on first failed delivery option" }).optional(),
		same_day_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Same day delivery option" }).optional(),
		saturday_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Saturday delivery option" }).optional(),
		signature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires signature option" }).optional(),
		tracked: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "DEPRECATED: replaced by no_tracking (its inverse)." }).optional(),
		insurance: e.union([e.object({ insured_amount: _ }).register(e.globalRegistry, { description: "Deprecated. Use options.insurance.{amount, currency} directly. Will be removed in a future release." }), _]).optional()
	}).register(e.globalRegistry, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	delivery_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7),
		e.literal(8)
	]).optional(),
	shipment_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7),
		e.literal(8)
	]).optional(),
	direction: e.enum(["INBOUND", "OUTBOUND"]).register(e.globalRegistry, { description: "The shipment direction for which the rates are requested." }).optional(),
	collo: e.int().gte(1).register(e.globalRegistry, { description: "The number of collo for which the rates are requested." }).optional()
})).min(1) }) }), Ja = e.union([e.object({
	shopId: e.int(),
	packageType: e.enum([
		"DIGITAL_STAMP",
		"ENVELOPE",
		"UNFRANKED",
		"MAILBOX",
		"PACKAGE",
		"PALLET",
		"SMALL_PACKAGE"
	]),
	countryCode: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 country code" }),
	shipmentDirection: e.enum(["OUTBOUND"])
}), e.object({
	shopId: e.int(),
	packageType: e.null().optional(),
	countryCode: e.string().length(2).regex(/^[A-Z]{2}$/).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 country code" }).optional(),
	shipmentDirection: e.enum(["INBOUND"])
})]), Ya = e.object({
	body: e.string().min(1),
	subject: e.string().min(1).max(255)
}), Xa = e.object({
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	hook: e.string(),
	url: e.string(),
	payload: e.string().nullish()
}), Za = e.object({ data: e.object({ webhook_subscriptions: e.array(Xa).min(1).optional() }) }), Qa = e.object({
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	hook: e.string(),
	url: e.string()
}), $a = e.object({ data: e.object({ webhook_subscriptions: e.array(Qa).min(1).optional() }) }), eo = e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }), to = Ui, no = Ki, ro = Wi, io = e.string().nullable(), ao = e.string().nullable(), oo = qi, so = Ji, co = e.iso.date().register(e.globalRegistry, { description: "When set, only resources created after this date will be returned. Inclusive." }), lo = P, uo = P, fo = F.nullable(), po = Yi, mo = Xi, ho = Zi, go = Qi, _o = e.int().gte(-1).lte(14).nullable(), vo = e.int().gte(0).nullable(), yo = $i, bo = e.int().gte(0).lte(14).nullable(), xo = e.boolean().register(e.globalRegistry, { description: "Use this parameter to only show Shipments that need to be dropped off today." }), So = ta, Co = F.nullable(), wo = e.string().nullable(), To = e.boolean(), Eo = e.union([na, e.string().regex(/^[Aa][46]$/)]), Do = Yi, Oo = e.boolean(), ko = ra, Ao = e.int().nullable(), jo = e.boolean(), Mo = e.string().nullable(), No = ia, Po = P, Fo = P, Io = F.nullable(), Lo = e.string().nullable(), Ro = e.union([aa, e.string().regex(/^([Aa][Ss][Cc]|[Dd][Ee][Ss][Cc])$/)]), zo = oa, Bo = sa, Vo = ua, Ho = fa, Uo = pa, Wo = e.string().nullable(), Go = e.string().nullable(), Ko = e.string().register(e.globalRegistry, { description: "Filter by `reference_identifier`, an optional arbitrary identifier to identify the Shipment." }), qo = e.string().register(e.globalRegistry, { description: "The region, department, state or province of the address." }), Jo = I, Yo = ha, Xo = L, Zo = L, Qo = _a, $o = va, es = e.enum(["asc", "desc"]).register(e.globalRegistry, { description: "Sort order. Defaults to `desc`." }), ts = ya, ns = e.string().nullable(), rs = Ui, is = ba, as = tt, os = e.int().register(e.globalRegistry, { description: "The ID of the notification group." }), ss = e.string().register(e.globalRegistry, { description: "One or more notification group IDs. Separate multiple IDs using `;`." }), cs = e.int().register(e.globalRegistry, { description: "The ID of the notification template." }), ls = e.string().register(e.globalRegistry, { description: "Filter by webhook event type." }), us = I, ds = wa, fs = Fa, ps = La, ms = za, hs = Va, gs = Ka, _s = Ja, vs = Ya, ys = Za, bs = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), xs = e.object({
	title: e.string().optional(),
	status: e.string()
}).register(e.globalRegistry, { description: "Status is OK" }), Ss = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		cc: e.string().nullish(),
		postal_code: pa.optional(),
		number: e.string().nullish(),
		city: e.string().nullish(),
		street: e.string().nullish(),
		platform: ua.optional(),
		shop_id: L.optional(),
		carrier: Ki.optional(),
		delivery_date: Xi.optional(),
		delivery_time: Zi.optional(),
		cutoff_time: P.optional(),
		dropoff_days: $i.optional(),
		monday_delivery: F.nullish(),
		dropoff_delay: e.int().gte(0).lte(14).nullish(),
		deliverydays_window: e.int().gte(-1).lte(14).nullish(),
		exclude_delivery_type: ta.optional(),
		exclude_parcel_lockers: F.nullish(),
		latitude: ra.optional(),
		longitude: ia.optional()
	}).optional()
}), Cs = Gn, ws = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		postal_code: pa.optional(),
		number: e.string().nullish(),
		distance: e.int().gte(0).nullish(),
		cc: e.string().nullish(),
		limit: e.int().nullish(),
		carrier_id: Wi.optional(),
		shop_id: L.optional(),
		reference: e.string().nullish(),
		location_name: e.string().nullish(),
		external_identifier: e.string().nullish(),
		city: e.string().nullish(),
		cut_off_time: P.optional(),
		min_cut_off_time: P.optional(),
		max_cut_off_time: P.optional(),
		latitude: ra.optional(),
		longitude: ia.optional(),
		exclude_parcel_lockers: F.nullish()
	}).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Ts = _r, Es = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		cc: e.string().nullish(),
		postal_code: pa.optional(),
		number: e.string().nullish(),
		city: e.string().nullish(),
		street: e.string().nullish(),
		platform: ua.optional(),
		shop_id: L.optional(),
		carrier: Ki.optional(),
		delivery_date: Xi.optional(),
		delivery_time: Zi.optional(),
		cutoff_time: P.optional(),
		dropoff_days: $i.optional(),
		monday_delivery: F.nullish(),
		dropoff_delay: e.int().gte(0).lte(14).nullish(),
		deliverydays_window: e.int().gte(-1).lte(14).nullish(),
		exclude_delivery_type: ta.optional(),
		exclude_parcel_lockers: F.nullish(),
		latitude: ra.optional(),
		longitude: ia.optional()
	}).optional()
}), Ds = Dr, Os = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), ks = lr, As = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		barcode: Ui.optional(),
		carrier_id: Wi.optional(),
		created: e.iso.date().register(e.globalRegistry, { description: "When set, only resources created after this date will be returned. Inclusive." }).optional(),
		delayed: F.nullish(),
		delivered: Yi.optional(),
		dropoff_today: e.boolean().register(e.globalRegistry, { description: "Use this parameter to only show Shipments that need to be dropped off today." }).optional(),
		filter_hidden_shops: e.boolean().optional(),
		hidden: Yi.optional(),
		link_consumer_portal: e.boolean().optional(),
		order: e.union([aa, e.string().regex(/^([Aa][Ss][Cc]|[Dd][Ee][Ss][Cc])$/)]).optional(),
		package_type: oa.optional(),
		page: sa.optional(),
		q: e.string().nullish(),
		reference_identifier: e.string().register(e.globalRegistry, { description: "Filter by `reference_identifier`, an optional arbitrary identifier to identify the Shipment." }).optional(),
		region: e.string().register(e.globalRegistry, { description: "The region, department, state or province of the address." }).optional(),
		shipment_type: ha.optional(),
		shop_id: L.optional(),
		size: _a.optional(),
		sort: va.optional(),
		status: ya.optional(),
		transaction_status: tt.optional()
	}).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), js = Pr, Ms = e.object({
	body: ps,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Ns = e.void().register(e.globalRegistry, { description: "Shipment patch was successful." }), Ps = e.object({
	body: ds,
	path: e.never().optional(),
	query: e.object({
		format: e.union([na, e.string().regex(/^[Aa][46]$/)]).optional(),
		positions: fa.optional(),
		collect_date: qi.optional(),
		delivery_options_identifier: Qi.optional()
	}).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Fs = Or, Is = e.object({
	body: fs,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Ls = e.union([Dn, e.void().register(e.globalRegistry, { description: "Shipment update was successful." })]), Rs = e.object({
	body: e.never().optional(),
	path: e.object({ ids: I }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), zs = e.void().register(e.globalRegistry, { description: "Shipment deletion was successful." }), Bs = e.object({
	body: e.never().optional(),
	path: e.object({ ids: I }),
	query: e.object({ link_consumer_portal: e.boolean().optional() }).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Vs = Pr, Hs = e.object({
	body: ms,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Us = ii, Ws = e.object({
	body: hs,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Gs = _i, Ks = e.object({
	body: gs,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), qs = e.union([Ei, e.void().register(e.globalRegistry, { description: "This response is given when the request is successful and the response is empty." })]), Js = e.object({
	body: e.never().optional(),
	path: e.object({ ids: I }),
	query: e.object({
		format: e.union([na, e.string().regex(/^[Aa][46]$/)]).optional(),
		positions: fa.optional(),
		collect_date: qi.optional(),
		delivery_options_identifier: Qi.optional()
	}).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Ys = e.union([e.void().register(e.globalRegistry, { description: "Direct Printing Response" }), An]), Xs = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		barcode: Ui.optional(),
		country_code: Ji.optional(),
		external_identifier: Ui.optional(),
		extra_info: ba.optional(),
		postal_code: pa.optional(),
		sort: e.enum(["asc", "desc"]).register(e.globalRegistry, { description: "Sort order. Defaults to `desc`." }).optional()
	}).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Zs = Wr, Qs = e.object({
	body: e.never().optional(),
	path: e.object({ ids: I }),
	query: e.object({
		sort: e.enum(["asc", "desc"]).register(e.globalRegistry, { description: "Sort order. Defaults to `desc`." }).optional(),
		extra_info: ba.optional()
	}).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), $s = Wr, ec = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({ shopId: L.optional() }).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), tc = Pi, nc = e.object({
	body: _s,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), rc = Pi, ic = e.object({
	body: e.never().optional(),
	path: e.object({ ids: e.string().register(e.globalRegistry, { description: "One or more notification group IDs. Separate multiple IDs using `;`." }) }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), ac = e.void().register(e.globalRegistry, { description: "Notification group deletion was successful." }), oc = e.object({
	body: e.never().optional(),
	path: e.object({ notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }) }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), sc = Li, cc = e.object({
	body: vs,
	path: e.object({
		notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }),
		notification_template_id: e.int().register(e.globalRegistry, { description: "The ID of the notification template." })
	}),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), lc = e.void().register(e.globalRegistry, { description: "Notification template update was successful." }), uc = e.object({
	body: e.never().optional(),
	path: e.object({ notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }) }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), dc = e.void().register(e.globalRegistry, { description: "Disabling notification templates was successful." }), fc = e.object({
	body: e.never().optional(),
	path: e.object({ notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }) }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), pc = e.void().register(e.globalRegistry, { description: "Enabling notification templates was successful." }), mc = e.object({
	body: e.never().optional(),
	path: e.object({
		notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }),
		notification_template_id: e.int().register(e.globalRegistry, { description: "The ID of the notification template." })
	}),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), hc = e.void().register(e.globalRegistry, { description: "Disabling notification template was successful." }), gc = e.object({
	body: e.never().optional(),
	path: e.object({
		notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }),
		notification_template_id: e.int().register(e.globalRegistry, { description: "The ID of the notification template." })
	}),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), _c = e.void().register(e.globalRegistry, { description: "Enabling notification template was successful." }), vc = e.object({
	body: e.never().optional(),
	path: e.object({
		notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }),
		notification_template_id: e.int().register(e.globalRegistry, { description: "The ID of the notification template." })
	}),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), yc = e.void().register(e.globalRegistry, { description: "Test notification was successfully send." }), bc = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({ hook: e.string().register(e.globalRegistry, { description: "Filter by webhook event type." }).optional() }).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), xc = zi, Sc = e.object({
	body: ys,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Cc = Hi, wc = e.object({
	body: e.never().optional(),
	path: e.object({ ids: I }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Tc = e.void().register(e.globalRegistry, { description: "Webhook subscription deletion was successful." }), Ec = e.object({
	body: e.never().optional(),
	path: e.object({ ids: I }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
}), Dc = zi, Oc = e.int().gte(400).lte(499).register(e.globalRegistry, { description: "The request contains bad syntax or cannot be fulfilled" }), kc = e.union([
	e.literal(3e3),
	e.literal(3001),
	e.literal(3002),
	e.literal(3003),
	e.literal(3004),
	e.literal(3005),
	e.literal(3006),
	e.literal(3007)
]).register(e.globalRegistry, { description: "Authentication and Authorization related error codes" }), Ac = e.union([kc, e.int()]), jc = e.object({
	status: Oc.optional(),
	code: Ac.optional(),
	title: e.string().optional(),
	message: e.string().optional()
}), Mc = e.object({
	message: e.string(),
	request_id: e.string().register(e.globalRegistry, { description: "Internal request ID, useful for debugging purposes." }),
	status_code: Oc,
	errors: e.union([e.array(jc), e.record(e.string(), jc)])
}), Nc = e.literal(404).register(e.globalRegistry, { description: "Did not find the requested target resource." });
Mc.and(e.object({
	status_code: Nc.optional(),
	errors: e.array(e.object({
		status: Nc.optional(),
		code: e.int().optional()
	})).optional()
}));
var R = e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).register(e.globalRegistry, { description: "Unique ID of a Shipment." }), Pc = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), Fc = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), Ic = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7),
	e.literal(8)
]), Lc = e.string(), Rc = e.union([e.union([e.enum([""]), e.string()]), e.unknown()]).nullable(), zc = e.union([e.unknown(), e.union([e.enum([""]), e.string()])]).nullable(), Bc = e.object({
	account_id: Pc.optional(),
	person: e.string().optional(),
	first_name: e.string().optional(),
	last_name: e.string().optional(),
	company: e.string().nullish(),
	street: e.string().optional(),
	street_additional_info: e.string().nullish(),
	number: e.string().nullish(),
	number_suffix: e.string().nullish(),
	postal_code: e.string().optional(),
	city: e.string().optional(),
	state: e.string().optional(),
	cc: Lc,
	region: e.string().nullish(),
	area: e.string().optional(),
	phone: e.string().nullish(),
	email: e.union([e.unknown(), e.union([e.enum([""]), e.string()])]).nullish(),
	billing_email: Rc.optional(),
	secondary_emails: e.array(zc).nullish(),
	box_number: e.string().nullish(),
	eori_number: e.string().optional(),
	vat_number: e.string().optional(),
	invalid: e.boolean().optional()
}), Vc = Bc.and(e.object({
	person: e.unknown().optional(),
	first_name: e.string().optional(),
	last_name: e.string().optional(),
	company: e.unknown().optional(),
	street: e.unknown().optional(),
	street_additional_info: e.unknown().optional(),
	number: e.unknown().optional(),
	number_suffix: e.unknown().optional(),
	postal_code: e.unknown().optional(),
	city: e.unknown().optional(),
	state: e.unknown().optional(),
	area: e.unknown().optional(),
	phone: e.unknown().optional()
})), Hc = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7),
	e.literal(8),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(12),
	e.literal(13),
	e.literal(14),
	e.literal(15),
	e.literal(16),
	e.literal(17),
	e.literal(18),
	e.literal(19),
	e.literal(98),
	e.literal(99),
	e.literal(100),
	e.literal(101),
	e.literal(30),
	e.literal(31),
	e.literal(32),
	e.literal(33),
	e.literal(34),
	e.literal(35),
	e.literal(36),
	e.literal(37),
	e.literal(38)
]), Uc = e.object({
	currency: e.union([e.enum(["EUR"]), e.string()]),
	amount: e.int().gte(0)
}), Wc = e.object({ insurance: Uc.optional() }).and(e.object({ insurance: e.object({ amount: e.unknown().optional() }).optional() })), z = e.union([e.literal(0), e.literal(1)]), B = e.object({
	currency: e.union([e.enum(["", "EUR"]), e.string()]).register(e.globalRegistry, { description: "The currency as uppercase 3-letter ISO 4217 code." }),
	amount: e.union([e.int().gte(0), e.string()])
}).register(e.globalRegistry, { description: "Money amount with currency" }), Gc = e.object({
	age_check: z.optional(),
	cash_on_delivery: B.optional(),
	collect: z.optional(),
	cooled_delivery: z.optional(),
	drop_off_at_postal_point: z.optional(),
	extra_assurance: z.optional(),
	fresh_food: z.optional(),
	frozen: z.optional(),
	hide_sender: z.optional(),
	large_format: z.optional(),
	no_tracking: z.optional(),
	only_recipient: z.optional(),
	priority_delivery: z.optional(),
	receipt_code: z.optional(),
	return: z.optional(),
	same_day_delivery: z.optional(),
	saturday_delivery: z.optional(),
	signature: z.optional(),
	tracked: z.optional()
}), Kc = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7)
]).register(e.globalRegistry, { description: "Package Type." }), qc = e.object({ package_type: Kc.optional() }), Jc = e.object({ delivery_type: e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7),
	e.literal(8)
]).nullish() }), Yc = e.object({ delivery_date: e.string().nullish() }), Xc = e.object({ label_description: e.string().nullish() }), V = Wc.and(Gc).and(qc).and(Jc).and(Yc).and(Xc), Zc = e.object({
	save_recipient_address: z.optional(),
	delivery_notification: z.optional(),
	delivery_notification_email: e.array(e.email()).optional(),
	disable_auto_detect_pickup: z.optional(),
	printer_identifier: e.string().optional(),
	tracktrace: e.object({
		bcc: z.optional(),
		bcc_email: Rc.optional(),
		carrier_email_basic_notification: z.optional(),
		delivery_notification: z.optional(),
		delivery_notification_email: e.array(e.string()).optional(),
		disable_auto_detect_pickup: z.optional(),
		email_on_handed_to_courier: z.optional(),
		from_address_company: e.string().optional(),
		from_address_email: e.union([e.unknown(), e.union([e.enum([""]), e.string()])]).optional(),
		printer_identifier: e.string().optional(),
		save_recipient_address: z.optional(),
		send_track_trace_emails: z.optional()
	}).optional()
}).nullable(), Qc = e.union([e.enum([
	"retail",
	"locker",
	"post_office"
]), e.string()]).register(e.globalRegistry, { description: "Pickup / drop-off location type." }), $c = e.union([
	e.literal(0),
	e.literal(1),
	e.literal(2),
	e.literal(4),
	e.literal(8),
	e.literal(16)
]), el = e.object({
	location_code: e.string().optional(),
	location_name: e.string().optional(),
	street: e.string().optional(),
	number: e.string().optional(),
	number_suffix: e.string().nullish(),
	postal_code: e.string().optional(),
	city: e.string().optional(),
	cc: e.string().optional(),
	location_type: e.union([Qc, $c]).optional(),
	retail_network_id: e.string().optional()
}).nullable(), tl = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5)
]), nl = e.object({
	description: e.string(),
	amount: e.int().gte(1).lte(99999),
	weight: e.int().gte(0).lte(999999999),
	item_value: B,
	classification: e.string(),
	country: e.union([e.unknown(), e.union([e.enum([""]), e.string()])]).optional()
}), H = e.object({
	contents: tl,
	invoice: e.string().nullish(),
	eori_number: e.string().nullish(),
	vat_number: e.string().nullish(),
	vat_number_uk: e.string().nullish(),
	voec_number: e.string().nullish(),
	weight: e.int().gte(0).lte(999999999),
	items: e.array(nl)
}), rl = e.int().gte(0).lte(999999999), il = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), al = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), ol = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), sl = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }), cl = rl, ll = il.nullable(), ul = al.nullable(), dl = ol.nullable(), fl = sl.nullable(), pl = e.object({
	weight: rl.optional(),
	height: il.nullish(),
	width: al.nullish(),
	length: ol.nullish(),
	volume: sl.nullish(),
	carrier_weight: e.union([cl, e.string()]).nullish(),
	carrier_height: ll.nullish(),
	carrier_width: ul.nullish(),
	carrier_length: dl.nullish(),
	carrier_volume: fl.nullish()
}).nullable(), ml = e.union([e.int(), e.string()]).nullable(), hl = e.union([e.enum([
	"pending",
	"unpaid",
	"paid"
]), e.string()]).nullable(), gl = el, _l = e.union([e.enum(["", "EUR"]), e.string()]).register(e.globalRegistry, { description: "The currency as uppercase 3-letter ISO 4217 code." }), vl = e.union([e.int().gte(0), e.string()]), U = e.object({
	currency: _l,
	amount: vl.nullable()
}).register(e.globalRegistry, { description: "Money amount with currency, where the amount may be null. The amount is null when the requester lacks permission to read price amounts (Permissions::BILLING_READ_PRICE_AMOUNTS)." }), yl = e.union([e.enum([
	"Facebook",
	"Flespakket.nl",
	"Amazon",
	"Bol.com",
	"MyParcel.nl",
	"Wix",
	"Ecwid",
	"Exact Online DE",
	"Exact Online NL",
	"Etsy"
]), e.string()]), bl = e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }), xl = e.union([e.enum([
	"pending",
	"unpaid",
	"paid"
]), e.string()]).nullable(), W = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7),
	e.literal(8),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(12),
	e.literal(13),
	e.literal(14),
	e.literal(15),
	e.literal(16),
	e.literal(17),
	e.literal(18),
	e.literal(19),
	e.literal(20),
	e.literal(21)
]).register(e.globalRegistry, { description: "This enumeration represents the Carriers. The value is the Carrier id." }), Sl = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6)
]), Cl = e.string(), wl = e.string().nullable(), Tl = R.nullable(), El = Pc, Dl = Fc, Ol = Ic, kl = Vc, Al = Bc, jl = Hc, Ml = V.and(e.unknown()), Nl = Zc, Pl = el, Fl = H.nullable(), Il = pl, Ll = ml, Rl = hl, zl = gl, Bl = z, Vl = U, Hl = e.string(), Ul = e.union([e.unknown(), e.union([e.enum(["Wereld"]), e.string()])]), Wl = yl.nullable(), Gl = bl.nullable(), Kl = xl, ql = W, Jl = Sl, Yl = Cl.nullable(), Xl = wl, Zl = e.string(), Ql = e.string(), $l = e.union([e.string(), e.int()]), eu = e.string(), tu = e.string(), nu = e.string(), ru = e.string(), iu = e.string(), au = e.string().nullable(), ou = e.object({
	id: e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).optional(),
	gender: e.string().nullish(),
	first_name: e.string().nullish(),
	last_name: e.string().nullable(),
	email: e.union([e.union([e.enum([""]), e.string()]), e.unknown()]).nullable(),
	phone: e.string().nullable(),
	company: e.string().nullable(),
	street: Zl,
	street_additional_info: Ql.optional(),
	number: $l,
	number_suffix: eu.optional(),
	postal_code: tu,
	city: nu,
	cc: ru,
	region: iu.optional(),
	box_number: au.optional()
}), su = ou.nullable(), cu = R.nullable(), lu = e.string().nullable(), uu = lu, du = e.boolean().default(!1), fu = e.boolean().default(!1), pu = e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).nullable(), mu = e.union([e.enum(["", "EUR"]), e.string()]), hu = mu.nullable(), gu = e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).nullable(), _u = e.union([e.unknown(), e.union([e.enum([""]), e.string()])]).nullable(), vu = e.array(e.object({
	uri: e.union([e.union([e.enum([""]), e.string()]), e.unknown()]),
	barcode: e.string()
})), yu = vu, bu = e.string().nullable(), xu = e.uuid().max(36).nullable(), Su = e.int().nullable(), Cu = e.string().nullable(), wu = e.record(e.string(), e.unknown()).nullable(), Tu = e.string().nullable(), Eu = e.object({
	quantity: Su.optional(),
	order_line_identifier: Cu.optional(),
	order_line: wu.optional(),
	picklist_identifier: Tu.optional(),
	order_identifier: e.string().nullish()
}).nullable(), Du = e.array(Eu).nullable(), Ou = e.string().register(e.globalRegistry, { description: "Represents a date in ISO 8601 format and a time in ISO 8601 format, separated\nby a space, so:\n\n```\nYYYY-MM-DD hh:mm:ss.u\n```\n\nWhere:\n  - `YYYY` represents a four-digit year, `0000` through `9999`\n  - `MM` represents a zero-padded month of the year, `01` through `12`\n  - `DD` represents a zero-padded day of that month, `01` through `31`\nand:\n  - `hh` represents a zero-padded hour, `00` through `24`\n  - `mm` represents a zero-padded minute, `00` through `59`\n  - `ss` (optional) represents a zero-padded second, `00` through `60`\n    (where `60` is only used to denote an added leap second)\n  - `.u` (optional) represents a fraction of a second, `.0` through `.999999+`\n" }), ku = Ou, Au = ku, ju = Ou, Mu = ju, Nu = e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }), Pu = Nu.nullable(), Fu = Pu, Iu = Nu.nullable(), Lu = Iu, Ru = e.object({
	id: e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).register(e.globalRegistry, { description: "Unique ID of a Shipment." }),
	parent_id: R.nullable(),
	account_id: Pc,
	shop_id: Fc,
	shipment_type: Ic,
	recipient: Vc,
	sender: Bc,
	status: Hc,
	options: V.and(e.unknown()),
	general_settings: Zc,
	pickup: el,
	customs_declaration: H.nullable(),
	physical_properties: pl,
	reference_identifier: ml,
	transaction_status: hl,
	drop_off_point: gl,
	hidden: z,
	price: U,
	barcode: e.string(),
	region: e.union([e.unknown(), e.union([e.enum(["Wereld"]), e.string()])]),
	external_provider: yl.nullable(),
	external_provider_id: bl.nullable(),
	payment_status: xl,
	carrier_id: W,
	platform_id: Sl,
	origin: Cl.nullable(),
	user_agent: wl,
	secondary_shipments: e.array(e.object({
		id: R,
		parent_id: Tl,
		account_id: El,
		shop_id: Dl,
		shipment_type: Ol,
		recipient: kl,
		sender: Al,
		status: jl,
		options: Ml,
		general_settings: Nl,
		pickup: Pl,
		customs_declaration: Fl,
		physical_properties: Il,
		reference_identifier: Ll,
		transaction_status: Rl,
		drop_off_point: zl,
		hidden: Bl,
		price: Vl,
		barcode: Hl,
		region: Ul,
		external_provider: Wl,
		external_provider_id: Gl,
		payment_status: Kl,
		carrier_id: ql,
		platform_id: Jl,
		origin: Yl,
		user_agent: Xl,
		secondary_shipments: e.array(e.unknown()).max(0).nullish(),
		collection_contact: su,
		multi_collo_main_shipment_id: cu,
		external_identifier: uu,
		delayed: du,
		delivered: fu,
		amount: pu.optional(),
		currency: hu.optional(),
		contract_id: gu,
		link_consumer_portal: _u.optional(),
		partner_tracktraces: yu.optional(),
		pickup_request_number: bu.optional(),
		order_shipment_identifier: xu.optional(),
		shipped_items: Du.optional(),
		created: Au,
		modified: Mu,
		created_by: Fu,
		modified_by: Lu
	})),
	collection_contact: ou.nullable(),
	multi_collo_main_shipment_id: R.nullable(),
	external_identifier: lu,
	delayed: e.boolean().default(!1),
	delivered: e.boolean().default(!1),
	amount: e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).nullish(),
	currency: mu.nullish(),
	contract_id: e.coerce.bigint().min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" }).max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" }).nullable(),
	link_consumer_portal: e.union([e.unknown(), e.union([e.enum([""]), e.string()])]).nullish(),
	partner_tracktraces: vu.optional(),
	pickup_request_number: e.string().nullish(),
	order_shipment_identifier: e.uuid().max(36).nullish(),
	shipped_items: e.array(Eu).nullish(),
	created: ku,
	modified: ju,
	created_by: Pu,
	modified_by: Iu
}), zu = e.object({ data: e.object({ shipments: e.array(Ru).register(e.globalRegistry, { description: "A list of Shipment Resources." }) }) });
e.union([e.string(), e.unknown()]);
var Bu = e.object({ url: e.url() }), Vu = e.object({ data: e.union([
	e.object({ pdf: Bu }),
	e.object({ pdfs: Bu }),
	e.object({ csvs: Bu }),
	e.object({ zpl: Bu }),
	e.object({ zpls: Bu })
]) }), Hu = e.array(e.object({
	shipment_id: R,
	price: B,
	price_after_vat: B
}));
e.object({ data: e.object({ shipments: e.object({
	unpaid_shipments: Hu,
	blocked_shipments: Hu
}) }) });
var Uu = e.object({
	amount: e.int().nullable(),
	currency: e.union([e.enum(["", "EUR"]), e.string()]).register(e.globalRegistry, { description: "The currency as uppercase 3-letter ISO 4217 code." })
}).register(e.globalRegistry, { description: "Price amount in a specific currency" }), Wu = e.object({
	id: e.string(),
	hash: e.string(),
	type: e.int(),
	notification_hash: e.string(),
	original_notification_hash: e.string(),
	paid: e.union([e.literal(0), e.literal(1)]),
	price: Uu,
	payment_url: e.url().nullable(),
	invoices: e.object({
		id: e.int(),
		number: e.string(),
		status: e.int()
	})
});
e.object({ data: e.object({ payment_instructions: e.array(Wu) }) });
var Gu = e.literal(400).register(e.globalRegistry, { description: "The server will not process the request due to a client error." });
Mc.and(e.object({
	status_code: Gu.optional(),
	errors: e.array(e.object({
		status: Gu.optional(),
		code: e.int().optional()
	})).optional()
})), e.object({
	type: e.string().register(e.globalRegistry, { description: "URI reference identifying the problem type. Derived from the wrapping UserException constant name (e.g. `urn:problem:invalid-shipments`) or, when no matching constant exists, a status-based fallback URN.\n" }),
	title: e.string().register(e.globalRegistry, { description: "A short, human-readable summary of the problem type." }),
	status: e.int().register(e.globalRegistry, { description: "The HTTP status code for this occurrence." }),
	detail: e.string().register(e.globalRegistry, { description: "A human-readable explanation specific to this occurrence." }),
	instance: e.string().register(e.globalRegistry, { description: "URI reference identifying the specific occurrence. The request path for the top-level object; the RFC 6901 JSON Pointer of the failing field for each `errors[]` entry.\n" }).optional(),
	request_id: e.string().register(e.globalRegistry, { description: "Per-request correlation identifier. Mirrors the value of the `X-Request-Id` response header and the legacy envelope's `request_id` field. Allowed as an RFC 9457 §3.2 extension member so consumers don't have to read both header and body for tracing.\n" }).optional(),
	errors: e.array(e.object({
		type: e.string(),
		title: e.string(),
		detail: e.string(),
		instance: e.string().optional()
	})).register(e.globalRegistry, { description: "Sub-problem list. Each entry is itself an RFC 9457 problem-detail object describing one failing field. The sub-error `type`/`title` narrow past the wrapping problem when the underlying validator code maps to its own UserException constant (e.g. `urn:problem:invalid-address`, `urn:problem:invalid-physical-properties`).\n" }).optional()
}).register(e.globalRegistry, { description: "RFC 9457 problem-detail object returned when the caller lists `application/problem+json` in the Accept header. Top-level fields are strictly the five defined in RFC 9457 §3.1; the `errors` array is an extension populated when the underlying exception carried per-field validator errors.\n" });
var Ku = e.union([
	e.literal(0),
	e.literal(1),
	e.literal(2),
	e.literal(3)
]), G = e.object({
	date: Ou,
	timezone: e.string(),
	timezone_type: Ku
}), qu = e.union([e.enum([
	"morning",
	"standard",
	"evening",
	"same_day",
	"express",
	"early_morning"
]), e.string()]), Ju = e.union([e.enum([
	"package",
	"mailbox",
	"unfranked",
	"digital_stamp",
	"pallet",
	"small_package",
	"envelope"
]), e.string()]).register(e.globalRegistry, { description: "Package Type." }), Yu = e.object({
	type: e.union([e.enum(["start", "end"]), e.string()]),
	date_time: G
}), Xu = e.object({
	type: qu.nullable(),
	package_type: Ju,
	delivery_time_frames: e.array(Yu),
	shipment_options: e.array(e.object({
		name: e.string(),
		schema: e.object({
			type: e.union([e.enum(["boolean"]), e.string()]),
			enum: e.array(e.boolean())
		})
	})),
	price: Uu.optional(),
	identifier: e.string().optional(),
	transporter: e.string().optional(),
	label_type: e.string().optional()
}), Zu = e.object({
	date: G,
	possibilities: e.array(Xu)
}), Qu = e.object({ data: e.object({ deliveries: e.array(Zu) }) }), $u = e.iso.date().regex(/\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2]\d|3[0-1])/).register(e.globalRegistry, { description: "Represents a date in ISO 8601 format:\n\n```\nYYYY-MM-DD\n```\n\nWhere:\n  - `YYYY` represents a four-digit year, `0000` through `9999`\n  - `MM` represents a zero-padded month of the year, `01` through `12`\n  - `DD` represents a zero-padded day of that month, `01` through `31`\n" }), ed = e.iso.time().regex(/([0-1]\d|2[0-4]):[0-5]\d(:([0-5]\d|60)(.\d+)?)?/).register(e.globalRegistry, { description: "Represents a time in ISO 8601 format:\n\n```\nhh:mm:ss.u\n```\n\nWhere:\n  - `hh` represents a zero-padded hour, `00` through `24`\n  - `mm` represents a zero-padded minute, `00` through `59`\n  - `ss` (optional) represents a zero-padded second, `00` through `60`\n    (where `60` is only used to denote an added leap second)\n  - `.u` (optional) represents a fraction of a second, `.0` through `.999999+`\n" }), td = e.object({
	start: ed,
	end: ed,
	price: Uu,
	price_comment: e.string(),
	comment: e.string(),
	type: e.int(),
	collect_date: G.optional(),
	identifier: e.string().optional(),
	transporter: e.string().optional(),
	label_type: e.string().optional()
}), nd = e.object({
	date: $u,
	time: e.array(td)
}), rd = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(6),
	e.literal(7),
	e.literal(8)
]), id = e.object({
	start: ed.nullish(),
	type: rd.optional(),
	price: Uu.optional()
}), ad = e.array(e.string()).register(e.globalRegistry, { description: "Opening hours.\nEach opening consist out of open- and close time formatted as a single string separated by ' - '. e.g. \"13:00 - 20:00\"\n" }), od = e.object({
	monday: ad,
	tuesday: ad,
	wednesday: ad,
	thursday: ad,
	friday: ad,
	saturday: ad,
	sunday: ad
}), sd = e.union([e.number().gte(-90).lte(90), e.string()]), cd = e.union([e.number().gte(-180).lte(180), e.string()]), ld = e.object({
	date: $u.nullish(),
	time: e.array(id).optional(),
	location: e.string().optional(),
	street: e.string().optional(),
	number: e.string().optional(),
	number_suffix: e.string().nullish(),
	postal_code: e.string().optional(),
	city: e.string().optional(),
	cc: e.string().optional(),
	start_time: ed.nullish(),
	price: e.int().optional(),
	price_comment: e.union([e.enum(["retail", "retailexpress"]), e.string()]).optional(),
	comment: e.string().optional(),
	phone_number: e.string().optional(),
	opening_hours: od.optional(),
	distance: e.string().optional(),
	latitude: sd.optional(),
	longitude: cd.optional(),
	location_code: e.string().optional(),
	retail_network_id: e.string().nullish(),
	holiday: e.object({
		from: e.string().nullish(),
		to: e.string().nullish()
	}).optional()
}), ud = e.int().gte(500).lte(599).register(e.globalRegistry, { description: "The server failed to fulfill an apparently valid request" }), dd = e.union([Oc, ud]), fd = e.object({
	status: dd.optional(),
	code: Ac,
	title: e.string().optional(),
	message: e.string()
});
e.object({
	data: e.object({
		delivery: e.array(nd),
		pickup: e.array(ld),
		message: e.string().optional()
	}),
	errors: e.array(e.union([fd, e.object({
		code: e.int(),
		message: e.string(),
		human: e.string().optional()
	})])).optional()
});
var pd = e.literal(406).register(e.globalRegistry, { description: "The target resource doesn't have an acceptable representation for the user agent." });
Mc.and(e.object({
	status_code: pd.optional(),
	errors: e.array(e.object({
		status: pd.optional(),
		code: e.int().optional()
	})).optional()
}));
var md = e.object({ link: e.url() }).register(e.globalRegistry, { description: "DownloadUrl Object Definition" }), hd = e.object({ data: e.object({ download_url: md }) }), gd = e.union([
	e.literal(0),
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6)
]), _d = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7)
]), vd = e.array(e.union([gd, _d])).nullable(), yd = e.object({
	monday: e.number().nullish(),
	tuesday: e.number().nullish(),
	wednesday: e.number().nullish(),
	thursday: e.number().nullish(),
	friday: e.number().nullish(),
	saturday: e.number().nullish(),
	sunday: e.number().nullish()
}), bd = e.object({
	start: G.nullable(),
	end: G.nullable()
}), xd = e.array(bd), Sd = e.object({
	monday: xd.optional(),
	tuesday: xd.optional(),
	wednesday: xd.optional(),
	thursday: xd.optional(),
	friday: xd.optional(),
	saturday: xd.optional(),
	sunday: xd.optional()
}).nullable(), Cd = e.object({
	location_code: e.string().optional(),
	location_name: e.string().nullish(),
	cc: e.string().optional(),
	state: e.string().nullish(),
	city: e.string().optional(),
	postal_code: e.string().optional(),
	street: e.string().optional(),
	number: e.union([e.string(), e.int()]).nullish(),
	number_suffix: e.string().nullish(),
	phone: e.string().nullish(),
	reference: e.string().nullish(),
	longitude: cd.nullish(),
	latitude: sd.nullish(),
	available_days: vd.optional(),
	cut_off_time: e.string().nullish(),
	carrier_id: W.optional(),
	distance: e.number().nullish(),
	occupancy: yd.nullish(),
	occupancy_today: e.number().nullish(),
	default_drop_off_point: e.boolean().nullish(),
	type: Qc.nullish(),
	opening_hours: Sd.optional()
}), wd = e.object({ data: e.object({ drop_off_points: e.array(Cd) }) }), Td = e.literal(415).register(e.globalRegistry, { description: "Content is in a format not supported by this method on the target resource." });
Mc.and(e.object({
	status_code: Td.optional(),
	errors: e.array(e.object({
		status: Td.optional(),
		code: e.literal(3100).optional()
	})).optional()
}));
var Ed = e.literal(401).register(e.globalRegistry, { description: "The request lacks valid authentication credentials for the target resource." });
Mc.and(e.object({
	status_code: Ed.optional(),
	errors: e.array(e.object({
		status: Ed.optional(),
		code: e.int().optional()
	})).optional()
}));
var Dd = e.object({
	cc: e.string(),
	city: e.string(),
	street: e.string(),
	postal_code: e.string(),
	number: e.string(),
	number_suffix: e.string().nullish()
}), Od = e.array(e.object({
	delivery_type_id: e.int(),
	delivery_type_name: e.string(),
	price: e.int(),
	moment: e.object({ start: G.nullish() })
})), kd = e.object({
	start: G.nullable(),
	end: G.nullable()
}), Ad = e.object({
	monday: e.array(kd),
	tuesday: e.array(kd),
	wednesday: e.array(kd),
	thursday: e.array(kd),
	friday: e.array(kd),
	saturday: e.array(kd),
	sunday: e.array(kd)
}), jd = e.object({
	location_name: e.string(),
	retail_network_id: e.string().nullable(),
	distance: e.string(),
	latitude: e.string(),
	longitude: e.string(),
	location_code: e.string(),
	phone_number: e.string().nullable(),
	type: Qc.nullable(),
	opening_hours: Ad
}), Md = e.object({
	address: Dd,
	possibilities: Od,
	location: jd
}), Nd = e.object({ data: e.object({ pickup_locations: e.array(Md) }) }), Pd = e.object({ data: e.object({
	shipments: e.array(Ru).register(e.globalRegistry, { description: "A list of Shipment Resources." }),
	pdf: e.object({ url: e.string() }).optional(),
	zpl: e.object({ url: e.string() }).optional()
}) });
e.object({ data: e.object({ ids: e.array(e.object({
	id: R,
	reference_identifier: ml
})).register(e.globalRegistry, { description: "A list of Shipment IDs." }) }) });
var Fd = e.array(e.object({
	id: R,
	reference_identifier: ml
})).register(e.globalRegistry, { description: "A list of Shipment IDs." });
e.object({ data: e.union([e.object({
	ids: Fd,
	pdf: e.object({ url: e.string() })
}), e.object({
	ids: Fd,
	zpl: e.object({ url: e.string() })
})]) });
var Id = e.object({
	status: ud.optional(),
	code: e.int().optional(),
	title: e.string().optional(),
	message: e.string().optional()
});
e.object({
	message: e.string().register(e.globalRegistry, { description: "A human-readable description of the error." }).optional(),
	request_id: e.string().register(e.globalRegistry, { description: "Internal request ID, useful for debugging purposes." }).optional(),
	status_code: ud.optional(),
	errors: e.array(Id).optional()
});
var Ld = e.object({ data: e.object({
	shipments: e.array(Ru).register(e.globalRegistry, { description: "A list of Shipment Resources." }),
	results: e.int().register(e.globalRegistry, { description: "The number of results." })
}) }), Rd = e.object({
	uri: e.url(),
	barcode: e.string()
}), zd = e.object({
	name: e.string(),
	cc: e.string().nullable(),
	city: e.string().nullable(),
	postal_code: e.string().nullable(),
	street: e.string().nullable(),
	number: e.string().nullable(),
	number_suffix: e.string().nullable(),
	longitude: e.number().nullable(),
	latitude: e.number().nullable()
}), Bd = e.union([e.enum([
	"registered",
	"handed_to_carrier",
	"sorting",
	"distribution",
	"delivered"
]), e.string()]).nullable(), Vd = e.object({
	code: e.string(),
	status: Hc.nullable(),
	main: Bd,
	description: e.string(),
	time: Ou,
	delayed: e.boolean(),
	location: zd
}), Hd = e.array(Vd), Ud = e.union([e.enum(["estimated", "expected"]), e.string()]).nullable(), Wd = e.object({
	start: G.nullable(),
	end: G.nullable()
}).nullable(), Gd = e.union([e.string(), e.object({
	content: e.string(),
	content_type: e.string()
})]).nullable(), Kd = e.object({
	shipment_id: R,
	carrier: W,
	code: e.string(),
	description: e.string(),
	time: Ou,
	link_consumer_portal: e.url().nullable(),
	link_tracktrace: e.url().nullable(),
	partner_tracktraces: e.array(Rd),
	recipient: Vc,
	sender: Bc,
	options: V,
	pickup: el,
	delayed: e.boolean(),
	location: zd,
	status: e.object({
		current: Hc,
		main: Bd,
		final: e.boolean()
	}),
	history: Hd,
	delivery_moment_type: Ud.optional(),
	delivery_moment: Wd.optional(),
	signature: Gd.optional(),
	returnable: e.boolean().optional()
}).register(e.globalRegistry, { description: "A Track & Trace resource." }), qd = e.object({ data: e.object({ tracktraces: e.array(Kd).register(e.globalRegistry, { description: "A list of Track & Trace Resources." }) }) }), Jd = e.union([e.enum([
	"BPOST",
	"BRT",
	"CHEAP_CARGO",
	"DHL_EUROPLUS",
	"DHL_FOR_YOU",
	"DHL_FREIGHT",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"GLS",
	"INPOST",
	"POSTE_ITALIANE",
	"POSTNL",
	"SPRING",
	"TRUNKRS",
	"UPS_EXPRESS_SAVER",
	"UPS_STANDARD",
	"VIA_TIM"
]), e.string()]).register(e.globalRegistry, { description: "Carrier string definition for capabilities endpoints (v2)" }), Yd = e.object({
	id: e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).register(e.globalRegistry, { description: "The contract ID." }),
	type: e.union([e.enum(["MAIN", "CUSTOM"]), e.string()]).register(e.globalRegistry, { description: "The type of contract." })
}).register(e.globalRegistry, { description: "Contract definition for capabilities endpoints (v2)" }), Xd = e.union([e.enum([
	"PACKAGE",
	"MAILBOX",
	"UNFRANKED",
	"DIGITAL_STAMP",
	"PALLET",
	"SMALL_PACKAGE",
	"ENVELOPE"
]), e.string()]).register(e.globalRegistry, { description: "Package Type." }), K = e.object({
	isSelectedByDefault: e.boolean(),
	isRequired: e.boolean()
}), Zd = e.object({
	additionalInsurance: K.optional(),
	deliverAtPostalPoint: K.optional(),
	freshFood: K.optional(),
	frozen: K.optional(),
	hideSender: K.optional(),
	noTracking: K.optional(),
	oversizedPackage: K.optional(),
	priorityDelivery: K.optional(),
	printReturnLabelAtDropOff: K.optional(),
	recipientOnlyDelivery: K.optional(),
	requiresAgeVerification: K.optional(),
	requiresCashOnDelivery: K.optional(),
	requiresReceiptCode: K.optional(),
	requiresSignature: K.optional(),
	returnOnFirstFailedDelivery: K.optional(),
	sameDayDelivery: K.optional(),
	saturdayDelivery: K.optional(),
	scheduledCollection: K.optional(),
	tracked: K.optional()
}), q = K.and(e.object({
	requires: e.array(e.string()).register(e.globalRegistry, { description: "camelCase shipment option keys that are required" }),
	excludes: e.array(e.string()).register(e.globalRegistry, { description: "camelCase shipment option keys that are excluded" })
})), Qd = e.object({
	insuredAmount: e.object({
		default: B,
		min: B,
		max: B
	}).register(e.globalRegistry, { description: "Deprecated. Use the flat default/min/max properties on the insurance option directly. Will be removed in a future release.\n" }).optional(),
	default: B.optional(),
	min: B.optional(),
	max: B.optional()
}), $d = q.and(Qd), ef = Zd.and(e.object({
	additionalInsurance: q.optional(),
	deliverAtPostalPoint: q.optional(),
	freshFood: q.optional(),
	frozen: q.optional(),
	hideSender: q.optional(),
	insurance: $d.optional(),
	noTracking: q.optional(),
	oversizedPackage: q.optional(),
	priorityDelivery: q.optional(),
	printReturnLabelAtDropOff: q.optional(),
	recipientOnlyDelivery: q.optional(),
	requiresAgeVerification: q.optional(),
	requiresCashOnDelivery: q.optional(),
	requiresReceiptCode: q.optional(),
	requiresSignature: q.optional(),
	returnOnFirstFailedDelivery: q.optional(),
	sameDayDelivery: q.optional(),
	saturdayDelivery: q.optional(),
	scheduledCollection: q.optional(),
	tracked: q.optional()
})), tf = e.object({
	value: e.number().register(e.globalRegistry, { description: "The numeric value" }),
	unit: e.union([e.enum([
		"g",
		"kg",
		"cm",
		"mm",
		"mm3",
		"cm3",
		"dm3",
		"m3"
	]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units" })
}), J = e.object({
	min: tf,
	max: tf,
	calculation: e.string()
}), nf = e.object({
	weight: J.optional(),
	width: J.optional(),
	length: J.optional(),
	height: J.optional(),
	girth: J.optional(),
	volumetricWeight: J.optional(),
	volume: J.optional(),
	lengthWidthHeightSum: J.optional()
}), rf = e.union([e.enum([
	"MORNING_DELIVERY",
	"STANDARD_DELIVERY",
	"EVENING_DELIVERY",
	"PICKUP_DELIVERY",
	"SAME_DAY_DELIVERY",
	"EXPRESS_DELIVERY",
	"EARLY_MORNING_DELIVERY"
]), e.string()]), af = e.union([e.enum(["B2B", "B2C"]), e.string()]), of = e.object({ max: e.int() }), sf = e.object({
	carrier: Jd,
	contract: Yd.optional(),
	packageTypes: e.array(Xd),
	options: ef,
	physicalProperties: nf,
	deliveryTypes: e.array(rf),
	transactionTypes: e.array(af),
	collo: of
}).register(e.globalRegistry, { description: "A V2 Capability response item for a given Shipment configuration." }), cf = e.object({ results: e.array(sf).register(e.globalRegistry, { description: "A list of V2 Capabilities for a given Shipment configuration." }) }), lf = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(12),
	e.literal(13),
	e.literal(14),
	e.literal(15),
	e.literal(16),
	e.literal(17),
	e.literal(18),
	e.literal(19),
	e.literal(20),
	e.literal(21)
]).register(e.globalRegistry, { description: "Carrier ID definition for capabilities endpoints (v1)" }), uf = e.object({
	id: e.int().min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" }).max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }).register(e.globalRegistry, { description: "The contract ID." }),
	type: e.union([e.enum(["main", "custom"]), e.string()]).register(e.globalRegistry, { description: "The type of contract." })
}).register(e.globalRegistry, { description: "Contract definition for capabilities endpoints (v1)" }), Y = e.object({
	is_selected_by_default: e.boolean(),
	is_required: e.boolean()
}), df = e.object({
	age_check: Y.optional(),
	cash_on_delivery: Y.optional(),
	collect: Y.optional(),
	drop_off_at_postal_point: Y.optional(),
	extra_assurance: Y.optional(),
	fresh_food: Y.optional(),
	frozen: Y.optional(),
	hide_sender: Y.optional(),
	large_format: Y.optional(),
	no_tracking: Y.optional(),
	only_recipient: Y.optional(),
	printerless_return: Y.optional(),
	priority_delivery: Y.optional(),
	receipt_code: Y.optional(),
	return: Y.optional(),
	same_day_delivery: Y.optional(),
	saturday_delivery: Y.optional(),
	signature: Y.optional(),
	tracked: Y.optional()
}), X = Y.and(e.object({
	requires: e.array(e.string()).register(e.globalRegistry, { description: "snake_case shipment option keys that are required" }),
	excludes: e.array(e.string()).register(e.globalRegistry, { description: "snake_case shipment option keys that are excluded" })
})), ff = e.object({
	insured_amount: e.object({
		default: B,
		min: B,
		max: B
	}).register(e.globalRegistry, { description: "Deprecated. Use the flat default/min/max properties on the insurance option directly. Will be removed in a future release.\n" }).optional(),
	default: B.optional(),
	min: B.optional(),
	max: B.optional()
}), pf = X.and(ff), mf = df.and(e.object({
	age_check: X.optional(),
	cash_on_delivery: X.optional(),
	collect: X.optional(),
	drop_off_at_postal_point: X.optional(),
	extra_assurance: X.optional(),
	fresh_food: X.optional(),
	frozen: X.optional(),
	hide_sender: X.optional(),
	insurance: pf.optional(),
	large_format: X.optional(),
	no_tracking: X.optional(),
	only_recipient: X.optional(),
	printerless_return: X.optional(),
	priority_delivery: X.optional(),
	receipt_code: X.optional(),
	return: X.optional(),
	same_day_delivery: X.optional(),
	saturday_delivery: X.optional(),
	signature: X.optional(),
	tracked: X.optional()
})), hf = e.object({
	weight: J.optional(),
	width: J.optional(),
	length: J.optional(),
	height: J.optional(),
	girth: J.optional(),
	volumetric_weight: J.optional(),
	volume: J.optional(),
	length_width_height_sum: J.optional()
}), gf = e.object({
	carrier_id: lf,
	contract: uf.optional(),
	package_types: e.array(Kc),
	options: mf,
	physical_properties: hf,
	delivery_types: e.array(rd),
	transaction_types: e.array(af),
	collo: of
}).register(e.globalRegistry, { description: "A V1 Capability response item for a given Shipment configuration." });
e.object({ data: e.object({ capabilities: e.array(gf).register(e.globalRegistry, { description: "A list of V1 Capabilities for a given Shipment configuration." }) }) });
var Z = K.and(e.object({})), _f = Z.and(Qd), vf = Zd.and(e.object({
	additionalInsurance: Z.optional(),
	deliverAtPostalPoint: Z.optional(),
	hideSender: Z.optional(),
	insurance: _f.optional(),
	noTracking: Z.optional(),
	oversizedPackage: Z.optional(),
	priorityDelivery: Z.optional(),
	printReturnLabelAtDropOff: Z.optional(),
	recipientOnlyDelivery: Z.optional(),
	requiresAgeVerification: Z.optional(),
	requiresCashOnDelivery: Z.optional(),
	requiresReceiptCode: Z.optional(),
	requiresSignature: Z.optional(),
	returnOnFirstFailedDelivery: Z.optional(),
	sameDayDelivery: Z.optional(),
	saturdayDelivery: Z.optional(),
	scheduledCollection: Z.optional(),
	tracked: Z.optional()
})), yf = e.object({
	carrier: Jd,
	packageTypes: e.array(Xd),
	options: vf,
	deliveryTypes: e.array(rf),
	transactionTypes: e.array(af),
	collo: of
}).register(e.globalRegistry, { description: "A V2 Capability response item for a given Shipment configuration." }), bf = e.object({ items: e.array(yf).register(e.globalRegistry, { description: "A superset of V2 Capabilities for the contracts within a user's account." }) }), Q = Y.and(e.object({})), xf = Q.and(ff), Sf = df.and(e.object({
	age_check: Q.optional(),
	cash_on_delivery: Q.optional(),
	collect: Q.optional(),
	drop_off_at_postal_point: Q.optional(),
	extra_assurance: Q.optional(),
	hide_sender: Q.optional(),
	insurance: xf.optional(),
	large_format: Q.optional(),
	no_tracking: Q.optional(),
	only_recipient: Q.optional(),
	printerless_return: Q.optional(),
	priority_delivery: Q.optional(),
	receipt_code: Q.optional(),
	return: Q.optional(),
	same_day_delivery: Q.optional(),
	saturday_delivery: Q.optional(),
	signature: Q.optional(),
	tracked: Q.optional()
})), Cf = e.object({
	carrier_id: lf,
	package_types: e.array(Kc),
	options: Sf,
	delivery_types: e.array(rd),
	transaction_types: e.array(af),
	collo: of
}).register(e.globalRegistry, { description: "A V1 Capability contract definitions response item for a given Shipment configuration." });
e.object({ data: e.object({ contract_definitions: e.array(Cf).register(e.globalRegistry, { description: "A superset of V1 Capabilities for the contracts within a user's account." }) }) });
var wf = e.object({
	id: e.int().register(e.globalRegistry, { description: "The id of the contract." }),
	type: e.union([e.enum(["MAIN", "CUSTOM"]), e.string()]).register(e.globalRegistry, { description: "The type of contract." })
}).register(e.globalRegistry, { description: "The contract object." }), Tf = e.union([e.enum([
	"EXPRESS",
	"FULFILMENT",
	"LABEL_PACKAGE",
	"MULTI_COLLO",
	"RETURN",
	"RETURN_ERS",
	"RETURN_SPECIAL",
	"STANDARD"
]), e.string()]), Ef = e.object({
	name: e.string(),
	key: e.string(),
	price: U,
	vat: U,
	priceWithVat: U
}).register(e.globalRegistry, { description: "A V2 Price object." }), Df = e.object({
	base: Ef,
	charges: e.array(Ef),
	discounts: e.array(Ef),
	options: e.array(Ef),
	other: e.array(Ef),
	total: Ef
}).register(e.globalRegistry, { description: "The V2 price composition object, containing the base, options, charges, discounts and total prices." }), Of = e.object({
	carrier: Jd,
	contract: wf.optional(),
	packageType: Xd,
	deliveryType: rf.optional(),
	shipmentType: Tf,
	priceComposition: Df
}).register(e.globalRegistry, { description: "A V2 Rate response item for a given Shipment configuration." }), kf = e.object({
	id: e.int().register(e.globalRegistry, { description: "The id of the contract." }),
	type: e.union([e.enum(["main", "custom"]), e.string()]).register(e.globalRegistry, { description: "The type of contract." })
}).register(e.globalRegistry, { description: "The contract object." }), Af = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4),
	e.literal(5),
	e.literal(6),
	e.literal(7)
]), jf = e.object({
	name: e.string(),
	key: e.string(),
	price: U,
	vat: U,
	price_with_vat: U
}).register(e.globalRegistry, { description: "A V1 Price object." }), Mf = e.object({
	base: jf,
	charges: e.array(jf),
	discounts: e.array(jf),
	options: e.array(jf),
	other: e.array(jf),
	total: jf
}).register(e.globalRegistry, { description: "The price composition object, containing the base, options, charges, discounts and total prices." }), Nf = e.object({
	carrier_id: lf,
	contract: kf.optional(),
	package_type: Kc,
	delivery_type: rd.optional(),
	shipment_type: Af,
	price_composition: Mf
}).register(e.globalRegistry, { description: "A V1 Rate response item for a given Shipment configuration." });
e.object({ data: e.object({ rates: e.array(Nf).register(e.globalRegistry, { description: "A list of V1 Rates for a given Shipment configuration." }) }) });
var Pf = e.object({
	id: e.int(),
	shopId: e.int(),
	packageType: e.union([e.enum([
		"DIGITAL_STAMP",
		"ENVELOPE",
		"UNFRANKED",
		"MAILBOX",
		"PACKAGE",
		"PALLET",
		"SMALL_PACKAGE"
	]), e.string()]).nullable(),
	countryCode: e.string().nullable(),
	shipmentDirection: e.union([e.enum(["OUTBOUND", "INBOUND"]), e.string()]),
	fallback: e.boolean()
}).register(e.globalRegistry, { description: "A Notification Group response item" }), Ff = e.object({ results: e.array(Pf) }), If = e.union([e.enum([
	"LABEL_DOWNLOAD",
	"FIRST_SCAN",
	"RETURN"
]), e.string()]).register(e.globalRegistry, { description: "The notification template type." }), Lf = e.object({
	id: e.int(),
	notificationGroupId: e.int(),
	type: If,
	subject: e.string(),
	body: e.string(),
	active: e.boolean()
}).register(e.globalRegistry, { description: "A Notification Template response item" }), Rf = e.object({ results: e.array(Lf) }), zf = e.object({
	id: e.int(),
	account_id: e.int(),
	shop_id: e.int(),
	hook: e.string(),
	url: e.string(),
	payload: e.string().nullish()
}).register(e.globalRegistry, { description: "A Webhook Subscription response item" }), Bf = e.object({ data: e.object({ webhook_subscriptions: e.array(zf) }) }), Vf = e.object({
	id: e.int(),
	account_id: e.int(),
	shop_id: e.int(),
	hook: e.string(),
	url: e.string()
}).register(e.globalRegistry, { description: "A Webhook Subscription response item" });
e.object({ data: e.object({ webhook_subscriptions: e.array(Vf) }) });
var Hf = e.object({ data: e.object({ ids: e.array(e.object({ id: e.int() })).register(e.globalRegistry, { description: "A list of created webhook subscription IDs." }) }) }), Uf = e.string(), Wf = e.union([e.enum([
	"1",
	"2",
	"3",
	"4",
	"5",
	"6",
	"7",
	"8",
	"9",
	"10",
	"11",
	"12",
	"13",
	"14",
	"15",
	"16",
	"17",
	"18",
	"19",
	"20",
	"21"
]), e.string()]).register(e.globalRegistry, { description: "This enumeration represents the Carriers. The value is the Carrier id." }), Gf = e.union([e.enum([
	"postnl",
	"bpost",
	"cheapcargo",
	"dpd",
	"instabox",
	"dhl",
	"bol.com",
	"ups",
	"dhlforyou",
	"dhlparcelconnect",
	"dhleuroplus",
	"upsstandard",
	"upsexpresssaver",
	"gls",
	"brt",
	"trunkrs",
	"inpost",
	"posteitaliane",
	"spring",
	"viatim",
	"dhlfreight"
]), e.string()]).register(e.globalRegistry, { description: "This enumeration represents the Carriers. The value is the Carrier id." }), Kf = e.union([Wf, Gf]).nullable(), qf = e.iso.date().regex(/\d{4}-\d{2}-\d{2}/).nullable(), Jf = e.string().register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 country code" }), Yf = ed.nullable(), $ = e.union([
	e.boolean(),
	e.int().gte(0).lte(1),
	e.union([e.unknown(), e.unknown()]),
	e.union([e.enum([
		"0",
		"1",
		"false",
		"true"
	]), e.string()])
]), Xf = e.union([
	e.literal(!1),
	e.literal(!0),
	e.literal(0),
	e.literal(1),
	e.literal("0"),
	e.literal("1"),
	e.literal("false"),
	e.literal("true"),
	e.literal("off"),
	e.literal("on"),
	e.literal("no"),
	e.literal("yes"),
	e.literal("")
]).nullable(), Zf = $u.nullable(), Qf = ed.nullable(), $f = e.string().nullable(), ep = e.string().nullable(), tp = e.union([e.enum([
	"1",
	"2",
	"3",
	"4",
	"6",
	"7",
	"8"
]), e.string()]), np = e.union([tp, e.unknown()]), rp = e.union([e.enum(["A4", "A6"]), e.string()]).register(e.globalRegistry, { description: "The size of a paper as specified in ISO216." }), ip = sd.nullable(), ap = cd.nullable(), op = e.union([e.enum(["ASC", "DESC"]), e.string()]).register(e.globalRegistry, { description: "Specify whether the results should be sorted in ascending or descending order." }), sp = e.union([
	Kc,
	e.array(Kc),
	e.string()
]), cp = e.int().gte(1).lte(1e3).register(e.globalRegistry, { description: "Request a specific page of the results, used for paginated results." }), lp = e.union([e.enum([
	"myparcel",
	"flespakket",
	"belgie",
	"delivery_dutch",
	"postnl_customer",
	"italy"
]), e.string()]), up = e.union([e.enum([
	"1",
	"2",
	"3",
	"4",
	"5",
	"6"
]), e.string()]), dp = e.union([lp, up]).nullable(), fp = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(3),
	e.literal(4)
]).register(e.globalRegistry, { description: "The position of the label on the paper." }), pp = e.union([fp, e.string()]), mp = e.string().nullable(), hp = e.coerce.bigint().gte(BigInt(1)).lte(BigInt(0x8000000000000000)), gp = e.union([hp, e.string()]), _p = e.union([
	Ic,
	e.array(Ic),
	e.string()
]), vp = e.int().gte(1).lte(2147483647), yp = e.union([
	vp,
	e.array(vp),
	e.string()
]), bp = e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "Specify the number of resources returned per page, used for paginated results." }), xp = e.union([e.enum([
	"amount",
	"created",
	"created_by",
	"currency",
	"drop_off_point",
	"hidden",
	"id",
	"mark_delivered",
	"modified",
	"modified_by",
	"order_shipment_identifier",
	"parent_id",
	"recipient",
	"reference_identifier",
	"sender",
	"shipment_type",
	"shop_id",
	"status",
	"transaction_status"
]), e.string()]), Sp = e.union([
	Hc,
	e.array(Hc),
	e.string()
]), Cp = e.string(), wp = e.array(e.union([e.email(), e.string()])), Tp = e.object({
	cc: e.string(),
	postal_code: e.string(),
	city: e.string(),
	street: e.string(),
	street_additional_info: e.string().nullish(),
	number: e.string().optional(),
	number_suffix: e.string().optional(),
	box_number: e.string().optional(),
	region: e.string().optional(),
	person: e.string(),
	company: e.string().optional(),
	phone: e.string().optional(),
	email: e.union([e.email(), e.string()]).nullish()
}), Ep = e.object({
	postal_code: e.string().optional(),
	location_name: e.string().optional(),
	city: e.string().optional(),
	street: e.string().optional(),
	number: e.string().optional(),
	number_suffix: e.string().nullish(),
	box_number: e.string().optional(),
	region: e.string().optional(),
	state: e.string().optional(),
	cc: e.string().optional(),
	location_code: e.string().optional(),
	location_type: e.union([$c, Qc]).optional(),
	retail_network_id: e.string().optional()
}).nullable(), Dp = e.object({ data: e.object({
	user_agent: e.string().optional(),
	shipments: e.array(e.object({
		account_id: e.int().optional(),
		shop_id: e.int().optional(),
		contract_id: e.int().optional(),
		reference_identifier: e.union([e.int(), e.string()]).optional(),
		recipient: e.object({
			cc: e.string(),
			region: e.string().optional(),
			state: e.string().optional(),
			postal_code: e.string(),
			city: e.string(),
			street: e.string(),
			street_additional_info: e.string().optional(),
			number: e.string().optional(),
			number_suffix: e.string().optional(),
			box_number: e.string().optional(),
			area: e.string().optional(),
			person: e.string(),
			company: e.string().optional(),
			email: e.union([e.email(), e.string()]).optional(),
			secondary_emails: wp.optional(),
			phone: e.string().optional(),
			eori_number: e.string().nullish(),
			vat_number: e.string().nullish()
		}),
		sender: Tp.optional(),
		recipients: e.array(e.number()).min(1).optional(),
		physical_properties: e.object({
			weight: e.int().gte(0).lte(999999999),
			height: e.int().optional(),
			width: e.int().optional(),
			length: e.int().optional(),
			volume: e.int().optional()
		}).optional(),
		options: V.and(e.unknown()),
		customs_declaration: H.optional(),
		carrier: W,
		pickup: Ep.optional(),
		drop_off_point: e.object({
			postal_code: e.string(),
			location_name: e.string(),
			city: e.string(),
			street: e.string(),
			number: e.string(),
			number_suffix: e.string().optional(),
			box_number: e.string().optional(),
			region: e.string().optional(),
			state: e.string().optional(),
			cc: e.string().optional(),
			location_code: e.string(),
			retail_network_id: e.string().optional()
		}).nullish(),
		note: e.string().optional(),
		status: e.union([
			e.literal(1),
			e.literal(2),
			e.literal(3),
			e.literal(4),
			e.literal(5),
			e.literal(6),
			e.literal(7),
			e.literal(8)
		]).optional(),
		delivered: e.literal(0).optional(),
		general_settings: e.object({
			save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional(),
			delivery_notification: e.union([e.literal(0), e.literal(1)]).optional(),
			delivery_notification_email: e.array(e.string()).optional(),
			disable_auto_detect_pickup: e.union([e.literal(0), e.literal(1)]).optional(),
			printer_identifier: e.string().optional()
		}).optional(),
		secondary_shipments: e.array(e.object({
			account_id: e.int().optional(),
			shop_id: e.int().optional(),
			reference_identifier: e.union([e.int(), e.string()]).optional(),
			recipient: e.object({
				cc: e.string().optional(),
				region: e.string().optional(),
				state: e.string().optional(),
				postal_code: e.string().optional(),
				city: e.string().optional(),
				street: e.string().optional(),
				street_additional_info: e.string().optional(),
				number: e.string().optional(),
				number_suffix: e.string().optional(),
				box_number: e.string().optional(),
				area: e.string().optional(),
				person: e.string().optional(),
				company: e.string().optional(),
				email: e.union([e.email(), e.string()]).optional(),
				secondary_emails: wp.optional(),
				phone: e.string().optional(),
				eori_number: e.string().nullish(),
				vat_number: e.string().nullish()
			}).optional(),
			recipients: e.array(e.number()).min(1).optional(),
			physical_properties: e.object({
				weight: e.int().gte(0).lte(999999999),
				height: e.int().optional(),
				width: e.int().optional(),
				length: e.int().optional(),
				volume: e.int().optional()
			}).optional(),
			options: V.optional(),
			customs_declaration: H.optional(),
			carrier: W.optional(),
			pickup: Ep.optional(),
			drop_off_point: e.object({
				postal_code: e.string(),
				location_name: e.string(),
				city: e.string(),
				street: e.string(),
				number: e.string(),
				number_suffix: e.string().optional(),
				box_number: e.string().optional(),
				region: e.string().optional(),
				state: e.string().optional(),
				cc: e.string().optional(),
				location_code: e.string(),
				retail_network_id: e.string().optional()
			}).nullish(),
			note: e.string().optional(),
			status: e.union([
				e.literal(1),
				e.literal(2),
				e.literal(3),
				e.literal(4),
				e.literal(5),
				e.literal(6),
				e.literal(7),
				e.literal(8)
			]).optional(),
			delivered: e.literal(0).optional(),
			general_settings: e.object({ save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional() }).optional(),
			hidden: e.union([e.literal(0), e.literal(1)]).optional(),
			shipped_items: e.array(e.object({
				order_line_identifier: e.string(),
				quantity: e.int().gte(1)
			})).min(0).optional()
		})).min(1).optional(),
		collection_contact: e.object({
			cc: e.string(),
			city: e.string(),
			company: e.string(),
			email: e.email(),
			first_name: e.string().optional(),
			gender: e.union([e.enum(["mr", "mrs"]), e.string()]).optional(),
			last_name: e.string(),
			number: e.union([e.string(), e.int()]),
			number_suffix: e.string().nullish(),
			phone: e.string(),
			postal_code: e.string(),
			street: e.string(),
			street_additional_info: e.string().nullish()
		}).optional(),
		hidden: e.union([e.literal(0), e.literal(1)]).optional(),
		shipped_items: e.array(e.object({
			order_line_identifier: e.string(),
			quantity: e.int().gte(1)
		})).min(0).optional()
	}))
}) });
e.object({ data: e.object({
	user_agent: e.string().optional(),
	shipments: e.array(e.object({
		account_id: e.int().optional(),
		shop_id: e.int().optional(),
		reference_identifier: e.union([e.int(), e.string()]).optional(),
		recipient: e.object({
			cc: e.string(),
			region: e.string().optional(),
			state: e.string().optional(),
			postal_code: e.string().optional(),
			city: e.string(),
			street: e.string(),
			street_additional_info: e.string().optional(),
			number: e.string().optional(),
			number_suffix: e.string().optional(),
			box_number: e.string().optional(),
			area: e.string().optional(),
			person: e.string(),
			company: e.string().optional(),
			email: e.union([e.email(), e.string()]).optional(),
			secondary_emails: wp.optional(),
			phone: e.string().optional()
		}),
		sender: Tp.optional(),
		recipients: e.array(e.number()).min(1).optional(),
		physical_properties: e.object({
			weight: e.int().gte(0).lte(999999999),
			height: e.int().optional(),
			width: e.int().optional(),
			length: e.int().optional(),
			volume: e.int().optional()
		}).optional(),
		options: V.and(e.unknown()),
		customs_declaration: H.optional(),
		carrier: W,
		pickup: Ep.optional(),
		"multi-colli": e.object({ amount: e.int() }).nullish(),
		note: e.string().optional(),
		status: e.union([
			e.literal(1),
			e.literal(2),
			e.literal(3),
			e.literal(4),
			e.literal(5),
			e.literal(6),
			e.literal(7),
			e.literal(8)
		]).optional(),
		delivered: e.literal(0).optional(),
		general_settings: e.object({
			save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional(),
			delivery_notification: e.union([e.literal(0), e.literal(1)]).optional(),
			delivery_notification_email: e.array(e.string()).optional(),
			disable_auto_detect_pickup: e.union([e.literal(0), e.literal(1)]).optional(),
			printer_identifier: e.string().optional()
		}).optional(),
		hidden: e.union([e.literal(0), e.literal(1)]).optional()
	}))
}) });
var Op = e.object({ package_type: e.union([
	e.literal(1),
	e.literal(2),
	e.literal(6)
]).optional() });
e.literal(1).register(e.globalRegistry, { description: "Regular package." }), e.literal(2).register(e.globalRegistry, { description: "Shipment that fits through a mailbox slot." }), e.literal(6);
var kp = e.object({
	age_check: z.optional(),
	cooled_delivery: z.optional(),
	drop_off_at_postal_point: z.optional(),
	extra_assurance: z.optional(),
	hide_sender: z.optional(),
	large_format: z.optional(),
	only_recipient: z.optional(),
	receipt_code: z.optional(),
	return: z.optional(),
	same_day_delivery: z.optional(),
	saturday_delivery: z.optional(),
	signature: z.optional()
}), Ap = e.object({ options: Op.and(Wc).and(kp).and(Xc).and(e.object({
	contribution: B.and(e.object({ amount: e.unknown().optional() })).optional(),
	printerless_return: z.optional()
})).optional() }), jp = e.union([
	e.literal(1),
	e.literal(2),
	e.literal(4),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(14),
	e.literal(15),
	e.literal(17),
	e.literal(18)
]);
e.object({ data: e.object({ return_shipments: e.array(Ap.and(e.object({
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	contract_id: e.int().optional(),
	parent: e.int(),
	reference_identifier: e.union([e.int(), e.string()]).optional(),
	carrier: jp,
	email: e.string(),
	name: e.string(),
	sender: e.object({
		cc: e.string(),
		postal_code: e.string().optional(),
		city: e.string(),
		street: e.string(),
		street_additional_info: e.string().optional(),
		number: e.string().optional(),
		number_suffix: e.string().optional(),
		box_number: e.string().optional(),
		region: e.string().optional(),
		person: e.string(),
		company: e.string().optional(),
		email: e.union([e.email(), e.string()]).nullish(),
		phone: e.string().optional()
	}).optional(),
	physical_properties: e.object({
		weight: e.int().gte(0).lte(999999999).optional(),
		height: e.int().optional(),
		width: e.int().optional(),
		length: e.int().optional(),
		volume: e.int().optional()
	}).optional(),
	customs_declaration: H.optional(),
	general_settings: e.object({ save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional() }).optional()
}))).optional() }) }), e.object({ data: e.object({ return_shipments: e.array(Ap.and(e.object({
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	carrier: jp,
	email: e.string().optional(),
	name: e.string().optional(),
	cc: e.string().optional(),
	sender: e.object({
		cc: e.string(),
		postal_code: e.string().optional(),
		city: e.string(),
		street: e.string(),
		street_additional_info: e.string().optional(),
		number: e.string().optional(),
		number_suffix: e.string().optional(),
		box_number: e.string().optional(),
		region: e.string().optional(),
		person: e.string(),
		company: e.string().optional(),
		email: e.union([e.email(), e.string()]).nullish(),
		phone: e.string().optional()
	}).optional(),
	physical_properties: e.object({
		weight: e.int().gte(0).lte(999999999).optional(),
		height: e.int().optional(),
		width: e.int().optional(),
		length: e.int().optional(),
		volume: e.int().optional()
	}).optional(),
	customs_declaration: H.optional(),
	general_settings: e.object({ save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional() }).optional()
}))).optional() }) });
var Mp = e.object({ data: e.object({ shipments: e.array(e.object({
	id: e.int(),
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	contract_id: e.int().optional(),
	reference_identifier: e.union([e.int(), e.string()]).optional(),
	carrier: W,
	status: e.int().optional(),
	delivered: e.union([e.literal(0), e.literal(1)]).optional(),
	recipient: e.object({
		cc: e.string(),
		region: e.string().optional(),
		state: e.string().optional(),
		postal_code: e.string().optional(),
		city: e.string(),
		street: e.string(),
		street_additional_info: e.string().optional(),
		number: e.string().nullish(),
		number_suffix: e.string().nullish(),
		box_number: e.string().optional(),
		person: e.string(),
		company: e.string().optional(),
		email: e.union([e.email(), e.string()]).optional(),
		secondary_emails: wp.optional(),
		phone: e.string().optional(),
		eori_number: e.string().nullish(),
		vat_number: e.string().nullish()
	}),
	sender: Tp.optional(),
	options: V.and(e.unknown()),
	customs_declaration: H.optional(),
	physical_properties: e.object({
		weight: e.int().gte(0).lte(999999999),
		height: e.int().optional(),
		width: e.int().optional(),
		length: e.int().optional(),
		volume: e.int().optional()
	}).optional(),
	pickup: Ep.optional(),
	drop_off_point: e.object({
		postal_code: e.string(),
		location_name: e.string(),
		city: e.string(),
		street: e.string(),
		number: e.string(),
		number_suffix: e.string().optional(),
		box_number: e.string().optional(),
		region: e.string().optional(),
		state: e.string().optional(),
		cc: e.string().optional(),
		location_code: e.string(),
		retail_network_id: e.string().optional()
	}).nullish(),
	note: e.string().optional(),
	general_settings: e.object({
		save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional(),
		delivery_notification: e.union([e.literal(0), e.literal(1)]).optional(),
		delivery_notification_email: e.array(e.string()).optional(),
		disable_auto_detect_pickup: e.union([e.literal(0), e.literal(1)]).optional(),
		printer_identifier: e.string().optional()
	}).optional(),
	multi_collo_main_shipment_id: e.int().nullish(),
	secondary_shipments: e.array(e.object({
		id: e.int().optional(),
		account_id: e.int().optional(),
		shop_id: e.int().optional(),
		reference_identifier: e.union([e.int(), e.string()]).optional(),
		recipient: e.object({
			cc: e.string().optional(),
			region: e.string().optional(),
			state: e.string().optional(),
			postal_code: e.string().optional(),
			city: e.string().optional(),
			street: e.string().optional(),
			street_additional_info: e.string().optional(),
			number: e.string().nullish(),
			number_suffix: e.string().nullish(),
			box_number: e.string().optional(),
			area: e.string().optional(),
			person: e.string().optional(),
			company: e.string().optional(),
			email: e.union([e.email(), e.string()]).optional(),
			secondary_emails: wp.optional(),
			phone: e.string().optional(),
			eori_number: e.string().nullish(),
			vat_number: e.string().nullish()
		}).optional(),
		recipients: e.array(e.number()).min(1).optional(),
		physical_properties: e.object({
			weight: e.int().gte(0).lte(999999999),
			height: e.int().optional(),
			width: e.int().optional(),
			length: e.int().optional(),
			volume: e.int().optional()
		}).optional(),
		options: V.optional(),
		customs_declaration: H.optional(),
		carrier: W.optional(),
		pickup: Ep.optional(),
		drop_off_point: e.object({
			postal_code: e.string(),
			location_name: e.string(),
			city: e.string(),
			street: e.string(),
			number: e.string(),
			number_suffix: e.string().optional(),
			box_number: e.string().optional(),
			region: e.string().optional(),
			state: e.string().optional(),
			cc: e.string().optional(),
			location_code: e.string(),
			retail_network_id: e.string().optional()
		}).nullish(),
		note: e.string().optional(),
		status: e.union([
			e.literal(1),
			e.literal(2),
			e.literal(3),
			e.literal(4),
			e.literal(5),
			e.literal(6),
			e.literal(7),
			e.literal(8)
		]).optional(),
		delivered: e.union([e.literal(0), e.literal(1)]).optional(),
		general_settings: e.object({ save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional() }).optional(),
		multi_collo_main_shipment_id: e.int().nullish(),
		hidden: e.union([e.literal(0), e.literal(1)]).optional(),
		shipped_items: e.array(e.object({
			order_line_identifier: e.string(),
			quantity: e.int().gte(1)
		})).min(0).optional()
	})).min(1).optional(),
	collection_contact: e.object({
		cc: e.string(),
		city: e.string(),
		company: e.string().nullish(),
		email: e.email().optional(),
		first_name: e.string().optional(),
		gender: e.union([e.enum(["mr", "mrs"]), e.string()]).optional(),
		last_name: e.string().optional(),
		number: e.union([e.string(), e.int()]),
		number_suffix: e.string().nullish(),
		phone: e.string(),
		postal_code: e.string(),
		street: e.string(),
		street_additional_info: e.string().nullish()
	}).optional(),
	hidden: e.union([e.literal(0), e.literal(1)]).optional(),
	shipped_items: e.array(e.object({
		order_line_identifier: e.string(),
		quantity: e.int().gte(1)
	})).min(0).optional()
})).optional() }) });
e.object({ data: e.object({ shipments: e.array(e.object({
	id: e.int(),
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	reference_identifier: e.union([e.int(), e.string()]).optional(),
	carrier: W,
	status: e.int().optional(),
	delivered: e.union([e.literal(0), e.literal(1)]).optional(),
	recipient: e.object({
		cc: e.string(),
		region: e.string().optional(),
		state: e.string().optional(),
		postal_code: e.string().optional(),
		city: e.string(),
		street: e.string(),
		street_additional_info: e.string().optional(),
		number: e.string().nullish(),
		number_suffix: e.string().nullish(),
		box_number: e.string().optional(),
		person: e.string(),
		company: e.string().optional(),
		email: e.union([e.email(), e.string()]).optional(),
		secondary_emails: wp.optional(),
		phone: e.string().optional()
	}),
	sender: Tp.optional(),
	options: V.and(e.unknown()),
	customs_declaration: H.optional(),
	physical_properties: e.object({
		weight: e.int().gte(0).lte(999999999),
		height: e.int().optional(),
		width: e.int().optional(),
		length: e.int().optional(),
		volume: e.int().optional()
	}).optional(),
	pickup: Ep.optional(),
	note: e.string().optional(),
	general_settings: e.object({
		save_recipient_address: e.union([e.literal(0), e.literal(1)]).optional(),
		delivery_notification: e.union([e.literal(0), e.literal(1)]).optional(),
		delivery_notification_email: e.array(e.string()).optional(),
		disable_auto_detect_pickup: e.union([e.literal(0), e.literal(1)]).optional(),
		printer_identifier: e.string().optional()
	}).optional(),
	hidden: e.union([e.literal(0), e.literal(1)]).optional()
})).optional() }) });
var Np = e.object({ data: e.object({ shipments: e.array(e.object({
	id: e.int(),
	hidden: e.union([e.literal(0), e.literal(1)]).optional(),
	status: Hc.optional(),
	delivered: e.union([e.literal(0), e.literal(1)]).optional()
})) }) }), Pp = e.union([e.enum([
	"RETAIL",
	"LOCKER",
	"POST_OFFICE"
]), e.string()]).register(e.globalRegistry, { description: "Pickup / drop-off location type used for capability and rates filtering." }), Fp = e.object({
	shopId: e.int().register(e.globalRegistry, { description: "The ID of the shop for which the capabilities are requested." }).optional(),
	contractId: e.int().register(e.globalRegistry, { description: "The ID of the contract for which the capabilities are requested." }).optional(),
	recipient: e.object({
		countryCode: e.string().register(e.globalRegistry, { description: "Alpha-2 Country code of the recipient." }),
		postalCode: e.string().register(e.globalRegistry, { description: "Postal code of the recipient." }).optional(),
		isBusiness: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Recipient data." }),
	sender: e.object({
		countryCode: e.string().register(e.globalRegistry, { description: "Alpha-2 Country code of the sender." }).optional(),
		postalCode: e.string().register(e.globalRegistry, { description: "Postal code of the sender." }).optional(),
		isBusiness: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Sender data." }).optional(),
	carrier: Jd.optional(),
	packageType: Xd.optional(),
	physicalProperties: e.object({
		height: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The height value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The height of the package" }).optional(),
		width: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The width value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The width of the package" }).optional(),
		length: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The length value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The length of the package" }).optional(),
		weight: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The weight value" }),
			unit: e.union([e.enum(["g", "kg"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(e.globalRegistry, { description: "The weight of the package" }).optional()
	}).register(e.globalRegistry, { description: "Physical properties of the package." }).optional(),
	options: e.object({
		additionalInsurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Additional insurance option" }).optional(),
		deliverAtPostalPoint: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Deliver at postal point option" }).optional(),
		freshFood: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Fresh food delivery option" }).optional(),
		frozen: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Frozen delivery option" }).optional(),
		hideSender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Hide sender option" }).optional(),
		insurance: e.union([e.record(e.string(), e.never()), B]).optional(),
		noTracking: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Ship without track and trace option" }).optional(),
		oversizedPackage: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Oversized package option" }).optional(),
		printReturnLabelAtDropOff: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Print return label at drop off package option" }).optional(),
		priorityDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Priority delivery package option" }).optional(),
		recipientOnlyDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Recipient only delivery option" }).optional(),
		returnOnFirstFailedDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Return on first failed delivery option" }).optional(),
		requiresAgeVerification: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires age verification option" }).optional(),
		requiresCashOnDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Cash on delivery option" }).optional(),
		requiresReceiptCode: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires receipt code option" }).optional(),
		requiresSignature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires signature option" }).optional(),
		sameDayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Same day delivery option" }).optional(),
		saturdayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Saturday delivery option" }).optional(),
		scheduledCollection: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Scheduled collection option" }).optional()
	}).register(e.globalRegistry, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	deliveryType: e.union([e.enum([
		"EVENING_DELIVERY",
		"EXPRESS_DELIVERY",
		"EARLY_MORNING_DELIVERY",
		"MORNING_DELIVERY",
		"PICKUP_DELIVERY",
		"SAME_DAY_DELIVERY",
		"STANDARD_DELIVERY"
	]), e.string()]).optional(),
	direction: e.union([e.enum(["INBOUND", "OUTBOUND"]), e.string()]).register(e.globalRegistry, { description: "The shipment direction for which the capabilities are requested." }).optional(),
	pickup: e.object({ location: e.object({ type: Pp.optional() }).register(e.globalRegistry, { description: "Pickup location details." }).optional() }).register(e.globalRegistry, { description: "Pickup location criteria for filtering capabilities." }).optional()
});
e.object({ data: e.object({ capabilities: e.array(e.object({
	shop_id: e.int().register(e.globalRegistry, { description: "The ID of the shop for which the capabilities are requested." }).optional(),
	contract_id: e.int().register(e.globalRegistry, { description: "The ID of the contract for which the capabilities are requested." }).optional(),
	recipient: e.object({
		cc: e.string().register(e.globalRegistry, { description: "Alpha-2 Country code of the recipient." }),
		postal_code: e.string().register(e.globalRegistry, { description: "Postal code of the recipient." }).optional(),
		is_business: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Recipient data." }),
	sender: e.object({
		cc: e.string().register(e.globalRegistry, { description: "Alpha-2 Country code of the sender." }).optional(),
		postal_code: e.string().register(e.globalRegistry, { description: "Postal code of the sender." }).optional(),
		is_business: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Sender data." }).optional(),
	carrier_id: lf.optional(),
	package_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7)
	]).optional(),
	physical_properties: e.object({
		height: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The height value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The height of the package" }).optional(),
		width: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The width value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The width of the package" }).optional(),
		length: e.object({
			value: e.int().gte(0).lte(1e4).register(e.globalRegistry, { description: "The length value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The length of the package" }).optional(),
		weight: e.object({
			value: e.int().gte(0).register(e.globalRegistry, { description: "The weight value" }),
			unit: e.union([e.enum(["g", "kg"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(e.globalRegistry, { description: "The weight of the package" }).optional()
	}).register(e.globalRegistry, { description: "Physical properties of the package." }).optional(),
	options: e.object({
		age_check: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires age verification option" }).optional(),
		cash_on_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Cash on delivery option" }).optional(),
		collect: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Scheduled collection option" }).optional(),
		drop_off_at_postal_point: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Deliver at postal point option" }).optional(),
		extra_assurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Additional insurance option" }).optional(),
		fresh_food: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Fresh food delivery option" }).optional(),
		frozen: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Frozen delivery option" }).optional(),
		hide_sender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Hide sender option" }).optional(),
		large_format: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Oversized package option" }).optional(),
		no_tracking: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Ship without track and trace option" }).optional(),
		only_recipient: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Recipient only delivery option" }).optional(),
		priority_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Priority delivery option" }).optional(),
		printerless_return: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Printerless return delivery option" }).optional(),
		receipt_code: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires receipt code option" }).optional(),
		return: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Return on first failed delivery option" }).optional(),
		same_day_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Same day delivery option" }).optional(),
		saturday_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Saturday delivery option" }).optional(),
		signature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires signature option" }).optional(),
		tracked: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "DEPRECATED: replaced by no_tracking (its inverse)." }).optional(),
		insurance: e.union([e.record(e.string(), e.never()), B]).optional()
	}).register(e.globalRegistry, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	delivery_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7),
		e.literal(8)
	]).optional(),
	shipment_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7),
		e.literal(8)
	]).optional(),
	direction: e.union([e.enum(["INBOUND", "OUTBOUND"]), e.string()]).register(e.globalRegistry, { description: "The shipment direction for which the capabilities are requested." }).optional(),
	pickup: e.object({ location_type: Qc.optional() }).register(e.globalRegistry, { description: "Pickup location criteria for filtering capabilities." }).optional()
})) }) });
var Ip = e.object({ carrier: e.union([e.enum([
	"BRT",
	"DHL_EUROPLUS",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"DHL_FOR_YOU",
	"INPOST",
	"POSTNL"
]), e.string()]).optional() });
e.object({ data: e.object({ carrier_id: e.union([
	e.literal(1),
	e.literal(4),
	e.literal(9),
	e.literal(10),
	e.literal(11),
	e.literal(15),
	e.literal(17)
]).optional() }).optional() });
var Lp = e.object({
	city: e.string().register(e.globalRegistry, { description: "The city of the address." }).optional(),
	countryCode: e.string().register(e.globalRegistry, { description: "The country code (ISO 3166-1 alpha-2) of the address." }),
	street: e.string().register(e.globalRegistry, { description: "The street of the address." }).optional(),
	additionalInformation: e.string().register(e.globalRegistry, { description: "Additional information about the address." }).optional(),
	boxNumber: e.string().register(e.globalRegistry, { description: "The box number of the address. Only applicable for `countryCode`=`BE`." }).optional(),
	houseNumber: e.string().register(e.globalRegistry, { description: "The house number of the address." }).optional(),
	houseNumberSuffix: e.string().register(e.globalRegistry, { description: "The house number suffix of the address." }).optional(),
	postalCode: e.string().register(e.globalRegistry, { description: "The postal code of the address." }).optional(),
	region: e.string().register(e.globalRegistry, { description: "The region of the address." }).optional(),
	state: e.string().register(e.globalRegistry, { description: "The state of the address." }).optional()
}), Rp = e.object({
	name: e.string().register(e.globalRegistry, { description: "The name of the pickup location." }),
	code: e.string().register(e.globalRegistry, { description: "The location code of the pickup location." }).optional(),
	type: Pp.optional()
}), zp = e.object({
	address: Lp,
	location: Rp,
	retailNetworkId: e.union([e.enum(["PNPNL-01", "PNPBE-01"]), e.string()]).register(e.globalRegistry, { description: "PostNL Retail network ID." }).optional()
}).register(e.globalRegistry, { description: "Pickup location data." }), Bp = e.object({
	shopId: e.int().register(e.globalRegistry, { description: "The ID of the shop for which the rates are requested." }).optional(),
	contractId: e.int().register(e.globalRegistry, { description: "The ID of the contract for which the rates are requested." }).optional(),
	recipient: e.object({
		countryCode: e.string().register(e.globalRegistry, { description: "Alpha-2 Country code of the recipient." }),
		postalCode: e.string().register(e.globalRegistry, { description: "Postal code of the recipient." }).optional(),
		isBusiness: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Recipient data." }),
	sender: e.object({
		countryCode: e.string().register(e.globalRegistry, { description: "Alpha-2 Country code of the sender." }).optional(),
		postalCode: e.string().register(e.globalRegistry, { description: "Postal code of the sender." }).optional(),
		isBusiness: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Sender data." }).optional(),
	pickup: zp.optional(),
	carrier: Jd,
	packageType: Xd,
	physicalProperties: e.object({
		height: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The height value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The height of the package" }).optional(),
		width: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The width value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The width of the package" }).optional(),
		length: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The length value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The length of the package" }).optional(),
		weight: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The weight value" }),
			unit: e.union([e.enum(["g", "kg"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(e.globalRegistry, { description: "The weight of the package" }).optional()
	}).register(e.globalRegistry, { description: "Physical properties of the package." }).optional(),
	options: e.object({
		additionalInsurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Additional insurance option" }).optional(),
		deliverAtPostalPoint: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Deliver at postal point option" }).optional(),
		freshFood: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Fresh food option" }).optional(),
		frozen: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Frozen option" }).optional(),
		hideSender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Hide sender option" }).optional(),
		insurance: e.union([e.object({ insuredAmount: B }).register(e.globalRegistry, { description: "Deprecated. Use options.insurance.{amount, currency} directly. Will be removed in a future release." }), B]).optional(),
		noTracking: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Ship without track and trace option" }).optional(),
		oversizedPackage: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Oversized package option" }).optional(),
		priorityDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Priority delivery package option" }).optional(),
		recipientOnlyDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Recipient only delivery option" }).optional(),
		returnOnFirstFailedDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Return on first failed delivery option" }).optional(),
		requiresAgeVerification: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires age verification option" }).optional(),
		requiresCashOnDelivery: e.object({ dueAmount: B }).register(e.globalRegistry, { description: "Cash on delivery option" }).optional(),
		requiresReceiptCode: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires receipt code option" }).optional(),
		requiresSignature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires signature option" }).optional(),
		sameDayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Same day delivery option" }).optional(),
		saturdayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Saturday delivery option" }).optional(),
		scheduledCollection: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Scheduled collection option" }).optional()
	}).register(e.globalRegistry, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	deliveryType: e.union([e.enum([
		"EARLY_MORNING_DELIVERY",
		"EVENING_DELIVERY",
		"EXPRESS_DELIVERY",
		"MORNING_DELIVERY",
		"PICKUP_DELIVERY",
		"SAME_DAY_DELIVERY",
		"STANDARD_DELIVERY"
	]), e.string()]).optional(),
	direction: e.union([e.enum(["INBOUND", "OUTBOUND"]), e.string()]).register(e.globalRegistry, { description: "The shipment direction for which the rates are requested." }).optional(),
	collo: e.int().gte(1).register(e.globalRegistry, { description: "The number of collo for which the rates are requested." }).optional()
});
e.object({ data: e.object({ rates: e.array(e.object({
	shop_id: e.int().register(e.globalRegistry, { description: "The ID of the shop for which the rates are requested." }).optional(),
	contract_id: e.int().register(e.globalRegistry, { description: "The ID of the contract for which the rates are requested." }).optional(),
	recipient: e.object({
		cc: e.string().register(e.globalRegistry, { description: "Alpha-2 Country code of the recipient." }),
		postal_code: e.string().register(e.globalRegistry, { description: "Postal code of the recipient." }).optional(),
		is_business: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Recipient data." }),
	sender: e.object({
		cc: e.string().register(e.globalRegistry, { description: "Alpha-2 Country code of the sender." }).optional(),
		postal_code: e.string().register(e.globalRegistry, { description: "Postal code of the sender." }).optional(),
		is_business: e.boolean().register(e.globalRegistry, { description: "Whether this is a business address." }).optional()
	}).register(e.globalRegistry, { description: "Sender data." }).optional(),
	pickup: el.optional(),
	carrier_id: lf,
	package_type: Kc,
	physical_properties: e.object({
		height: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The height value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The height of the package" }).optional(),
		width: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The width value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The width of the package" }).optional(),
		length: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The length value" }),
			unit: e.union([e.enum(["cm", "mm"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., mm, cm)" })
		}).register(e.globalRegistry, { description: "The length of the package" }).optional(),
		weight: e.object({
			value: e.number().gte(0).register(e.globalRegistry, { description: "The weight value" }),
			unit: e.union([e.enum(["g", "kg"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement in SI units (e.g., g, kg)" })
		}).register(e.globalRegistry, { description: "The weight of the package" }).optional()
	}).register(e.globalRegistry, { description: "Physical properties of the package." }).optional(),
	options: e.object({
		age_check: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires age verification option" }).optional(),
		cash_on_delivery: e.object({ due_amount: B }).register(e.globalRegistry, { description: "Cash on delivery option" }).optional(),
		collect: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Scheduled collection option" }).optional(),
		cooled_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Cooled delivery option" }).optional(),
		drop_off_at_postal_point: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Deliver at postal point option" }).optional(),
		extra_assurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Additional insurance option" }).optional(),
		hide_sender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Hide sender option" }).optional(),
		large_format: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Oversized package option" }).optional(),
		no_tracking: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Ship without track and trace option" }).optional(),
		only_recipient: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Recipient only delivery option" }).optional(),
		priority_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Priority delivery option" }).optional(),
		receipt_code: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires receipt code option" }).optional(),
		return: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Return on first failed delivery option" }).optional(),
		same_day_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Same day delivery option" }).optional(),
		saturday_delivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Saturday delivery option" }).optional(),
		signature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires signature option" }).optional(),
		tracked: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "DEPRECATED: replaced by no_tracking (its inverse)." }).optional(),
		insurance: e.union([e.object({ insured_amount: B }).register(e.globalRegistry, { description: "Deprecated. Use options.insurance.{amount, currency} directly. Will be removed in a future release." }), B]).optional()
	}).register(e.globalRegistry, { description: "Shipment options object. Empty objects indicate the option is requested/enabled." }).optional(),
	delivery_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7),
		e.literal(8)
	]).optional(),
	shipment_type: e.union([
		e.literal(1),
		e.literal(2),
		e.literal(3),
		e.literal(4),
		e.literal(5),
		e.literal(6),
		e.literal(7),
		e.literal(8)
	]).optional(),
	direction: e.union([e.enum(["INBOUND", "OUTBOUND"]), e.string()]).register(e.globalRegistry, { description: "The shipment direction for which the rates are requested." }).optional(),
	collo: e.int().gte(1).register(e.globalRegistry, { description: "The number of collo for which the rates are requested." }).optional()
})) }) });
var Vp = e.union([e.object({
	shopId: e.int(),
	packageType: e.union([e.enum([
		"DIGITAL_STAMP",
		"ENVELOPE",
		"UNFRANKED",
		"MAILBOX",
		"PACKAGE",
		"PALLET",
		"SMALL_PACKAGE"
	]), e.string()]),
	countryCode: e.string().register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 country code" }),
	shipmentDirection: e.union([e.enum(["OUTBOUND"]), e.string()])
}), e.object({
	shopId: e.int(),
	packageType: e.null().optional(),
	countryCode: e.string().register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 country code" }).optional(),
	shipmentDirection: e.union([e.enum(["INBOUND"]), e.string()])
})]), Hp = e.object({
	body: e.string(),
	subject: e.string()
}), Up = e.object({
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	hook: e.string(),
	url: e.string(),
	payload: e.string().nullish()
}), Wp = e.object({ data: e.object({ webhook_subscriptions: e.array(Up).optional() }) }), Gp = e.object({
	account_id: e.int().optional(),
	shop_id: e.int().optional(),
	hook: e.string(),
	url: e.string()
});
e.object({ data: e.object({ webhook_subscriptions: e.array(Gp).optional() }) }), e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }), e.string().nullable(), e.string().nullable(), e.iso.date().register(e.globalRegistry, { description: "When set, only resources created after this date will be returned. Inclusive." }), $.nullable(), e.int().gte(-1).lte(14).nullable(), e.int().gte(0).nullable(), e.int().gte(0).lte(14).nullable(), e.boolean().register(e.globalRegistry, { description: "Use this parameter to only show Shipments that need to be dropped off today." }), $.nullable(), e.string().nullable(), e.boolean(), e.union([rp, e.string()]), e.boolean(), e.int().nullable(), e.boolean(), e.string().nullable(), $.nullable(), e.string().nullable(), e.union([op, e.string()]), e.string().nullable(), e.string().nullable(), e.string().register(e.globalRegistry, { description: "Filter by `reference_identifier`, an optional arbitrary identifier to identify the Shipment." }), e.string().register(e.globalRegistry, { description: "The region, department, state or province of the address." }), e.union([e.enum(["asc", "desc"]), e.string()]).register(e.globalRegistry, { description: "Sort order. Defaults to `desc`." }), e.string().nullable(), e.int().register(e.globalRegistry, { description: "The ID of the notification group." }), e.string().register(e.globalRegistry, { description: "One or more notification group IDs. Separate multiple IDs using `;`." }), e.int().register(e.globalRegistry, { description: "The ID of the notification template." }), e.string().register(e.globalRegistry, { description: "Filter by webhook event type." });
var Kp = Dp, qp = Mp, Jp = Np, Yp = Fp, Xp = Ip, Zp = Bp, Qp = Vp, $p = Hp, em = Wp;
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var tm = e.object({
	title: e.string().optional(),
	status: e.string()
}).register(e.globalRegistry, { description: "Status is OK" });
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		cc: e.string().nullish(),
		postal_code: mp.optional(),
		number: e.string().nullish(),
		city: e.string().nullish(),
		street: e.string().nullish(),
		platform: dp.optional(),
		shop_id: yp.optional(),
		carrier: Kf.optional(),
		delivery_date: Zf.optional(),
		delivery_time: Qf.optional(),
		cutoff_time: Yf.optional(),
		dropoff_days: ep.optional(),
		monday_delivery: $.nullish(),
		dropoff_delay: e.int().gte(0).lte(14).nullish(),
		deliverydays_window: e.int().gte(-1).lte(14).nullish(),
		exclude_delivery_type: np.optional(),
		exclude_parcel_lockers: $.nullish(),
		latitude: ip.optional(),
		longitude: ap.optional()
	}).optional()
});
var nm = Qu;
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		postal_code: mp.optional(),
		number: e.string().nullish(),
		distance: e.int().gte(0).nullish(),
		cc: e.string().nullish(),
		limit: e.int().nullish(),
		carrier_id: Wf.optional(),
		shop_id: yp.optional(),
		reference: e.string().nullish(),
		location_name: e.string().nullish(),
		external_identifier: e.string().nullish(),
		city: e.string().nullish(),
		cut_off_time: Yf.optional(),
		min_cut_off_time: Yf.optional(),
		max_cut_off_time: Yf.optional(),
		latitude: ip.optional(),
		longitude: ap.optional(),
		exclude_parcel_lockers: $.nullish()
	}).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var rm = wd;
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		cc: e.string().nullish(),
		postal_code: mp.optional(),
		number: e.string().nullish(),
		city: e.string().nullish(),
		street: e.string().nullish(),
		platform: dp.optional(),
		shop_id: yp.optional(),
		carrier: Kf.optional(),
		delivery_date: Zf.optional(),
		delivery_time: Qf.optional(),
		cutoff_time: Yf.optional(),
		dropoff_days: ep.optional(),
		monday_delivery: $.nullish(),
		dropoff_delay: e.int().gte(0).lte(14).nullish(),
		deliverydays_window: e.int().gte(-1).lte(14).nullish(),
		exclude_delivery_type: np.optional(),
		exclude_parcel_lockers: $.nullish(),
		latitude: ip.optional(),
		longitude: ap.optional()
	}).optional()
});
var im = Nd;
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var am = hd;
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		barcode: Uf.optional(),
		carrier_id: Wf.optional(),
		created: e.iso.date().register(e.globalRegistry, { description: "When set, only resources created after this date will be returned. Inclusive." }).optional(),
		delayed: $.nullish(),
		delivered: Xf.optional(),
		dropoff_today: e.boolean().register(e.globalRegistry, { description: "Use this parameter to only show Shipments that need to be dropped off today." }).optional(),
		filter_hidden_shops: e.boolean().optional(),
		hidden: Xf.optional(),
		link_consumer_portal: e.boolean().optional(),
		order: e.union([op, e.string()]).optional(),
		package_type: sp.optional(),
		page: cp.optional(),
		q: e.string().nullish(),
		reference_identifier: e.string().register(e.globalRegistry, { description: "Filter by `reference_identifier`, an optional arbitrary identifier to identify the Shipment." }).optional(),
		region: e.string().register(e.globalRegistry, { description: "The region, department, state or province of the address." }).optional(),
		shipment_type: _p.optional(),
		shop_id: yp.optional(),
		size: bp.optional(),
		sort: xp.optional(),
		status: Sp.optional(),
		transaction_status: hl.optional()
	}).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var om = Ld;
e.object({
	body: Jp,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var sm = e.void().register(e.globalRegistry, { description: "Shipment patch was successful." });
e.object({
	body: Kp,
	path: e.never().optional(),
	query: e.object({
		format: e.union([rp, e.string()]).optional(),
		positions: pp.optional(),
		collect_date: qf.optional(),
		delivery_options_identifier: $f.optional()
	}).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var cm = Pd;
e.object({
	body: qp,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var lm = e.union([zu, e.void().register(e.globalRegistry, { description: "Shipment update was successful." })]);
e.object({
	body: e.never().optional(),
	path: e.object({ ids: gp }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var um = e.void().register(e.globalRegistry, { description: "Shipment deletion was successful." });
e.object({
	body: e.never().optional(),
	path: e.object({ ids: gp }),
	query: e.object({ link_consumer_portal: e.boolean().optional() }).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var dm = Ld;
e.object({
	body: Yp,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var fm = cf;
e.object({
	body: Xp,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var pm = bf;
e.object({
	body: Zp,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var mm = e.union([Of, e.void().register(e.globalRegistry, { description: "This response is given when the request is successful and the response is empty." })]);
e.object({
	body: e.never().optional(),
	path: e.object({ ids: gp }),
	query: e.object({
		format: e.union([rp, e.string()]).optional(),
		positions: pp.optional(),
		collect_date: qf.optional(),
		delivery_options_identifier: $f.optional()
	}).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var hm = e.union([e.void().register(e.globalRegistry, { description: "Direct Printing Response" }), Vu]);
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		barcode: Uf.optional(),
		country_code: Jf.optional(),
		external_identifier: Uf.optional(),
		extra_info: Cp.optional(),
		postal_code: mp.optional(),
		sort: e.union([e.enum(["asc", "desc"]), e.string()]).register(e.globalRegistry, { description: "Sort order. Defaults to `desc`." }).optional()
	}).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var gm = qd;
e.object({
	body: e.never().optional(),
	path: e.object({ ids: gp }),
	query: e.object({
		sort: e.union([e.enum(["asc", "desc"]), e.string()]).register(e.globalRegistry, { description: "Sort order. Defaults to `desc`." }).optional(),
		extra_info: Cp.optional()
	}).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var _m = qd;
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({ shopId: yp.optional() }).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var vm = Ff;
e.object({
	body: Qp,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var ym = Ff;
e.object({
	body: e.never().optional(),
	path: e.object({ ids: e.string().register(e.globalRegistry, { description: "One or more notification group IDs. Separate multiple IDs using `;`." }) }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var bm = e.void().register(e.globalRegistry, { description: "Notification group deletion was successful." });
e.object({
	body: e.never().optional(),
	path: e.object({ notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }) }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var xm = Rf;
e.object({
	body: $p,
	path: e.object({
		notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }),
		notification_template_id: e.int().register(e.globalRegistry, { description: "The ID of the notification template." })
	}),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var Sm = e.void().register(e.globalRegistry, { description: "Notification template update was successful." });
e.object({
	body: e.never().optional(),
	path: e.object({ notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }) }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var Cm = e.void().register(e.globalRegistry, { description: "Disabling notification templates was successful." });
e.object({
	body: e.never().optional(),
	path: e.object({ notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }) }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var wm = e.void().register(e.globalRegistry, { description: "Enabling notification templates was successful." });
e.object({
	body: e.never().optional(),
	path: e.object({
		notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }),
		notification_template_id: e.int().register(e.globalRegistry, { description: "The ID of the notification template." })
	}),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var Tm = e.void().register(e.globalRegistry, { description: "Disabling notification template was successful." });
e.object({
	body: e.never().optional(),
	path: e.object({
		notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }),
		notification_template_id: e.int().register(e.globalRegistry, { description: "The ID of the notification template." })
	}),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var Em = e.void().register(e.globalRegistry, { description: "Enabling notification template was successful." });
e.object({
	body: e.never().optional(),
	path: e.object({
		notification_group_id: e.int().register(e.globalRegistry, { description: "The ID of the notification group." }),
		notification_template_id: e.int().register(e.globalRegistry, { description: "The ID of the notification template." })
	}),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var Dm = e.void().register(e.globalRegistry, { description: "Test notification was successfully send." });
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({ hook: e.string().register(e.globalRegistry, { description: "Filter by webhook event type." }).optional() }).optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var Om = Bf;
e.object({
	body: em,
	path: e.never().optional(),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var km = Hf;
e.object({
	body: e.never().optional(),
	path: e.object({ ids: gp }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var Am = e.void().register(e.globalRegistry, { description: "Webhook subscription deletion was successful." });
e.object({
	body: e.never().optional(),
	path: e.object({ ids: gp }),
	query: e.never().optional(),
	headers: e.object({ "User-Agent": e.string().register(e.globalRegistry, { description: "To give us insight into where requests come from and API documentation usage, you should send a `User-Agent` header with all your requests. This header should include information about your integration, the CMS/platform and the backend you are using." }).optional() }).optional()
});
var jm = Bf, Mm = (e) => (e?.client ?? p).get({
	requestValidator: async (e) => await bs.parseAsync(e),
	responseValidator: async (e) => await tm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/",
	...e
}), Nm = (e) => (e?.client ?? p).get({
	requestValidator: async (e) => await Ss.parseAsync(e),
	responseValidator: async (e) => await nm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/delivery_options",
	...e
}), Pm = (e) => (e?.client ?? p).get({
	requestValidator: async (e) => await ws.parseAsync(e),
	responseValidator: async (e) => await rm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/drop_off_points",
	...e
}), Fm = (e) => (e?.client ?? p).get({
	requestValidator: async (e) => await Es.parseAsync(e),
	responseValidator: async (e) => await im.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/pickup_locations",
	...e
}), Im = (e) => (e?.client ?? p).post({
	requestValidator: async (e) => await Os.parseAsync(e),
	responseValidator: async (e) => await am.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/return_shipments",
	...e
}), Lm = (e) => (e?.client ?? p).get({
	requestValidator: async (e) => await As.parseAsync(e),
	responseValidator: async (e) => await om.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipments",
	...e
}), Rm = (e) => (e.client ?? p).patch({
	requestValidator: async (e) => await Ms.parseAsync(e),
	responseValidator: async (e) => await sm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipments",
	...e,
	headers: {
		"Content-Type": "application/vnd.shipment+json",
		...e.headers
	}
}), zm = (e) => (e.client ?? p).post({
	requestValidator: async (e) => await Ps.parseAsync(e),
	responseValidator: async (e) => await cm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipments",
	...e,
	headers: {
		"Content-Type": "application/vnd.shipment+json;version=1.1",
		...e.headers
	}
}), Bm = (e) => (e.client ?? p).put({
	requestValidator: async (e) => await Is.parseAsync(e),
	responseValidator: async (e) => await lm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipments",
	...e,
	headers: {
		"Content-Type": "application/vnd.shipment+json;version=1.1",
		...e.headers
	}
}), Vm = (e) => (e.client ?? p).delete({
	requestValidator: async (e) => await Rs.parseAsync(e),
	responseValidator: async (e) => await um.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipments/{ids}",
	...e
}), Hm = (e) => (e.client ?? p).get({
	requestValidator: async (e) => await Bs.parseAsync(e),
	responseValidator: async (e) => await dm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipments/{ids}",
	...e
}), Um = (e) => (e.client ?? p).post({
	requestValidator: async (e) => await Hs.parseAsync(e),
	responseValidator: async (e) => await fm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipments/capabilities",
	...e,
	headers: {
		"Content-Type": "application/json;version=2.0",
		...e.headers
	}
}), Wm = (e) => (e.client ?? p).post({
	requestValidator: async (e) => await Ws.parseAsync(e),
	responseValidator: async (e) => await pm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipments/capabilities/contract-definitions",
	...e,
	headers: {
		"Content-Type": "application/json;version=2.0",
		...e.headers
	}
}), Gm = (e) => (e.client ?? p).post({
	requestValidator: async (e) => await Ks.parseAsync(e),
	responseValidator: async (e) => await mm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipments/rates",
	...e,
	headers: {
		"Content-Type": "application/json;version=2.0",
		...e.headers
	}
}), Km = (e) => (e.client ?? p).get({
	requestValidator: async (e) => await Js.parseAsync(e),
	responseValidator: async (e) => await hm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/shipment_labels/{ids}",
	...e
}), qm = (e) => (e?.client ?? p).get({
	requestValidator: async (e) => await Xs.parseAsync(e),
	responseValidator: async (e) => await gm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/tracktraces",
	...e
}), Jm = (e) => (e.client ?? p).get({
	requestValidator: async (e) => await Qs.parseAsync(e),
	responseValidator: async (e) => await _m.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/tracktraces/{ids}",
	...e
}), Ym = (e) => (e?.client ?? p).get({
	requestValidator: async (e) => await ec.parseAsync(e),
	responseValidator: async (e) => await vm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups",
	...e
}), Xm = (e) => (e.client ?? p).post({
	requestValidator: async (e) => await nc.parseAsync(e),
	responseValidator: async (e) => await ym.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Zm = (e) => (e.client ?? p).delete({
	requestValidator: async (e) => await ic.parseAsync(e),
	responseValidator: async (e) => await bm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups/{ids}",
	...e
}), Qm = (e) => (e.client ?? p).get({
	requestValidator: async (e) => await oc.parseAsync(e),
	responseValidator: async (e) => await xm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups/{notification_group_id}/notification_templates",
	...e
}), $m = (e) => (e.client ?? p).put({
	requestValidator: async (e) => await cc.parseAsync(e),
	responseValidator: async (e) => await Sm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups/{notification_group_id}/notification_templates/{notification_template_id}",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), eh = (e) => (e.client ?? p).put({
	requestValidator: async (e) => await uc.parseAsync(e),
	responseValidator: async (e) => await Cm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups/{notification_group_id}/notification_templates/disable",
	...e
}), th = (e) => (e.client ?? p).put({
	requestValidator: async (e) => await fc.parseAsync(e),
	responseValidator: async (e) => await wm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups/{notification_group_id}/notification_templates/enable",
	...e
}), nh = (e) => (e.client ?? p).put({
	requestValidator: async (e) => await mc.parseAsync(e),
	responseValidator: async (e) => await Tm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups/{notification_group_id}/notification_templates/{notification_template_id}/disable",
	...e
}), rh = (e) => (e.client ?? p).put({
	requestValidator: async (e) => await gc.parseAsync(e),
	responseValidator: async (e) => await Em.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups/{notification_group_id}/notification_templates/{notification_template_id}/enable",
	...e
}), ih = (e) => (e.client ?? p).post({
	requestValidator: async (e) => await vc.parseAsync(e),
	responseValidator: async (e) => await Dm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/notification_groups/{notification_group_id}/notification_templates/{notification_template_id}/test",
	...e
}), ah = (e) => (e?.client ?? p).get({
	requestValidator: async (e) => await bc.parseAsync(e),
	responseValidator: async (e) => await Om.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/webhook_subscriptions",
	...e
}), oh = (e) => (e.client ?? p).post({
	requestValidator: async (e) => await Sc.parseAsync(e),
	responseValidator: async (e) => await km.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/webhook_subscriptions",
	...e,
	headers: {
		"Content-Type": "application/json;version=1.1",
		...e.headers
	}
}), sh = (e) => (e.client ?? p).delete({
	requestValidator: async (e) => await wc.parseAsync(e),
	responseValidator: async (e) => await Am.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/webhook_subscriptions/{ids}",
	...e
}), ch = (e) => (e.client ?? p).get({
	requestValidator: async (e) => await Ec.parseAsync(e),
	responseValidator: async (e) => await jm.parseAsync(e),
	security: [{
		scheme: "bearer",
		type: "http"
	}, {
		name: "Authorization",
		type: "apiKey"
	}],
	url: "/webhook_subscriptions/{ids}",
	...e
}), lh = "https://api.myparcel.nl", uh = "https://api.acceptance.myparcel.nl", dh = (e) => e.baseUrl ? e.baseUrl : e.environment === "acceptance" ? uh : lh;
//#endregion
export { ua as $, Ce as $a, Xo as $c, A as $i, bs as $n, kt as $o, hs as $r, Gi as $s, aa as $t, Im as A, Me as Aa, On as Ac, gi as Ai, uc as An, tr as Ao, Po as Ar, Ot as As, yn as At, Ut as B, Ke as Ba, Tr as Bc, li as Bi, gc as Bn, ut as Bo, Ro as Br, Lt as Bs, or as Bt, ch as C, Ra as Ca, Yn as Cc, Ls as Ci, wc as Cn, Ve as Co, Oo as Cr, ft as Cs, $n as Ct, Xm as D, Ae as Da, Vn as Dc, Ka as Di, go as Dn, Hn as Do, Mo as Dr, xt as Ds, zn as Dt, Wm as E, Fe as Ea, Jn as Ec, qa as Ei, mo as En, Bn as Eo, jo as Er, Ct as Es, qn as Et, xe as F, Da as Fa, T as Fc, yi as Fi, yo as Fn, Lr as Fo, Ya as Fr, ht as Fs, he as Ft, Rt as G, Ga, Or as Gc, Zr as Gi, wo as Gn, Ye as Go, zo as Gr, h as Gs, I as Gt, Vt as H, Ue as Ha, Er as Hc, j as Hi, ir as Hn, on as Ho, dn as Hr, De as Hs, nr as Ht, qt as I, Oa as Ia, _r as Ic, hi as Ii, bo as In, pr as Io, Pi as Ir, hn as Is, me as It, ca as J, Sa as Ja, Ar as Jc, k as Ji, Eo as Jn, Je as Jo, Ms as Jr, Ir as Js, Yi as Jt, zt as K, xa as Ka, Dn as Kc, di as Ki, is as Kn, Ze as Ko, Bo as Kr, Ur as Ks, F as Kt, Te as L, ka as La, Fn as Lc, fi as Li, xo as Ln, En as Lo, Li as Lr, mt as Ls, In as Lt, $m as M, Ne as Ma, fr as Mc, mi as Mi, mc as Mn, at as Mo, os as Mr, wt as Ms, Mr as Mt, Bm as N, Ea as Na, hr as Nc, N as Ni, hc as Nn, ot as No, ss as Nr, At as Ns, _e as Nt, Gm as O, je as Oa, ar as Oc, Mi as Oi, ho as On, Qn as Oo, No as Or, cn as Os, _n as Ot, ih as P, v as Pa, mr as Pc, M as Pi, vo as Pn, Fr as Po, Ja as Pr, _t as Ps, ge as Pt, la as Q, tt as Qa, Yo as Qc, Kr as Qi, Ts as Qn, en as Qo, ms as Qr, Ki as Qs, ia as Qt, Kt as R, qr as Ra, Dr as Rc, ri as Ri, fc as Rn, Xt as Ro, cs as Rr, vt as Rs, br as Rt, ah as S, Re as Sa, Mn as Sc, Is as Si, zs as Sn, zr as So, ls as Sr, It as Ss, dr as St, Um as T, Pe as Ta, Un as Tc, Wo as Ti, po as Tn, Br as To, Ao as Tr, Nt as Ts, Nn as Tt, Ht as U, Ge as Ua, Cr as Uc, O as Ui, So as Un, st as Uo, pn as Ur, Ee as Us, rr as Ut, Bt as V, qe as Va, wr as Vc, Xr as Vi, _c as Vn, dt as Vo, fn as Vr, Oe as Vs, vr as Vt, Gt as W, Ca as Wa, E as Wc, ui as Wi, Co as Wn, $e as Wo, un as Wr, mn as Ws, ma as Wt, Se as X, ja as Xa, Pr as Xc, Gr as Xi, Cs as Xn, Be as Xo, Vo as Xr, Ui as Xs, L as Xt, lt as Y, y as Ya, jr as Yc, ai as Yi, Ss as Yn, Xe as Yo, Ns as Yr, Jo as Ys, ga as Yt, xn as Z, Ci as Za, Wr as Zc, oi as Zi, ws as Zn, pt as Zo, Ho as Zr, Wi as Zs, ra as Zt, Lm as _, ze as _a, Ta as _c, Cc as _i, p as _l, uo as _n, Ko as _o, Ec as _r, bn as _s, Kn as _t, Vm as a, Fi as aa, ea as ac, nc as ai, ns as al, lr as an, g as ao, Es as ar, nn as as, za as at, qm as b, Le as ba, Ia as bc, lc as bi, ac as bn, yc as bo, xc as br, yt as bs, ur as bt, nh as c, Di as ca, oa as cc, Ks as ci, eo as cl, ve as cn, it as co, Vs as cr, $t as cs, pi as ct, Nm as d, Ti as da, ha as dc, Ps as di, Za as dl, sr as dn, Oi as do, Ys as dr, jt as ds, _i as dt, D as ea, qi as ec, Ws as ei, Zo as el, sa as en, S as eo, xs as er, Pt as es, to as et, Pm as f, ki as fa, va as fc, Fs as fi, Hi as fl, be as fn, ti as fo, js as fr, Mt as fs, no as ft, Fm as g, Ua as ga, Na as gc, Sc as gi, Ri as gl, lo as gn, Go as go, Zs as gr, an as gs, oo as gt, Qm as h, Ei as ha, La as hc, ys as hi, Bi as hl, co as hn, Xa as ho, Xs as hr, m as hs, ao as ht, Zm as i, Yr as ia, Zi as ic, _s as ii, ts as il, kn as in, ei as io, sc as ir, Cn as is, Ba as it, oh as j, Aa as ja, gr as jc, vi as ji, dc as jn, Zn as jo, Io as jr, gt as js, wn as jt, zm as k, Ie as ka, Gn as kc, bi as ki, _o as kn, w as ko, Fo as kr, Ft as ks, Sn as kt, th as l, Si as la, na as lc, qs as li, us as ll, Ln as ln, rt as lo, As as lr, Et as ls, ii as lt, Ym as m, ji as ma, ba as mc, ks as mi, zi as ml, so as mn, Qa as mo, $s as mr, Dt as ms, io as mt, lh as n, Jr as na, Xi as nc, Hs as ni, $o as nl, $i as nn, we as no, tc as nr, rn as ns, Pn as nt, sh as o, Ni as oa, ta as oc, rc as oi, rs as ol, Rn as on, _ as oo, Ds as or, St as os, Ha as ot, Mm as p, wi as pa, ya as pc, Os as pi, Vi as pl, xr as pn, Qr as po, Qs as pr, bt as ps, ro as pt, ct as q, et as qa, kr as qc, $r as qi, To as qn, Qe as qo, ps as qr, Hr as qs, Ji as qt, dh as r, ci as ra, Qi as rc, Us as ri, es as rl, An as rn, Xn as ro, oc as rr, vn as rs, jn as rt, eh as s, Ii as sa, fa as sc, gs as si, as as sl, Nr as sn, x as so, Bs as sr, Qt as ss, Va as st, uh as t, si as ta, P as tc, Gs as ti, Qo as tl, _a as tn, Ma as to, ec as tr, Jt as ts, tn as tt, rh as u, Ai as ua, pa as uc, ds as ui, $a as ul, yr as un, ke as uo, Js as ur, Zt as us, xi as ut, Hm as v, b as va, wa as vc, Uo as vi, f as vl, fo as vn, qo as vo, Dc as vr, Tn as vs, gn as vt, Rm as w, Wa as wa, Wn as wc, fs as wi, Tc as wn, Vr as wo, ko as wr, sn as ws, er as wt, Jm as x, da as xa, Fa as xc, vs as xi, Rs as xn, Rr as xo, Do as xr, ln as xs, cr as xt, Km as y, He as ya, Pa as yc, cc as yi, ic as yn, vc as yo, bc as yr, Yt as ys, C as yt, Wt as z, We as za, Sr as zc, ni as zi, pc as zn, nt as zo, Lo as zr, Tt as zs, ye as zt };
